/*
 * @license
 * Palo Alto Theme (c)
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */
! function(t, e, i, s, o) {
    "use strict";

    function n(t, e) {
        let i;
        return function() {
            if (t) {
                const s = () => t.apply(this, arguments);
                clearTimeout(i), i = setTimeout(s, e)
            }
        }
    }
    window.theme = window.theme || {}, window.theme.sizes = {
        mobile: 480,
        small: 768,
        large: 1024,
        widescreen: 1440
    }, window.theme.keyboardKeys = {
        TAB: "Tab",
        ENTER: "Enter",
        NUMPADENTER: "NumpadEnter",
        ESCAPE: "Escape",
        SPACE: "Space",
        LEFTARROW: "ArrowLeft",
        RIGHTARROW: "ArrowRight"
    }, window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const r = "body",
        a = "[data-main]",
        l = "[data-site-header]",
        c = "[data-prevent-transparent-header]",
        h = "supports-transparent-header",
        d = "site-header--transparent",
        u = "is-first-section-transparent",
        p = "data-transparent",
        m = () => {
            const t = document.querySelector(r),
                e = t.querySelector(l);
            if (!e) return;
            const i = "true" === e.getAttribute(p),
                s = t.querySelector(a).children[0];
            if (!s) return;
            const o = s.querySelector(`${c}:first-of-type`);
            window.isHeaderTransparent = i && s.classList.contains(h) && !o;
            CSS.supports("(selector(:has(*)))") || (t.classList.toggle(u, window.isHeaderTransparent), e.classList.toggle(d, window.isHeaderTransparent))
        };
    let g = L();
    const v = {
            body: "body",
            main: "[data-main]",
            collectionFilters: "[data-collection-filters]",
            footer: '[data-section-type*="footer"]',
            header: "[data-header-height]",
            stickyHeader: '[data-site-header][data-position="fixed"]',
            announcementBar: "[data-announcement-bar]",
            collectionStickyBar: "[data-collection-sticky-bar]",
            logoTextLink: "[data-logo-text-link]"
        },
        y = {
            templateCollection: "template-collection",
            templateSearch: "template-search",
            supportsTransparentHeader: "supports-transparent-header"
        };

    function f() {
        document.addEventListener("theme:resize", w), b(), document.dispatchEvent(new CustomEvent("theme:vars"), {
            bubbles: !1
        })
    }

    function b() {
        E()
    }

    function w() {
        E(!0)
    }

    function E(t = !1) {
        const e = document.querySelector(v.body),
            i = document.querySelector(v.collectionFilters),
            s = null !== document.querySelector(v.logoTextLink);
        let {
            windowHeight: o,
            headerHeight: n,
            headerInitialHeight: r,
            announcementBarHeight: a,
            footerHeight: l,
            collectionStickyBarHeight: c
        } = function() {
            var t, e;
            const i = {};
            return i.windowHeight = Math.min(window.screen.height, window.innerHeight), i.footerHeight = S(v.footer), i.headerHeight = S(v.header), i.headerInitialHeight = parseInt((null === (t = document.querySelector(v.header)) || void 0 === t ? void 0 : t.dataset.height) || (null === (e = document.querySelector(v.header)) || void 0 === e ? void 0 : e.offsetHeight)) || 0, i.announcementBarHeight = S(v.announcementBar), i.collectionStickyBarHeight = S(v.collectionStickyBar), i
        }();
        s && (n = function() {
            document.documentElement.style.setProperty("--header-height", "auto"), document.documentElement.style.setProperty("--header-sticky-height", "auto");
            const t = document.querySelector(v.header).offsetHeight;
            return requestAnimationFrame((() => {
                document.documentElement.style.setProperty("--header-height", `${t}px`), document.documentElement.style.setProperty("--header-sticky-height", `${t}px`)
            })), t
        }());
        const h = window.isHeaderTransparent && document.querySelector(v.main).firstElementChild.classList.contains(y.supportsTransparentHeader) ? o - a : o - r - a;
        let d = document.querySelector(v.stickyHeader) ? o - window.stickyHeaderHeight : o;
        const u = e.classList.contains(y.templateCollection),
            p = e.classList.contains(y.templateSearch),
            m = u && i || p && i;
        if (document.documentElement.style.setProperty("--footer-height", `${l}px`), document.documentElement.style.setProperty("--content-full", `${h}px`), document.documentElement.style.setProperty("--content-min", o - n - l + "px"), document.documentElement.style.setProperty("--collection-sticky-bar-height", `${c}px`), m && (d = o), !t) return void document.documentElement.style.setProperty("--full-height", `${d}px`);
        const f = L();
        f !== g && (document.documentElement.style.setProperty("--full-height", `${d}px`), g = f)
    }

    function S(t) {
        const e = document.querySelector(t);
        return e ? e.clientHeight : 0
    }

    function L() {
        return window.matchMedia("(orientation: portrait)").matches ? "portrait" : window.matchMedia("(orientation: landscape)").matches ? "landscape" : void 0
    }
    let k = !1,
        A = !1;

    function q() {
        setTimeout((() => {
            if (k) return;
            if (!A) return void q();
            const t = document.querySelectorAll('img[loading="lazy"]');
            t.length && t.forEach((t => {
                t.setAttribute("loading", "eager")
            })), k = !0
        }), 3e3)
    }
    const C = {
        overflowBackground: "[data-overflow-background]",
        overflowFrame: "[data-overflow-frame]",
        overflowContent: "[data-overflow-content]",
        overflowContainer: "[data-overflow-container]",
        overflowWrapper: "[data-overflow-wrapper]"
    };

    function T(t, e) {
        let i = 0;
        e.forEach((t => {
            i = t.offsetHeight > i ? t.offsetHeight : i
        }));
        const s = t.querySelectorAll(C.overflowBackground);
        [t, ...s].forEach((t => {
            t.style.setProperty("min-height", `calc(${i}px + var(--header-height))`)
        }))
    }

    function P(t) {
        if (window.innerWidth < window.theme.sizes.small) {
            return void t.querySelectorAll(C.overflowFrame).forEach((t => {
                const e = t.querySelectorAll(C.overflowContent);
                T(t, e)
            }))
        }
        let e = 0;
        const i = t.querySelectorAll(C.overflowFrame);
        t.querySelectorAll(C.overflowContent).forEach((t => {
            t.offsetHeight > e && (e = t.offsetHeight)
        }));
        [...i, ...t.querySelectorAll(C.overflowBackground)].forEach((t => {
            t.style.setProperty("min-height", `${e}px`)
        })), t.style.setProperty("min-height", `${e}px`)
    }

    function F(t) {
        const e = t.querySelectorAll(C.overflowContainer);
        e && e.forEach((t => {
            const e = t.querySelectorAll(C.overflowContent);
            T(t, e), document.addEventListener("theme:resize", (() => {
                T(t, e)
            }))
        }));
        const i = t.querySelectorAll(C.overflowWrapper);
        i && i.forEach((t => {
            P(t), document.addEventListener("theme:resize", (() => {
                P(t)
            }))
        }))
    }

    function I() {
        document.dispatchEvent(new CustomEvent("theme:resize", {
            bubbles: !0
        })), window.lastWindowWidth !== window.innerWidth && (document.dispatchEvent(new CustomEvent("theme:resize:width", {
            bubbles: !0
        })), window.lastWindowWidth = window.innerWidth)
    }
    window.lastWindowWidth = window.innerWidth;
    let x = window.pageYOffset,
        D = null,
        H = null,
        M = null,
        O = null,
        _ = 0;
    const B = {
        quickViewVisible: "js-quick-view-visible",
        cartDrawerOpen: "js-drawer-open-cart"
    };

    function $(e) {
        setTimeout((() => {
            _ && clearTimeout(_), t.disablePageScroll(e.detail, {
                allowTouchMove: t => "TEXTAREA" === t.tagName
            }), document.documentElement.setAttribute("data-scroll-locked", "")
        }))
    }

    function z(t) {
        const e = t.detail;
        e ? _ = setTimeout(R, e) : R()
    }

    function R() {
        document.body.classList.contains(B.quickViewVisible) || document.body.classList.contains(B.cartDrawerOpen) || (t.clearQueueScrollLocks(), t.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked"))
    }
    const V = (t, e = "", i) => {
        const s = i || document.createElement("div");
        return s.classList.add(e), s.setAttribute("data-scroll-lock-scrollable", ""), t.parentNode.insertBefore(s, t), s.appendChild(t)
    };

    function W(t) {
        t.querySelectorAll("table").forEach((t => {
            V(t, "table-wrapper")
        }))
    }
    const N = {
            loading: "is-loading"
        },
        U = {
            img: "img.is-loading"
        };

    function j(t) {
        t.querySelectorAll(U.img).forEach((t => {
            t.complete && (t.classList.remove(N.loading), t.parentNode.classList.remove(N.loading))
        }))
    }
    const K = {
            inputSearch: 'input[type="search"]',
            inputType: 'input[name="type"]',
            form: "form",
            allVisibleElements: '[role="option"]',
            ariaSelected: '[aria-selected="true"]',
            selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
            popularSearches: "[data-popular-searches]",
            popdownBody: "[data-popdown-body]",
            mainInputSearch: "[data-main-input-search]",
            predictiveSearchResults: "[data-predictive-search-results]",
            predictiveSearch: "predictive-search",
            searchForm: "search-form"
        },
        Q = "is-searched",
        G = "template-search";
    let X = class extends HTMLElement {
        getQuery() {
            return this.input.value.trim()
        }
        onFocus() {
            this.currentSearchTerm = this.getQuery()
        }
        onChange() {
            this.classList.toggle(Q, !this.isFormCleared()), this.searchTerm = this.getQuery()
        }
        isFormCleared() {
            return 0 === this.input.value.length
        }
        submit() {
            this.form.submit()
        }
        reset() {
            this.input.val = ""
        }
        onFormSubmit(t) {
            this.getQuery().length && !this.querySelector(K.selectedLink) || t.preventDefault()
        }
        onKeydown(t) {
            "ArrowUp" !== t.code && "ArrowDown" !== t.code || t.preventDefault()
        }
        onKeyup(t) {
            switch (!this.getQuery().length && this.predictiveSearch && this.close(!0), t.preventDefault(), t.code) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption()
            }
        }
        switchOption(t) {
            const e = "up" === t,
                i = this.classList.contains(Q) && this.predictiveSearchResults ? this.predictiveSearchResults : this.popularSearches;
            if (!i) return;
            this.selectedElement = i.querySelector(K.ariaSelected);
            const s = Array.from(i.querySelectorAll(K.allVisibleElements)).filter((t => null !== t.offsetParent));
            let o = 0;
            if (e && !this.selectedElement) return;
            let n = -1,
                r = 0;
            for (; - 1 === n && r <= s.length;) s[r] === this.selectedElement && (n = r), r++;
            !e && this.selectedElement ? o = n === s.length - 1 ? 0 : n + 1 : e && (o = 0 === n ? s.length - 1 : n - 1), o !== n && (this.activeElement = s[o], this.handleFocusableDescendants())
        }
        selectOption() {
            const t = this.querySelector(K.selectedOption);
            t && t.click()
        }
        handleFocusableDescendants(t = !1) {
            const e = this.selectedElement ? this.selectedElement : this.querySelector(K.ariaSelected);
            var i;
            if (e && e.setAttribute("aria-selected", !1), !this.activeElement || t) return this.selectedElement = null, null === (i = this.activeElement) || void 0 === i || i.setAttribute("aria-selected", !1), this.input.setAttribute("aria-expanded", !1), void this.input.setAttribute("aria-activedescendant", "");
            this.activeElement.setAttribute("aria-selected", !0), this.input.setAttribute("aria-activedescendant", this.activeElement.id)
        }
        constructor() {
            var t;
            super(), this.input = this.querySelector(K.inputSearch), this.form = this.querySelector(K.form), this.popdownBody = this.closest(K.popdownBody), this.popularSearches = null === (t = this.popdownBody) || void 0 === t ? void 0 : t.querySelector(K.popularSearches), this.predictiveSearchResults = this.querySelector(K.predictiveSearchResults), this.predictiveSearch = this.matches(K.predictiveSearch), this.searchForm = this.matches(K.searchForm), this.selectedElement = null, this.activeElement = null, this.searchTerm = "", this.currentSearchTerm = "", this.isSearchPage = document.body.classList.contains(G), this.input.addEventListener("input", n((t => {
                this.onChange(t)
            }), 300).bind(this)), this.input.addEventListener("focus", this.onFocus.bind(this)), this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)), this.addEventListener("keyup", this.onKeyup.bind(this)), this.addEventListener("keydown", this.onKeydown.bind(this)), this.isSearchPage && (this.mainInputType = document.querySelector(`${K.mainInputSearch} ${K.inputType}`), this.inputType = this.querySelector(K.inputType), this.inputType.value = this.mainInputType.value)
        }
    };
    customElements.define("search-form", X);
    const J = "predictive-search",
        Y = "#shopify-section-api-predictive-search",
        Z = "[data-predictive-search-results]",
        tt = "[data-predictive-search-status]",
        et = "[data-predictive-search-live-region-count-value]",
        it = "reset";
    customElements.define("predictive-search", class extends X {
            connectedCallback() {
                this.predictiveSearchResults.addEventListener("transitionend", (t => {
                    t.target !== this.predictiveSearchResults || this.getQuery().length || (this.classList.remove(it), requestAnimationFrame((() => this.clearResultsHTML())))
                }))
            }
            onChange() {
                super.onChange(), this.classList.remove(it), this.searchTerm.length ? requestAnimationFrame((() => this.getSearchResults(this.searchTerm))) : this.classList.add(it)
            }
            onFocus() {
                super.onFocus(), this.currentSearchTerm.length && (this.searchTerm !== this.currentSearchTerm ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm))
            }
            getSearchResults(t) {
                const e = t.replace(" ", "-").toLowerCase(),
                    i = parseInt(window.theme.settings.suggestionsResultsLimit);
                let s = "query";
                s += window.theme.settings.suggestArticles ? ",article" : "", s += window.theme.settings.suggestCollections ? ",collection" : "", s += window.theme.settings.suggestProducts ? ",product" : "", s += window.theme.settings.suggestPages ? ",page" : "", this.setLiveRegionLoadingState(), this.cachedResults[e] ? this.renderSearchResults(this.cachedResults[e]) : fetch(`${theme.routes.predictiveSearchUrl}?q=${encodeURIComponent(t)}&resources[type]=${s}&resources[limit]=${i}&section_id=api-predictive-search`, {
                    signal: this.abortController.signal
                }).then((t => {
                    if (!t.ok) {
                        var e = new Error(t.status);
                        throw this.close(), e
                    }
                    return t.text()
                })).then((t => {
                    const i = (new DOMParser).parseFromString(t, "text/html").querySelector(Y).innerHTML;
                    this.allPredictiveSearchInstances.forEach((t => {
                        t.cachedResults[e] = i
                    })), this.renderSearchResults(i)
                })).catch((t => {
                    if (20 !== (null == t ? void 0 : t.code)) throw this.close(), t
                }))
            }
            switchOption(t) {
                super.switchOption(t), this.statusElement && (this.statusElement.textContent = "")
            }
            setLiveRegionLoadingState() {
                this.statusElement = this.statusElement || this.querySelector(tt), this.loadingText = this.loadingText || this.getAttribute("data-loading-text"), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", !0)
            }
            setLiveRegionText(t) {
                this.statusElement.setAttribute("aria-hidden", "false"), this.statusElement.textContent = t, setTimeout((() => {
                    this.statusElement.setAttribute("aria-hidden", "true")
                }), 1e3)
            }
            renderSearchResults(t) {
                this.predictiveSearchResults.innerHTML = t, this.setAttribute("results", !0), this.setLiveRegionResults(), this.open()
            }
            setLiveRegionResults() {
                this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(et).textContent)
            }
            open() {
                this.setAttribute("open", !0)
            }
            close(t = !1) {
                this.closeResults(t)
            }
            closeResults(t = !1) {
                t && (this.reset(), this.removeAttribute("results"), this.classList.remove(it)), this.removeAttribute("loading"), this.removeAttribute("open")
            }
            clearResultsHTML() {
                this.predictiveSearchResults.innerHTML = ""
            }
            constructor() {
                super(), this.abortController = new AbortController, this.allPredictiveSearchInstances = document.querySelectorAll(J), this.predictiveSearchResults = this.querySelector(Z), this.cachedResults = {}
            }
        }), window.requestIdleCallback = window.requestIdleCallback || function(t) {
            var e = Date.now();
            return setTimeout((function() {
                t({
                    didTimeout: !1,
                    timeRemaining: function() {
                        return Math.max(0, 50 - (Date.now() - e))
                    }
                })
            }), 1)
        }, window.cancelIdleCallback = window.cancelIdleCallback || function(t) {
            clearTimeout(t)
        }, window.addEventListener("resize", n(I, 50)),
        function() {
            let t;
            window.addEventListener("scroll", (function() {
                t && window.cancelAnimationFrame(t), t = window.requestAnimationFrame((function() {
                    ! function() {
                        const t = window.pageYOffset;
                        t > x ? (H = !0, D = !1) : t < x ? (H = !1, D = !0) : (D = null, H = null), x = t, document.dispatchEvent(new CustomEvent("theme:scroll", {
                            detail: {
                                up: D,
                                down: H,
                                position: t
                            },
                            bubbles: !1
                        })), D && !M && document.dispatchEvent(new CustomEvent("theme:scroll:up", {
                            detail: {
                                position: t
                            },
                            bubbles: !1
                        })), H && !O && document.dispatchEvent(new CustomEvent("theme:scroll:down", {
                            detail: {
                                position: t
                            },
                            bubbles: !1
                        })), O = H, M = D
                    }()
                }))
            }), {
                passive: !0
            }), window.addEventListener("theme:scroll:lock", $), window.addEventListener("theme:scroll:unlock", z)
        }(), "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? (document.documentElement.className = document.documentElement.className.replace("no-touch", "supports-touch"), window.theme.touch = !0) : window.theme.touch = !1, document.addEventListener("load", (t => {
            "IMG" == t.target.tagName && t.target.classList.contains(N.loading) && (t.target.classList.remove(N.loading), t.target.parentNode.classList.remove(N.loading))
        }), !0);
    const st = n((() => {
        m()
    }), 300);
    window.addEventListener("DOMContentLoaded", (() => {
            f(), F(document), W(document), j(document), document.documentElement.classList.remove("is-loading"), document.documentElement.classList.add("is-loaded"), window.fastNetworkAndCPU && (document.onreadystatechange = () => {
                "complete" === document.readyState && (A = !0, q())
            }, requestIdleCallback(q))
        })), document.addEventListener("shopify:section:load", (t => {
            const e = t.target;
            window.dispatchEvent(new Event("resize"), {
                bubbles: !0
            }), F(e), W(e), f(), st()
        })), document.addEventListener("shopify:section:reorder", (() => {
            st()
        })), document.addEventListener("shopify:section:unload", (() => {
            st()
        })),
        function() {
            function t(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect();
                return s.top >= 0 && s.bottom <= i && s.left >= 0 && s.right <= e
            }

            function e(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect(),
                    o = s.left >= 0 && s.left <= e || s.right >= 0 && s.right <= e,
                    n = s.top >= 0 && s.top <= i || s.bottom >= 0 && s.bottom <= i;
                return o && n
            }
            window.visibilityHelper = {
                isElementTotallyVisible: t,
                isElementPartiallyVisible: e,
                inViewportPartially: function(t, i) {
                    function s() {
                        var s = e(t);
                        s != o && (o = s, "function" == typeof i && i(s, t))
                    }
                    var o = e(t);
                    window.addEventListener("load", s), window.addEventListener("resize", s), window.addEventListener("scroll", s)
                },
                inViewportTotally: function(e, i) {
                    function s() {
                        var s = t(e);
                        s != o && (o = s, "function" == typeof i && i(s, e))
                    }
                    var o = t(e);
                    window.addEventListener("load", s), window.addEventListener("resize", s), window.addEventListener("scroll", s)
                }
            }
        }(), window.Shopify = window.Shopify || {}, window.Shopify.theme = window.Shopify.theme || {}, window.Shopify.theme.sections = window.Shopify.theme.sections || {}, window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}, window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || [];
    const ot = window.Shopify.theme.sections.registered,
        nt = window.Shopify.theme.sections.instances,
        rt = {
            id: "data-section-id",
            type: "data-section-type"
        };
    let at = class {
            getStack() {
                return this.callStack
            }
            constructor(t = null, e = []) {
                this.type = t, this.components = function(t) {
                    if (void 0 !== t && "object" != typeof t || null === t) throw new TypeError("Theme Sections: The components object provided is not a valid");
                    return t
                }(e), this.callStack = {
                    onLoad: [],
                    onUnload: [],
                    onSelect: [],
                    onDeselect: [],
                    onBlockSelect: [],
                    onBlockDeselect: [],
                    onReorder: []
                }, e.forEach((t => {
                    for (const [e, i] of Object.entries(t)) {
                        const t = this.callStack[e];
                        Array.isArray(t) && "function" == typeof i ? t.push(i) : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`), console.warn(i))
                    }
                }))
            }
        },
        lt = class {
            callFunctions(t, e = null) {
                this.callStack[t].forEach((t => {
                    const i = {
                        id: this.id,
                        type: this.type,
                        container: this.container
                    };
                    e ? t.call(i, e) : t.call(i)
                }))
            }
            onLoad() {
                this.callFunctions("onLoad")
            }
            onUnload() {
                this.callFunctions("onUnload")
            }
            onSelect(t) {
                this.callFunctions("onSelect", t)
            }
            onDeselect(t) {
                this.callFunctions("onDeselect", t)
            }
            onBlockSelect(t) {
                this.callFunctions("onBlockSelect", t)
            }
            onBlockDeselect(t) {
                this.callFunctions("onBlockDeselect", t)
            }
            onReorder(t) {
                this.callFunctions("onReorder", t)
            }
            constructor(t, e) {
                this.container = function(t) {
                    if (!(t instanceof Element)) throw new TypeError("Theme Sections: Attempted to load section. The section container provided is not a DOM element.");
                    if (null === t.getAttribute(rt.id)) throw new Error("Theme Sections: The section container provided does not have an id assigned to the " + rt.id + " attribute.");
                    return t
                }(t), this.id = t.getAttribute(rt.id), this.type = e.type, this.callStack = e.getStack();
                try {
                    this.onLoad()
                } catch (t) {
                    console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t)
                }
            }
        };

    function ct(t, e) {
        if ("string" != typeof t) throw new TypeError("Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered");
        if (void 0 !== ot[t]) throw new Error('Theme Sections: A section of type "' + t + '" has already been registered. You cannot register the same section type twice');
        Array.isArray(e) || (e = [e]);
        const i = new at(t, e);
        return ot[t] = i, ot
    }

    function ht(t, e) {
        t = pt(t), void 0 === e && (e = document.querySelectorAll("[" + rt.type + "]")), e = mt(e), t.forEach((function(t) {
            const i = ot[t];
            void 0 !== i && (e = e.filter((function(e) {
                return !(dt(e).length > 0) && (null !== e.getAttribute(rt.type) && (e.getAttribute(rt.type) !== t || (nt.push(new lt(e, i)), !1)))
            })))
        }))
    }

    function dt(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
        if (t instanceof Element || i instanceof Element) mt(t).forEach((function(t) {
            e = e.concat(nt.filter((function(e) {
                return e.container === t
            })))
        }));
        else if ("string" == typeof t || "string" == typeof i) {
            pt(t).forEach((function(t) {
                e = e.concat(nt.filter((function(e) {
                    return e.type === t
                })))
            }))
        }
        return e
    }

    function ut(t) {
        for (var e, i = 0; i < nt.length; i++)
            if (nt[i].id === t) {
                e = nt[i];
                break
            }
        return e
    }

    function pt(t) {
        return "*" === t ? t = Object.keys(ot) : "string" == typeof t ? t = [t] : t.constructor === lt ? t = [t.prototype.type] : Array.isArray(t) && t[0].constructor === lt && (t = t.map((function(t) {
            return t.type
        }))), t = t.map((function(t) {
            return t.toLowerCase()
        }))
    }

    function mt(t) {
        return NodeList.prototype.isPrototypeOf(t) && t.length > 0 ? t = Array.prototype.slice.call(t) : NodeList.prototype.isPrototypeOf(t) && 0 === t.length || null === t ? t = [] : !Array.isArray(t) && t instanceof Element && (t = [t]), t
    }
    window.Shopify.designMode && (document.addEventListener("shopify:section:load", (function(t) {
        var e = t.detail.sectionId,
            i = t.target.querySelector("[" + rt.id + '="' + e + '"]');
        null !== i && ht(i.getAttribute(rt.type), i)
    })), document.addEventListener("shopify:section:reorder", (function(t) {
        var e = t.detail.sectionId,
            i = t.target.querySelector("[" + rt.id + '="' + e + '"]');
        "object" == typeof dt(i)[0] && dt(i).forEach((function(t) {
            t.onReorder()
        }))
    })), document.addEventListener("shopify:section:unload", (function(t) {
        var e = t.detail.sectionId,
            i = t.target.querySelector("[" + rt.id + '="' + e + '"]');
        "object" == typeof dt(i)[0] && dt(i).forEach((function(t) {
            var e = nt.map((function(t) {
                return t.id
            })).indexOf(t.id);
            nt.splice(e, 1), t.onUnload()
        }))
    })), document.addEventListener("shopify:section:select", (function(t) {
        var e = ut(t.detail.sectionId);
        "object" == typeof e && e.onSelect(t)
    })), document.addEventListener("shopify:section:deselect", (function(t) {
        var e = ut(t.detail.sectionId);
        "object" == typeof e && e.onDeselect(t)
    })), document.addEventListener("shopify:block:select", (function(t) {
        var e = ut(t.detail.sectionId);
        "object" == typeof e && e.onBlockSelect(t)
    })), document.addEventListener("shopify:block:deselect", (function(t) {
        var e = ut(t.detail.sectionId);
        "object" == typeof e && e.onBlockDeselect(t)
    })));
    const gt = (t, e) => {
        let i, s;
        return function o(...n) {
            const r = Date.now();
            s = clearTimeout(s), !i || r - i >= e ? (t.apply(null, n), i = r) : s = setTimeout(o.bind(null, ...n), e - (r - i))
        }
    };

    function vt(t) {
        this.status = t.status || null, this.headers = t.headers || null, this.json = t.json || null, this.body = t.body || null
    }
    vt.prototype = Error.prototype;
    const yt = "[data-collapsible-single]",
        ft = "[data-collapsible-trigger]",
        bt = "[data-collapsible-content]",
        wt = "is-expanded",
        Et = "aria-expanded",
        St = "aria-controls",
        Lt = "data-collapsible-trigger-mobile",
        kt = "data-collapsible-transition-override",
        At = 500,
        qt = {};
    let Ct = class {
        init() {
            this.triggers.forEach((t => {
                t.addEventListener("click", this.collapsibleToggleEvent), t.addEventListener("keyup", this.collapsibleToggleEvent)
            }))
        }
        collapsibleToggle(t) {
            t.preventDefault();
            const e = t.target.matches(ft) ? t.target : t.target.closest(ft),
                i = e.getAttribute(St),
                s = document.getElementById(i),
                o = e.hasAttribute(Lt),
                n = e.classList.contains(wt),
                r = t.code === theme.keyboardKeys.SPACE,
                a = t.code === theme.keyboardKeys.ESCAPE,
                l = window.innerWidth < theme.sizes.small;
            this.isTransitioning && !this.transitionOverride || (!t.code || r || a) && (!n && a || o && !l || (this.isTransitioning = !0, e.disabled = !0, this.single && this.triggers.forEach((t => {
                const i = t.classList.contains(wt);
                if (e == t || !i) return;
                const s = t.getAttribute(St),
                    o = document.getElementById(s);
                requestAnimationFrame((() => {
                    this.closeItem(o, t)
                }))
            })), n ? requestAnimationFrame((() => {
                this.closeItem(s, e)
            })) : requestAnimationFrame((() => {
                this.openItem(s, e)
            }))))
        }
        openItem(t, e) {
            let i = t.querySelector(bt).offsetHeight;
            this.setDropdownHeight(t, i, e, !0), e.classList.add(wt), e.setAttribute(Et, !0), e.dispatchEvent(new CustomEvent("theme:form:sticky", {
                bubbles: !0,
                detail: {
                    element: "accordion"
                }
            }))
        }
        closeItem(t, e) {
            let i = t.querySelector(bt).offsetHeight;
            requestAnimationFrame((() => {
                i = 0, this.setDropdownHeight(t, i, e, !1), e.classList.remove(wt)
            })), this.setDropdownHeight(t, i, e, !1), e.classList.remove(wt), e.setAttribute(Et, !1)
        }
        setDropdownHeight(t, e, i, s) {
            t.style.height = `${e}px`, t.setAttribute(Et, s), t.classList.toggle(wt, s), this.resetHeightTimer && clearTimeout(this.resetHeightTimer), 0 == e && (this.resetHeightTimer = setTimeout((() => {
                t.style.height = ""
            }), At)), s ? this.resetHeightTimer = setTimeout((() => {
                t.style.height = "auto", this.isTransitioning = !1
            }), At) : this.isTransitioning = !1, setTimeout((() => {
                i.disabled = !1
            }), At)
        }
        onUnload() {
            this.triggers.forEach((t => {
                t.removeEventListener("click", this.collapsibleToggleEvent), t.removeEventListener("keyup", this.collapsibleToggleEvent)
            }))
        }
        constructor(t) {
            this.container = t, this.single = this.container.querySelector(yt), this.triggers = this.container.querySelectorAll(ft), this.resetHeightTimer = 0, this.isTransitioning = !1, this.transitionOverride = this.container.hasAttribute(kt), this.collapsibleToggleEvent = t => gt(this.collapsibleToggle(t), 1250), this.init()
        }
    };
    const Tt = {
            onLoad() {
                qt[this.id] = new Ct(this.container)
            }, onUnload() {
                qt[this.id].onUnload()
            }
        },
        Pt = "[data-quantity-holder]",
        Ft = "[data-quantity-field]",
        It = "[data-quantity-button]",
        xt = "[data-quantity-minus]",
        Dt = "[data-quantity-plus]",
        Ht = "read-only",
        Mt = "is-disabled";
    let Ot = class {
        init() {
            this.quantity = this.holder.querySelector(Pt), this.quantity && (this.field = this.quantity.querySelector(Ft), this.buttons = this.quantity.querySelectorAll(It), this.increaseButton = this.quantity.querySelector(Dt), this.quantityValue = Number(this.field.value || 0), this.cartItemID = this.field.getAttribute("data-id"), this.maxValue = Number(this.field.getAttribute("max")) > 0 ? Number(this.field.getAttribute("max")) : null, this.minValue = Number(this.field.getAttribute("min")) > 0 ? Number(this.field.getAttribute("min")) : 0, this.disableIncrease = this.disableIncrease.bind(this), this.emptyField = !1, this.updateQuantity = this.updateQuantity.bind(this), this.decrease = this.decrease.bind(this), this.increase = this.increase.bind(this), this.disableIncrease(), this.quantity.classList.contains(Ht) || (this.changeValueOnClick(), this.changeValueOnInput()))
        }
        changeValueOnClick() {
            this.buttons.forEach((t => {
                t.addEventListener("click", (t => {
                    t.preventDefault(), this.quantityValue = Number(this.field.value || 0);
                    const e = t.target,
                        i = e.matches(xt) || e.closest(xt),
                        s = e.matches(Dt) || e.closest(Dt);
                    i && this.decrease(), s && this.increase(), this.updateQuantity()
                }))
            }))
        }
        changeValueOnInput() {
            this.field.addEventListener("input", (() => {
                this.quantityValue = this.field.value, this.updateQuantity()
            }))
        }
        updateQuantity() {
            this.maxValue < this.quantityValue && null !== this.maxValue && (this.quantityValue = this.maxValue), this.minValue > this.quantityValue && (this.quantityValue = this.minValue), this.field.value = this.quantityValue, this.disableIncrease(), document.dispatchEvent(new CustomEvent("theme:cart:update")), this.quantityUpdateCart && this.updateCart()
        }
        decrease() {
            this.quantityValue > this.minValue ? this.quantityValue-- : this.quantityValue = 0
        }
        increase() {
            this.quantityValue++
        }
        disableIncrease() {
            this.increaseButton.classList.toggle(Mt, this.quantityValue >= this.maxValue && null !== this.maxValue)
        }
        updateCart() {
            if ("" === this.quantityValue) return;
            const t = new CustomEvent("theme:cart:update", {
                bubbles: !0,
                detail: {
                    id: this.cartItemID,
                    quantity: this.quantityValue
                }
            });
            this.holder.dispatchEvent(t)
        }
        constructor(t, e = !1) {
            this.holder = t, this.quantityUpdateCart = e
        }
    };
    const _t = {
        state: {
            firstFocusable: null,
            lastFocusable: null,
            trigger: null
        },
        trapFocus: function(t) {
            var e = Array.from(t.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')).filter((function(t) {
                var e = t.offsetWidth,
                    i = t.offsetHeight;
                return 0 !== e && 0 !== i && "none" !== getComputedStyle(t).getPropertyValue("display")
            }));
            e = e.filter((function(t) {
                return !t.classList.contains("deferred-media__poster")
            })), this.state.firstFocusable = e[0], this.state.lastFocusable = e[e.length - 1], t.elementToFocus || (t.elementToFocus = this.state.firstFocusable || t.container), this._setupHandlers(), document.addEventListener("focusin", this._onFocusInHandler), document.addEventListener("focusout", this._onFocusOutHandler), t.container.setAttribute("tabindex", "-1"), t.elementToFocus.focus()
        },
        removeTrapFocus: function(t) {
            const e = !document.body.classList.contains("no-outline");
            t && t.container && t.container.removeAttribute("tabindex"), document.removeEventListener("focusin", this._onFocusInHandler), this.state.trigger && e && this.state.trigger.focus()
        },
        _manageFocus: function(t) {
            t.code === theme.keyboardKeys.TAB && (t.target !== this.state.lastFocusable || t.shiftKey || (t.preventDefault(), this.state.firstFocusable.focus()), t.target === this.state.firstFocusable && t.shiftKey && (t.preventDefault(), this.state.lastFocusable.focus()))
        },
        _onFocusOut: function() {
            document.removeEventListener("keydown", this._manageFocusHandler)
        },
        _onFocusIn: function(t) {
            t.target !== this.state.lastFocusable && t.target !== this.state.firstFocusable || document.addEventListener("keydown", this._manageFocusHandler)
        },
        _setupHandlers: function() {
            this._onFocusInHandler || (this._onFocusInHandler = this._onFocusIn.bind(this)), this._onFocusOutHandler || (this._onFocusOutHandler = this._onFocusIn.bind(this)), this._manageFocusHandler || (this._manageFocusHandler = this._manageFocus.bind(this))
        }
    };
    const Bt = {};

    function $t(t = {}) {
        if (t.type || (t.type = "json"), t.url) return Bt[t.url] ? Bt[t.url] : function(t, e) {
            const i = new Promise(((i, s) => {
                "text" === e ? fetch(t).then((t => t.text())).then((t => {
                    i(t)
                })).catch((t => {
                    s(t)
                })) : function(t, e, i) {
                    let s = document.getElementsByTagName("head")[0],
                        o = !1,
                        n = document.createElement("script");
                    n.src = t, n.onload = n.onreadystatechange = function() {
                        o || this.readyState && "loaded" != this.readyState && "complete" != this.readyState ? i() : (o = !0, e())
                    }, s.appendChild(n)
                }(t, (function() {
                    i()
                }), (function() {
                    s()
                }))
            }));
            return Bt[t] = i, i
        }(t.url, t.type);
        if (t.json) return Bt[t.json] ? Promise.resolve(Bt[t.json]) : window.fetch(t.json).then((t => t.json())).then((e => (Bt[t.json] = e, e)));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return Bt[e] ? Bt[e] : function(t) {
                const e = "".concat(t.name, t.version),
                    i = new Promise(((e, i) => {
                        try {
                            window.Shopify.loadFeatures([{
                                name: t.name,
                                version: t.version,
                                onLoad: t => {
                                    ! function(t, e, i) {
                                        i ? e(i) : t()
                                    }(e, i, t)
                                }
                            }])
                        } catch (t) {
                            i(t)
                        }
                    }));
                return Bt[e] = i, i
            }(t)
        }
        return Promise.reject()
    }
    window.isYoutubeAPILoaded = !1, window.isVimeoAPILoaded = !1;
    const zt = "[data-video-id]",
        Rt = "loaded",
        Vt = "data-enable-sound",
        Wt = "data-enable-background",
        Nt = "data-enable-autoplay",
        Ut = "data-enable-loop",
        jt = "data-video-id",
        Kt = "data-video-type";
    const Qt = {
            videoIframe: "[data-video-id]",
            videoWrapper: ".video-wrapper",
            youtubeWrapper: "[data-youtube-wrapper]"
        },
        Gt = "data-section-id",
        Xt = "data-enable-sound",
        Jt = "data-check-player-visibility",
        Yt = "data-video-id",
        Zt = "data-video-type",
        te = "loaded",
        ee = [];
    const ie = "[data-notification-form]",
        se = "[data-notification]",
        oe = "[data-popup-close]",
        ne = "pswp--success",
        re = "notification-popup-visible";

    function ae(t) {
        const i = e.data(t);
        i && (i.on("dragStart", ((t, e) => {
            document.ontouchmove = function(t) {
                t.preventDefault()
            }
        })), i.on("dragEnd", ((t, e) => {
            document.ontouchmove = function(t) {
                return !0
            }
        })))
    }
    const le = "html5",
        ce = "youtube",
        he = "vimeo",
        de = "[data-deferred-media]",
        ue = "[data-deferred-media-button]",
        pe = "[data-product-single-media-wrapper]",
        me = "[data-video]",
        ge = ".media--hidden",
        ve = "media--hidden",
        ye = "loaded",
        fe = "data-section-id",
        be = "data-autoplay-video",
        we = "data-media-id";
    let Ee = class {
        init() {
            this.container.querySelectorAll(me).forEach((t => {
                const e = t.querySelector(ue);
                e && e.addEventListener("click", this.loadContent.bind(this, t)), this.autoplayVideo && this.loadContent(t)
            }))
        }
        loadContent(t) {
            if (t.querySelector(de).getAttribute(ye)) return;
            const e = document.createElement("div");
            e.appendChild(t.querySelector("template").content.firstElementChild.cloneNode(!0));
            const i = t.dataset.mediaId,
                s = e.querySelector("video, iframe"),
                o = this.hostFromVideoElement(s),
                n = t.querySelector(de);
            n.appendChild(s), n.setAttribute("loaded", !0), this.players[i] = {
                mediaId: i,
                sectionId: this.id,
                container: t,
                element: s,
                host: o,
                ready: () => {
                    this.createPlayer(i)
                }
            };
            const r = this.players[i];
            switch (r.host) {
                case le:
                    this.loadVideo(r, le);
                    break;
                case he:
                    window.isVimeoAPILoaded ? this.loadVideo(r, he) : $t({
                        url: "https://player.vimeo.com/api/player.js"
                    }).then((() => this.loadVideo(r, he)));
                    break;
                case ce:
                    window.isYoutubeAPILoaded ? this.loadVideo(r, ce) : $t({
                        url: "https://www.youtube.com/iframe_api"
                    }).then((() => this.loadVideo(r, ce)))
            }
        }
        hostFromVideoElement(t) {
            if ("VIDEO" === t.tagName) return le;
            if ("IFRAME" === t.tagName) {
                if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(t.src)) return ce;
                if (t.src.includes("vimeo.com")) return he
            }
            return null
        }
        loadVideo(t, e) {
            t.host === e && t.ready()
        }
        createPlayer(t) {
            const e = this.players[t];
            switch (e.host) {
                case le:
                    e.element.addEventListener("play", (() => {
                        e.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                            bubbles: !0
                        })
                    })), e.element.addEventListener("pause", (() => {
                        e.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
                            bubbles: !0
                        })
                    })), this.autoplayVideo && this.observeVideo(e, t);
                    break;
                case he:
                    e.player = new Vimeo.Player(e.element), e.player.play(), e.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                        bubbles: !0
                    }), window.isVimeoAPILoaded = !0, e.player.on("play", (() => {
                        e.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                            bubbles: !0
                        })
                    })), e.player.on("pause", (() => {
                        e.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
                            bubbles: !0
                        })
                    })), this.autoplayVideo && this.observeVideo(e, t);
                    break;
                case ce:
                    if (e.host == ce && e.player) return;
                    YT.ready((() => {
                        const i = e.container.dataset.videoId;
                        e.player = new YT.Player(e.element, {
                            videoId: i,
                            events: {
                                onReady: t => {
                                    t.target.playVideo(), e.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                                        bubbles: !0
                                    })
                                },
                                onStateChange: t => {
                                    1 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                                        bubbles: !0
                                    }), 2 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
                                        bubbles: !0
                                    }), 0 == t.data && e.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
                                        bubbles: !0
                                    })
                                }
                            }
                        }), window.isYoutubeAPILoaded = !0, this.autoplayVideo && this.observeVideo(e, t)
                    }))
            }
            e.container.addEventListener("theme:media:visible", (t => this.onVisible(t))), e.container.addEventListener("theme:media:hidden", (t => this.onHidden(t))), e.container.addEventListener("xrLaunch", (t => this.onHidden(t)))
        }
        observeVideo(t) {
            new IntersectionObserver(((e, i) => {
                e.forEach((e => {
                    const i = 0 == e.intersectionRatio,
                        s = !t.element.closest(ge);
                    i ? this.pauseVideo(t) : s && this.playVideo(t)
                }))
            }), {
                rootMargin: "200px",
                threshold: [0, .25, .75, 1]
            }).observe(t.element)
        }
        playVideo(t) {
            t.player && t.player.playVideo ? t.player.playVideo() : t.element && t.element.play ? t.element.play() : t.player && t.player.play && t.player.play(), t.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                bubbles: !0
            })
        }
        pauseVideo(t) {
            if (t.player && t.player.pauseVideo) "1" == t.player.playerInfo.playerState && t.player.pauseVideo();
            else if (t.player && t.player.pause) t.player.pause();
            else if (t.element && !t.element.paused) {
                var e;
                null === (e = t.element) || void 0 === e || e.pause()
            }
        }
        onHidden(t) {
            if (void 0 !== t.target.dataset.mediaId) {
                const e = t.target.dataset.mediaId,
                    i = this.players[e];
                this.pauseVideo(i)
            }
        }
        onVisible(t) {
            if (void 0 !== t.target.dataset.mediaId) {
                const e = t.target.dataset.mediaId,
                    i = this.players[e];
                setTimeout((() => {
                    this.playVideo(i)
                }), 50), this.pauseContainerMedia(e)
            }
        }
        pauseOtherMedia(t, e) {
            const i = `[${we}="${t}"]`,
                s = e.querySelectorAll(`${pe}:not(${i})`);
            s.length && s.forEach((t => {
                t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                    bubbles: !0
                }), t.classList.add(ve)
            }))
        }
        constructor(t) {
            this.container = t, this.id = this.container.getAttribute(fe), this.autoplayVideo = "true" === this.container.getAttribute(be), this.players = {}, this.pauseContainerMedia = (t, e = this.container) => this.pauseOtherMedia(t, e), this.init()
        }
    };

    function Se(t, e, i = [], s = !1) {
        const o = new FormData(t),
            n = new URLSearchParams(o);
        if (!e) return n.toString();
        const r = new FormData(e),
            a = new URLSearchParams(r),
            l = [];
        for (const t of o.entries()) "" === t[1] && l.push(t[0]);
        for (const t of r.entries()) "" === t[1] && l.push(t[0]);
        for (let t = 0; t < l.length; t++) {
            const e = l[t];
            n.has(e) && n.delete(e), a.has(e) && a.delete(e)
        }
        for (const t of n.keys()) a.has(t) && a.delete(t);
        if (i.length > 0)
            for (let t = 0; t < i.length; t++) {
                const e = i[t];
                n.has(e) && n.delete(e), a.has(e) && a.delete(e)
            }
        return s && (a.has("type") && a.delete("type"), n.set("type", s)), `${n.toString()}&${a.toString()}`
    }
    const Le = "[data-custom-scrollbar]",
        ke = "[data-custom-scrollbar-items]",
        Ae = "[data-custom-scrollbar-thumb]",
        qe = ".current";
    let Ce = class {
        calculateTrack(t) {
            if (!t) return this.scrollbar.style.setProperty("--thumb-scale", 0), void this.scrollbar.style.setProperty("--thumb-position", "0px");
            const e = t.clientWidth / this.scrollbarThumb.parentElement.clientWidth,
                i = t.offsetLeft / this.scrollbarThumb.parentElement.clientWidth;
            this.scrollbar.style.setProperty("--thumb-scale", e), this.scrollbar.style.setProperty("--thumb-position", this.trackWidth * i + "px")
        }
        calculateScrollbar() {
            if (this.scrollbarItems.children.length) {
                const t = [...this.scrollbarItems.children];
                this.trackWidth = 0, t.forEach((t => {
                    this.trackWidth += t.getBoundingClientRect().width + parseInt(window.getComputedStyle(t).marginRight)
                })), this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}px`)
            }
        }
        onScrollbarChange(t) {
            t && t.detail && t.detail.element && this.container.contains(t.detail.element) && this.calculateTrack(t.detail.element)
        }
        events() {
            document.addEventListener("theme:resize:width", this.calcScrollbarEvent), document.addEventListener("theme:custom-scrollbar:change", this.onScrollbarChangeEvent)
        }
        unload() {
            document.removeEventListener("theme:resize:width", this.calcScrollbarEvent), document.removeEventListener("theme:custom-scrollbar:change", this.onScrollbarChangeEvent)
        }
        constructor(t) {
            this.container = t, this.scrollbarItems = t.querySelector(ke), this.scrollbar = t.querySelector(Le), this.scrollbarThumb = t.querySelector(Ae), this.trackWidth = 0, this.calcScrollbarEvent = () => this.calculateScrollbar(), this.onScrollbarChangeEvent = t => this.onScrollbarChange(t), this.scrollbar && this.scrollbarItems && (this.events(), this.calculateScrollbar(), this.scrollbarItems.children.length && this.calculateTrack(this.scrollbarItems.querySelector(qe)))
        }
    };
    const Te = "[data-tooltip]",
        Pe = "[data-tooltip-container]",
        Fe = "[data-tooltip-arrow]",
        Ie = "[data-aos]",
        xe = "tooltip-default",
        De = "is-animating",
        He = "is-visible",
        Me = "is-hiding",
        Oe = "data-tooltip",
        _e = "data-tooltip-container",
        Be = "data-tooltip-stop-mouseenter",
        $e = {};
    let ze = class {
        init() {
            if (!document.querySelector(Pe)) {
                const t = `<div class="${this.rootClass}__inner"><div class="${this.rootClass}__arrow" data-tooltip-arrow></div><div class="${this.rootClass}__text"></div></div>`,
                    e = document.createElement("div");
                e.className = `${this.rootClass} ${this.isAnimatingClass}`, e.setAttribute(_e, ""), e.innerHTML = t, document.body.appendChild(e)
            }
            this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent), this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent), this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent), document.addEventListener("theme:tooltip:close", this.removePinEvent);
            const t = document.querySelector(Pe);
            theme.settings.animations && this.animatedContainer && this.animatedContainer.addEventListener("transitionend", (e => {
                "transform" === e.propertyName && t.classList.remove(De)
            }))
        }
        addPin(t = !1) {
            const e = document.querySelector(Pe),
                i = e.querySelector(Fe);
            if (e && (t && !this.tooltip.hasAttribute(Be) || !t)) {
                const t = e.querySelector(`.${this.rootClass}__inner`);
                e.querySelector(`.${this.rootClass}__text`).textContent = this.label;
                const s = t.offsetWidth,
                    o = this.tooltip.getBoundingClientRect(),
                    n = o.top,
                    r = o.width,
                    a = n + o.height + window.scrollY;
                let l = o.left - s / 2 + r / 2,
                    c = "50%";
                const h = l + s - window.innerWidth;
                h > 0 && (l -= h), l < 0 && (c = `calc(50% + ${l}px)`, l = 0), i.style.left = c, e.style.transform = `translate(${l}px, ${a}px)`, e.classList.remove(Me), e.classList.add(He), document.addEventListener("theme:scroll", this.removePinEvent)
            }
        }
        removePin(t, e = !1, i = !1) {
            const s = document.querySelector(Pe),
                o = s.classList.contains(He);
            s && (e && !this.tooltip.hasAttribute(Be) || !e) && (o && (i || t.detail.hideTransition) && (s.classList.add(Me), this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout), this.hideTransitionTimeout = setTimeout((() => {
                s.classList.remove(Me)
            }), this.transitionSpeed)), s.classList.remove(He), s.style.transform = "translate(100%, 0)", document.removeEventListener("theme:scroll", this.removePinEvent))
        }
        unload() {
            this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent), this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent), this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent), document.removeEventListener("theme:tooltip:close", this.removePinEvent), document.removeEventListener("theme:scroll", this.removePinEvent)
        }
        constructor(t) {
            this.tooltip = t, this.tooltip.hasAttribute(Oe) && (this.rootClass = xe, this.isAnimatingClass = De, this.label = this.tooltip.getAttribute(Oe), this.transitionSpeed = 200, this.hideTransitionTimeout = 0, this.animatedContainer = this.tooltip.closest(Ie), this.addPinEvent = () => this.addPin(), this.addPinMouseEvent = () => this.addPin(!0), this.removePinEvent = t => gt(this.removePin(t), 50), this.removePinMouseEvent = t => this.removePin(t, !0, !0), this.init())
        }
    };
    const Re = {
            onLoad() {
                $e[this.id] = [];
                this.container.querySelectorAll(Te).forEach((t => {
                    $e[this.id].push(new ze(t))
                }))
            }, onUnload() {
                $e[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            }
        },
        Ve = "[data-range-slider]",
        We = "[data-range-left]",
        Ne = "[data-range-right]",
        Ue = "[data-range-line]",
        je = "[data-range-holder]",
        Ke = "data-se-min",
        Qe = "data-se-max",
        Ge = "data-se-min-value",
        Xe = "data-se-max-value",
        Je = "data-se-step",
        Ye = "data-range-filter-update",
        Ze = "[data-field-price-min]",
        ti = "[data-field-price-max]",
        ei = "is-initialized";

    function ii(t) {
        return t.replace(/http(s)?:/, "")
    }

    function si() {
        this.entries = []
    }

    function oi(t, e) {
        ni(t);
        var i = function(t, e) {
            ni(t),
                function(t) {
                    if (!Array.isArray(t)) throw new TypeError(t + " is not an array.");
                    if (0 === t.length) throw new Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name")) throw new Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name) throw new TypeError("Invalid value type passed for name of option " + t[0].name + ". Value should be string.")
                }(e);
            var i = [];
            return e.forEach((function(e) {
                for (var s = 0; s < t.options.length; s++) {
                    if ((t.options[s].name || t.options[s]).toLowerCase() === e.name.toLowerCase()) {
                        i[s] = e.value;
                        break
                    }
                }
            })), i
        }(t, e);
        return function(t, e) {
            ni(t),
                function(t) {
                    if (Array.isArray(t) && "object" == typeof t[0]) throw new Error(t + "is not a valid array of options.")
                }(e);
            var i = t.variants.filter((function(t) {
                return e.every((function(e, i) {
                    return t.options[i] === e
                }))
            }));
            return i[0] || null
        }(t, i)
    }

    function ni(t) {
        if ("object" != typeof t) throw new TypeError(t + " is not an object.");
        if (0 === Object.keys(t).length && t.constructor === Object) throw new Error(t + " is empty.")
    }
    si.prototype.add = function(t, e, i) {
        this.entries.push({
            element: t,
            event: e,
            fn: i
        }), t.addEventListener(e, i)
    }, si.prototype.removeAll = function() {
        this.entries = this.entries.filter((function(t) {
            return t.element.removeEventListener(t.event, t.fn), !1
        }))
    };
    var ri = '[name="id"]',
        ai = '[name="selling_plan"]',
        li = '[name^="options"]',
        ci = '[name="quantity"]',
        hi = '[name^="properties"]';
    const di = {
            color: "ash"
        },
        ui = "[data-swatch]",
        pi = "[data-product-block]",
        mi = "[data-product-image-secondary]",
        gi = "[data-product-image-hover]",
        vi = "[data-button-quick-view]",
        yi = "[data-grid-image]",
        fi = "[data-grid-link]",
        bi = "[data-load-hovers]",
        wi = "[data-swatches-more]",
        Ei = "[data-section-type]",
        Si = "[data-swatches-container]",
        Li = "[data-swatches-label]",
        ki = "[data-swatches-button]",
        Ai = "[data-option-position]",
        qi = "product__media--featured-visible",
        Ci = "product__media__hover-img--visible",
        Ti = "swatch__link--no-image",
        Pi = "no-outline",
        Fi = "is-visible",
        Ii = "selector-wrapper--large",
        xi = "data-swatch",
        Di = "data-swatch-handle",
        Hi = "data-swatch-label",
        Mi = "data-swatch-image",
        Oi = "data-swatch-image-id",
        _i = "data-swatch-variant",
        Bi = "data-swatch-index",
        $i = "data-variant-id",
        zi = "data-loaded",
        Ri = "data-fetched-image",
        Vi = "data-fetched-image-index",
        Wi = "data-grid-image-default",
        Ni = "data-grid-image-target",
        Ui = "data-grid-image-target-default";
    let ji = {};
    const Ki = {};
    let Qi = class {
            init() {
                this.setStyles(), this.variant && this.outer && (this.handleHovers(), this.handleClicks()), !this.image && this.swatchLink && this.swatchLink.classList.add(Ti)
            }
            setStyles() {
                this.colorMatch && this.colorMatch.hex && this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`), this.colorMatch && this.colorMatch.path && this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`)
            }
            handleHovers() {
                this.swatchLink.addEventListener("mouseenter", (() => {
                    var t;
                    if (this.imageReplace = null, this.imageId) {
                        if (!this.outer.querySelector(`[${Ni}="${this.imageId}"]`) && (this.gridImage = this.outer.querySelector(yi), this.image && this.gridImage)) {
                            const t = window.devicePixelRatio || 1,
                                e = this.gridImage.offsetWidth * t,
                                i = 180 * Math.ceil(e / 180);
                            if ((this.gridImage.hasAttribute(Ui) ? this.gridImage.getAttribute(Ui) : "") === this.imageId && this.gridImage.hasAttribute(Wi)) return void(this.imageReplace = this.gridImage.getAttribute(Wi));
                            if (this.element.hasAttribute(Ri)) this.imageReplace = this.element.getAttribute(Ri);
                            else {
                                const t = function(t, e) {
                                    if (null === e) return t;
                                    if (null == t && (t = window.theme.assets.noImage), "master" === e) return ii(t);
                                    const i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
                                    if (i) {
                                        const s = t.split(i[0]),
                                            o = i[0];
                                        return ii(`${s[0]}_${e}${o}`)
                                    }
                                    return null
                                }(this.image, `${i}x`);
                                window.fetch(t).then((t => t.blob())).then((t => {
                                    const e = URL.createObjectURL(t);
                                    this.imageReplace = `url("${e}")`, this.element.setAttribute(Ri, this.imageReplace), this.element.hasAttribute(Bi) && this.outer.hasAttribute(Vi) && parseInt(this.element.getAttribute(Bi)) === parseInt(this.outer.getAttribute(Vi)) && (this.replaceImages(), this.outer.removeAttribute(Vi))
                                })).catch((t => {
                                    console.log(`Error: ${t}`)
                                }))
                            }
                        }
                    }
                    if (this.loadHovers = this.outer.querySelector(bi), this.loadHovers && !(null === (t = this.loadHovers) || void 0 === t ? void 0 : t.hasAttribute(zi))) {
                        const t = document.createElement("div");
                        t.appendChild(this.loadHovers.querySelector("template").content.firstElementChild.cloneNode(!0)), this.loadHovers.appendChild(t), this.loadHovers.setAttribute(zi, !0)
                    }
                }))
            }
            handleClicks() {
                this.swatchLink.addEventListener("click", (t => {
                    !document.body.classList.contains(Pi) || (t.preventDefault(), this.updateImagesAndLinksOnEvent())
                })), this.swatchLink.addEventListener("keyup", (t => {
                    const e = !document.body.classList.contains(Pi);
                    t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER || e || (t.preventDefault(), this.swatchLink.dispatchEvent(new Event("mouseenter", {
                        bubbles: !0
                    })), this.updateImagesAndLinksOnEvent())
                }))
            }
            updateImagesAndLinksOnEvent() {
                this.updateLinks(), this.replaceImages()
            }
            updateLinks() {
                this.linkElements = this.outer.querySelectorAll(fi), this.quickView = this.outer.querySelector(vi), this.linkElements.length && this.linkElements.forEach((t => {
                    const e = (i = t.getAttribute("href"), s = this.variant, /variant=/.test(i) ? i.replace(/(variant=)[^&]+/, "$1" + s) : /\?/.test(i) ? i.concat("&variant=").concat(s) : i.concat("?variant=").concat(s));
                    var i, s;
                    t.setAttribute("href", e)
                })), this.quickView && "quick_buy" === theme.settings.quickBuy && this.quickView.setAttribute($i, this.variant)
            }
            replaceImages() {
                if (this.imageSecondary = this.outer.querySelector(mi), this.outer.removeAttribute(Vi), !this.imageReplace && this.element.hasAttribute(Bi) && this.outer.setAttribute(Vi, parseInt(this.element.getAttribute(Bi))), this.imageReplace && this.gridImage && this.imageId) {
                    this.gridImage.setAttribute(Ni, this.imageId), this.gridImage.hasAttribute(Wi) || this.gridImage.setAttribute(Wi, window.getComputedStyle(this.gridImage).backgroundImage);
                    const t = () => {
                        requestAnimationFrame((() => {
                            this.gridImage.style.setProperty("background-image", this.imageReplace), requestAnimationFrame((() => {
                                this.imageSecondary.classList.remove(qi)
                            }))
                        })), this.imageSecondary.removeEventListener("animationend", t)
                    };
                    requestAnimationFrame((() => {
                        this.imageSecondary.classList.add(qi), this.imageSecondary.style.setProperty("background-image", this.imageReplace)
                    })), this.imageSecondary.addEventListener("animationend", t)
                }
                "image" === theme.settings.productGridHover && (this.hoverImages = this.outer.querySelectorAll(gi)), this.hoverImages.length > 1 && this.hoverImages.forEach((t => {
                    t.classList.remove(Ci), t.getAttribute($i) === this.variant ? t.classList.add(Ci) : this.hoverImages[0].classList.add(Ci)
                }))
            }
            constructor(t) {
                this.element = t, this.swatchLink = this.element.nextElementSibling, this.colorString = t.getAttribute(xi), this.image = this.element.getAttribute(Mi), this.imageId = this.element.getAttribute(Oi), this.variant = this.element.getAttribute(_i), this.outer = this.element.closest(pi), this.gridImage = null, this.imageDefault = null, this.hoverImages = [], this.loadHovers = null;
                const e = new class {
                    getColor() {
                        return this.match
                    }
                    init() {
                        return $t({
                            json: theme.assets.swatches
                        }).then((t => this.matchColors(t, this.settings.color))).catch((t => {
                            console.log("failed to load swatch colors script"), console.log(t)
                        }))
                    }
                    matchColors(t, e) {
                        let i = "#E5E5E5",
                            s = null;
                        const o = theme.assets.base || "/",
                            n = e.toLowerCase().replace(/\s/g, ""),
                            r = t.colors;
                        if (r) {
                            let t = null;
                            if (r.filter(((e, i) => {
                                    if (Object.keys(e).toString().toLowerCase().replace(/\s/g, "") === n) return t = i, e
                                })).length && null !== t) {
                                const e = Object.values(r[t])[0];
                                i = e, (e.includes(".jpg") || e.includes(".jpeg") || e.includes(".png") || e.includes(".svg")) && (s = `${o}${e}`, i = "#888888")
                            }
                        }
                        return {
                            color: this.settings.color,
                            path: s,
                            hex: i
                        }
                    }
                    constructor(t = {}) {
                        this.settings = {...di, ...t
                        }, this.match = this.init()
                    }
                }({
                    color: this.colorString
                });
                e.getColor().then((t => {
                    this.colorMatch = t, this.init()
                }))
            }
        },
        Gi = class extends HTMLElement {
            init() {
                this.swatchElements = this.querySelectorAll(ui), this.swatchElements.forEach((t => {
                    new Qi(t)
                }))
            }
            constructor() {
                super(), this.handle = this.getAttribute(Di), this.label = this.getAttribute(Hi).trim().toLowerCase(),
                    function(t) {
                        const e = `${theme.routes.root}products/${t}.js`;
                        return window.fetch(e).then((t => t.json())).catch((t => {
                            console.error(t)
                        }))
                    }(this.handle).then((t => {
                        this.product = t, this.colorOption = t.options.find((t => t.name.toLowerCase() === this.label || null)), this.colorOption && (this.swatches = this.colorOption.values, this.init())
                    }));
                const t = this.closest(Ei),
                    e = this.querySelector(wi);
                null == e || e.addEventListener("click", (() => {
                    this.classList.add(Fi)
                })), null == t || t.addEventListener("touchstart", (t => {
                    this.contains(t.target) || this.classList.remove(Fi)
                }))
            }
        },
        Xi = class {
            checkSwatchesHeight(t) {
                const e = t.querySelector(Li),
                    i = t.querySelector(ki),
                    s = parseInt(window.getComputedStyle(t).getPropertyValue("padding-top")),
                    o = parseInt(window.getComputedStyle(e).getPropertyValue("margin-bottom")),
                    n = parseInt(window.getComputedStyle(i).getPropertyValue("margin-bottom")),
                    r = t.closest(Ai);
                r.classList.remove(Ii), t.offsetHeight - s > e.offsetHeight + o + 2 * i.offsetHeight + 2 * n && (t.style.setProperty("--swatches-max-height", `${t.offsetHeight}px`), r.classList.add(Ii))
            }
            onUnload() {
                this.swatchesContainers.forEach((t => {
                    document.removeEventListener("theme:resize:width", this.checkSwatchesHeightOnResize)
                }))
            }
            constructor(t) {
                this.container = t, this.swatchesContainers = this.container.querySelectorAll(Si), this.swatchesContainers.forEach((t => {
                    this.checkSwatchesHeightOnResize = () => this.checkSwatchesHeight(t), this.checkSwatchesHeight(t), document.addEventListener("theme:resize:width", this.checkSwatchesHeightOnResize)
                }))
            }
        };
    const Ji = t => {
            ji = [];
            t.querySelectorAll(ui).forEach((t => {
                ji.push(new Qi(t))
            }))
        },
        Yi = {
            onLoad() {
                Ji(this.container)
            }
        },
        Zi = {
            onLoad() {
                Ki[this.id] = new Xi(this.container)
            }, onUnload() {
                Ki[this.id].onUnload()
            }
        },
        ts = "[data-slider]",
        es = "[data-product-media-container]",
        is = "[data-product-media-slideshow]",
        ss = "[data-product-media-slideshow-slide]",
        os = "[data-product-slideshow-progress]",
        ns = ".flickity-button",
        rs = "[data-product]",
        as = "[data-popup-close]",
        ls = "fill",
        cs = "js-quick-view-visible",
        hs = {};
    let ds = class {
        productGridSlideshow() {
            const t = this.container.querySelectorAll(is),
                i = this.container.querySelectorAll(es);
            t.length && t.forEach((t => {
                const i = t.closest(es),
                    s = i.querySelector(os),
                    o = t.querySelectorAll(ss).length,
                    n = 2200,
                    r = !this.sliders.length;
                let a = new e.data(t),
                    l = 0,
                    c = ss;
                !a.isActive && o > 1 && (a = new e(t, {
                    draggable: r,
                    cellSelector: c,
                    contain: !0,
                    wrapAround: !0,
                    imagesLoaded: !0,
                    lazyLoad: !0,
                    pageDots: !1,
                    prevNextButtons: !1,
                    adaptiveHeight: !1,
                    pauseAutoPlayOnHover: !1,
                    selectedAttraction: .2,
                    friction: 1,
                    on: {
                        ready: () => {
                            this.container.style.setProperty("--autoplay-speed", "2200ms")
                        },
                        change: () => {
                            l && clearTimeout(l), s.classList.remove(ls), requestAnimationFrame((() => {
                                s.classList.add(ls)
                            })), l = setTimeout((() => {
                                s.classList.remove(ls)
                            }), n)
                        },
                        dragEnd: () => {
                            a.playPlayer()
                        }
                    }
                }), window.theme.touch || (i.addEventListener("mouseenter", (() => {
                    s.classList.add(ls), l && clearTimeout(l), l = setTimeout((() => {
                        s.classList.remove(ls)
                    }), n), a.options.autoPlay = n, a.playPlayer()
                })), i.addEventListener("mouseleave", (() => {
                    a.stopPlayer(), l && clearTimeout(l), s.classList.remove(ls)
                }))))
            })), i.length && i.forEach((t => {
                t.addEventListener("click", (t => {
                    t.target.matches(ns) && t.preventDefault()
                }))
            }))
        }
        popupClose() {
            const t = document.querySelector(rs);
            if (t) {
                t.querySelector(as).dispatchEvent(new Event("click"))
            }
        }
        onBlockSelect() {
            this.body.classList.contains(cs) && this.popupClose()
        }
        onDeselect() {
            this.body.classList.contains(cs) && this.popupClose()
        }
        onUnload() {
            this.body.classList.contains(cs) && this.popupClose()
        }
        constructor(t) {
            this.container = t, this.body = document.body, this.sliders = this.container.querySelectorAll(ts), "slideshow" !== theme.settings.productGridHover || window.theme.touch || this.productGridSlideshow(), new Fl(this.container)
        }
    };
    const us = {
            onLoad() {
                hs[this.id] = new ds(this.container)
            }, onBlockSelect() {
                hs[this.id].onBlockSelect()
            }, onDeselect() {
                hs[this.id].onDeselect()
            }, onUnload() {
                hs[this.id].onUnload()
            }
        },
        ps = "#AjaxinateLoop",
        ms = "#AjaxinatePagination",
        gs = "data-ajaxinate-id",
        vs = "is-loaded";
    let ys = {},
        fs = class {
            init() {
                this.loadMoreFix(), this.ajaxinateContainer = this.container.querySelectorAll(ps), this.ajaxinateContainer.forEach((t => {
                    const e = `${ps}[${gs}="${t.dataset.ajaxinateId}"]`,
                        i = `${ms}[${gs}="${t.dataset.ajaxinateId}"]`;
                    if (t.children.length > 0) {
                        const o = new s({
                            container: e,
                            pagination: i,
                            method: "scroll"
                        });
                        t.classList.add(vs), this.endlessScroll.push(o)
                    }
                }))
            }
            update(t) {
                this.ajaxinateContainer = this.container.querySelectorAll(ps);
                const e = e => e.settings.container === t,
                    i = this.endlessScroll.find(e);
                if (i) {
                    const t = this.endlessScroll.findIndex(e);
                    this.endlessScroll.splice(t, 1), i.settings.method = "scroll", i.destroy()
                }
                const o = [...this.ajaxinateContainer].find((e => `${ps}[${gs}="${e.dataset.ajaxinateId}"]` === t));
                if (!o) return;
                const n = `${ps}[${gs}="${o.dataset.ajaxinateId}"]`,
                    r = `${ms}[${gs}="${o.dataset.ajaxinateId}"]`;
                if (!(o.children.length > 0)) return;
                const a = new s({
                    container: n,
                    pagination: r,
                    method: "scroll"
                });
                o.classList.add(vs), this.endlessScroll.push(a)
            }
            loadMoreFix() {
                s.prototype.loadMore = function() {
                    this.request = new XMLHttpRequest, this.request.onreadystatechange = function() {
                        if (!this.request.responseXML) return;
                        if (4 === !this.request.readyState || 200 === !this.request.status) return;
                        const t = this.request.responseXML.querySelector(this.settings.container),
                            e = this.request.responseXML.querySelector(this.settings.pagination);
                        this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML), null == e ? this.removePaginationElement() : (this.paginationElement.innerHTML = e.innerHTML, this.settings.callback && "function" == typeof this.settings.callback && this.settings.callback(this.request.responseXML), this.initialize())
                    }.bind(this), this.request.open("GET", this.nextPageUrl, !0), this.request.responseType = "document", this.request.send()
                }
            }
            unload() {
                this.endlessScroll.length > 0 && (this.endlessScroll.forEach((t => {
                    t.settings.method = "scroll", t.destroy()
                })), this.ajaxinateContainer.forEach((t => t.classList.remove(vs))))
            }
            constructor(t) {
                this.container = t, this.endlessScroll = [], theme.settings.enableInfinityScroll && this.init()
            }
        };
    const bs = {
            onLoad() {
                ys = new fs(this.container)
            }, onUnload: function() {
                "function" == typeof ys.unload && ys.unload()
            }
        },
        ws = 300,
        Es = "[data-toggle-filters]",
        Ss = "[data-close-filters]",
        Ls = "[data-open-filters]",
        ks = "[data-collection-wrapper]",
        As = "[data-collapsible-trigger]",
        qs = "[data-sort-toggle]",
        Cs = "[data-collection-sort-options]",
        Ts = "[data-input-sort]",
        Ps = "[data-collection-filters]",
        Fs = "[data-collection-filters-list]",
        Is = "[data-collection-sticky-bar]",
        xs = "[data-collection-filter]",
        Ds = "[data-collection-filter-tag]",
        Hs = "[data-collection-filter-tag-button]",
        Ms = "[data-collection-filters-form]",
        Os = "[data-filter-reset-button]",
        _s = "[data-filter-tag-reset-button]",
        Bs = '[data-section-type="popups"]',
        $s = "[data-collection-products]",
        zs = "[data-products-count]",
        Rs = "[data-field-price-min]",
        Vs = "[data-field-price-max]",
        Ws = "[data-se-min-value]",
        Ns = "[data-se-max-value]",
        Us = "data-se-min-value",
        js = "data-se-max-value",
        Ks = "data-se-min",
        Qs = "data-se-max",
        Gs = "[data-tooltip]",
        Xs = "[data-show-more]",
        Js = "[data-show-more-actions]",
        Ys = "[data-show-more-container]",
        Zs = "[data-show-more-trigger]",
        to = "[data-search-performed]",
        eo = "[data-search-form]",
        io = "[data-custom-scrollbar]",
        so = "is-active",
        oo = "is-expanded",
        no = "is-loading",
        ro = "popup--visible",
        ao = "collection__filters--visible",
        lo = "collection__sort__option-wrapper--visible",
        co = "data-filter-active",
        ho = "data-prevent-scroll-lock",
        uo = "data-filters-default-state",
        po = "tabindex",
        mo = "aria-expanded",
        go = "data-current-type",
        vo = {};
    let yo = class {
        initFacetedFilters() {
            "tag" != this.filterMode && "group" != this.filterMode && this.enableFilters && (this.rangeSlider = new class {
                init() {
                    if (this.slider = this.container.querySelector(Ve), !this.slider) return;
                    this.resizeFilters = n(this.reset.bind(this), 50), this.onMoveEvent = t => this.onMove(t), this.onStopEvent = t => this.onStop(t), this.onStartEvent = t => this.onStart(t), this.startX = 0, this.x = 0, this.touchLeft = this.slider.querySelector(We), this.touchRight = this.slider.querySelector(Ne), this.lineSpan = this.slider.querySelector(Ue), this.min = parseFloat(this.slider.getAttribute(Ke)), this.max = parseFloat(this.slider.getAttribute(Qe)), this.step = 0, this.normalizeFact = 20;
                    let t = this.min;
                    this.slider.hasAttribute(Ge) && (t = parseFloat(this.slider.getAttribute(Ge)));
                    let e = this.max;
                    this.slider.hasAttribute(Xe) && (e = parseFloat(this.slider.getAttribute(Xe))), t < this.min && (t = this.min), e > this.max && (e = this.max), t > e && (t = e), this.slider.getAttribute(Je) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(Je)))), this.reset(), window.addEventListener("theme:resize", this.resizeFilters), this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth, this.selectedTouch = null, this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact, this.setMinValue(t), this.setMaxValue(e), this.touchLeft.addEventListener("mousedown", this.onStartEvent), this.touchRight.addEventListener("mousedown", this.onStartEvent), this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
                        passive: !0
                    }), this.touchRight.addEventListener("touchstart", this.onStartEvent, {
                        passive: !0
                    }), this.slider.classList.add(ei)
                }
                reset() {
                    this.touchLeft.style.left = "0px", this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px", this.lineSpan.style.marginLeft = "0px", this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px", this.startX = 0, this.x = 0, this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth, this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact
                }
                setMinValue(t) {
                    const e = (t - this.min) / (this.max - this.min);
                    this.touchLeft.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.slider.setAttribute(Ge, t)
                }
                setMaxValue(t) {
                    const e = (t - this.min) / (this.max - this.min);
                    this.touchRight.style.left = Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact) + "px", this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.slider.setAttribute(Xe, t)
                }
                onStart(t) {
                    t.preventDefault();
                    let e = t;
                    t.touches && (e = t.touches[0]), t.currentTarget === this.touchLeft ? this.x = this.touchLeft.offsetLeft : t.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft), this.startX = e.pageX - this.x, this.selectedTouch = t.currentTarget, document.addEventListener("mousemove", this.onMoveEvent), document.addEventListener("mouseup", this.onStopEvent), document.addEventListener("touchmove", this.onMoveEvent, {
                        passive: !0
                    }), document.addEventListener("touchend", this.onStopEvent, {
                        passive: !0
                    })
                }
                onMove(t) {
                    let e = t;
                    t.touches && (e = t.touches[0]), this.x = e.pageX - this.startX, this.selectedTouch === this.touchLeft ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 ? this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10 : this.x < 0 && (this.x = 0), this.selectedTouch.style.left = this.x + "px") : this.selectedTouch === this.touchRight && (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 ? this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10 : this.x > this.maxX && (this.x = this.maxX), this.selectedTouch.style.left = this.x + "px"), this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px", this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px", this.calculateValue(), this.slider.getAttribute("on-change") && new Function("min, max", this.slider.getAttribute("on-change"))(this.slider.getAttribute(Ge), this.slider.getAttribute(Xe)), this.onChange(this.slider.getAttribute(Ge), this.slider.getAttribute(Xe))
                }
                onStop(t) {
                    document.removeEventListener("mousemove", this.onMoveEvent), document.removeEventListener("mouseup", this.onStopEvent), document.removeEventListener("touchmove", this.onMoveEvent, {
                        passive: !0
                    }), document.removeEventListener("touchend", this.onStopEvent, {
                        passive: !0
                    }), this.selectedTouch = null, this.calculateValue(), this.onChanged(this.slider.getAttribute(Ge), this.slider.getAttribute(Xe))
                }
                onChange(t, e) {
                    const i = this.slider.closest(je);
                    if (i) {
                        const s = i.querySelector(Ze),
                            o = i.querySelector(ti);
                        s && o && (s.value = parseInt(t), o.value = parseInt(e))
                    }
                }
                onChanged(t, e) {
                    this.slider.hasAttribute(Ye) && this.slider.dispatchEvent(new CustomEvent("theme:filter:range-update", {
                        bubbles: !0
                    }))
                }
                calculateValue() {
                    const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
                    let e = this.lineSpan.offsetLeft / this.initialValue,
                        i = e + t;
                    if (e = e * (this.max - this.min) + this.min, i = i * (this.max - this.min) + this.min, 0 !== this.step) {
                        let t = Math.floor(e / this.step);
                        e = this.step * t, t = Math.floor(i / this.step), i = this.step * t
                    }
                    this.selectedTouch === this.touchLeft && this.slider.setAttribute(Ge, e), this.selectedTouch === this.touchRight && this.slider.setAttribute(Xe, i)
                }
                unload() {
                    document.removeEventListener("theme:filters:init", this.initListener), window.removeEventListener("theme:resize", this.resizeFilters)
                }
                constructor(t) {
                    this.container = t, this.init(), this.initListener = () => this.init(), document.addEventListener("theme:filters:init", this.initListener)
                }
            }(this.container))
        }
        initTooltips() {
            var t, e;
            (this.tooltips = this.container.querySelectorAll(Gs), window.innerWidth < theme.sizes.small) && (this.tooltips = null === (e = this.productGrid) || void 0 === e ? void 0 : e.querySelectorAll(Gs));
            null === (t = this.tooltips) || void 0 === t || t.forEach((t => {
                new ze(t)
            }))
        }
        updateRange() {
            const t = this.filtersForm.querySelector(Ws),
                e = this.filtersForm.querySelector(Ns),
                i = this.filtersForm.querySelector(Rs),
                s = this.filtersForm.querySelector(Vs);
            if (t.hasAttribute(Us) && e.hasAttribute(js)) {
                const o = parseFloat(i.placeholder, 10),
                    n = parseFloat(s.placeholder, 10),
                    r = parseFloat(t.getAttribute(Us), 10),
                    a = parseFloat(e.getAttribute(js), 10);
                o === r && n === a || (i.value = parseInt(r), s.value = parseInt(a), this.filtersForm.dispatchEvent(new Event("input", {
                    bubbles: !0
                })))
            }
        }
        onSubmitHandler(t) {
            t.preventDefault();
            const e = new FormData(this.filtersForm),
                i = new URLSearchParams(e),
                s = [];
            let o = "";
            this.isSearchPage && (this.searchForm = this.container.querySelector(eo), this.currentType = this.container.getAttribute(go));
            const n = this.filtersForm.querySelector(Ws),
                r = this.filtersForm.querySelector(Ns),
                a = this.filtersForm.querySelector(Rs),
                l = this.filtersForm.querySelector(Vs);
            if (n && r && a && l && n.hasAttribute(Ks) && r.hasAttribute(Qs)) {
                const t = parseFloat(n.getAttribute(Ks), 10),
                    e = parseFloat(r.getAttribute(Qs), 10),
                    o = a.value ? parseFloat(a.value, 10) : t,
                    c = l.value ? parseFloat(l.value, 10) : e;
                o <= t && c >= e && (s.push("filter.v.price.gte"), s.push("filter.v.price.lte"), i.delete("filter.v.price.gte"), i.delete("filter.v.price.lte"))
            }
            if (o = i.toString(), this.isSearchPage) {
                o = Se(this.searchForm, this.filtersForm, s);
                let t = "";
                "all" === this.currentType && (t = "&type=product"), o.indexOf("&type=product") > -1 && (t = ""), o += t
            }
            this.renderSection(o, t)
        }
        onHistoryChange(t) {
            var e;
            if (!this.filters) return;
            let i = (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) || "";
            if (this.isSearchPage) {
                t.state || (i = window.location.search);
                if (!(i.indexOf("type=product") > -1)) return
            }
            this.renderSection(i, null, !1)
        }
        renderSection(t, e, i = !0) {
            this.startLoading();
            const s = `${window.location.pathname}?section_id=${this.sectionId}&${t}`,
                o = t => t.url === s;
            this.filterData.some(o) ? this.renderSectionFromCache(o, e) : this.renderSectionFromFetch(s, e), i && this.updateURLHash(t)
        }
        renderSectionFromFetch(t) {
            fetch(t).then((t => t.text())).then((e => {
                const i = e;
                this.filterData = [...this.filterData, {
                    html: i,
                    url: t
                }], this.inputSort = this.container.querySelectorAll(Ts), this.renderFilters(i), this.bindFilterButtonsEvents(), this.hideFiltersOnMobile(), this.renderProductGrid(i), this.updateProductsCount(i), this.finishLoading(), this.mobileFiltersScrollLock(), this.handleSearchPageActiveTab()
            }))
        }
        renderSectionFromCache(t, e) {
            const i = this.filterData.find(t).html;
            this.renderFilters(i, e), this.hideFiltersOnMobile(), this.renderProductGrid(i), this.updateProductsCount(i), this.finishLoading(), this.mobileFiltersScrollLock(), this.handleSearchPageActiveTab()
        }
        handleSearchPageActiveTab() {
            this.isSearchPage && (this.scrollable = this.container.querySelector(io), this.scrollable && !this.customScrollbar && (this.customScrollbar = new Ce(this.container)))
        }
        renderProductGrid(t) {
            const e = (new DOMParser).parseFromString(t, "text/html").querySelector($s);
            e && (this.productGrid.innerHTML = e.innerHTML, this.initProductGridEvents(theme.settings.enableInfinityScroll), this.filterShowMore())
        }
        updateProductsCount(t) {
            const e = (new DOMParser).parseFromString(t, "text/html").querySelector(zs);
            e && (this.productsCount.innerHTML = e.innerHTML)
        }
        renderFilters(t) {
            const e = (new DOMParser).parseFromString(t, "text/html").querySelector(Ps);
            e && (this.filters.innerHTML = e.innerHTML, this.filtersForm = document.querySelector(Ms), this.bindFilterButtonsEvents(), this.bindToggleButtonsEvents(), Ji(this.container), this.collapsible = new Ct(this.container), document.dispatchEvent(new CustomEvent("theme:filters:init", {
                bubbles: !0
            })))
        }
        updateURLHash(t) {
            history.pushState({
                searchParams: t
            }, "", `${window.location.pathname}${t&&"?".concat(t)}`)
        }
        bindFilterButtonsEvents() {
            this.inputSort.length > 0 && this.inputSort.forEach((t => {
                t.addEventListener("change", this.updateCollectionFormSortEvent)
            })), this.filtersForm && (this.filtersForm.addEventListener("input", this.debouncedSubmitEvent.bind(this)), this.filtersForm.addEventListener("theme:filter:range-update", this.updateRangeEvent)), this.collectionSortOptions && this.collectionSortOptions.addEventListener("keyup", this.onTabHandlerEvent), "tag" != this.filterMode && "group" != this.filterMode && this.enableFilters && this.container.querySelectorAll(Os).forEach((t => {
                t.addEventListener("click", this.onFilterResetClick, {
                    once: !0
                })
            }))
        }
        onFilterResetClick(t) {
            t.preventDefault(), this.renderSection(new URL(t.currentTarget.href).searchParams.toString())
        }
        bindToggleButtonsEvents() {
            var t;
            this.container.querySelectorAll(Es).forEach((t => {
                t.addEventListener("click", this.onFilterToggleClick)
            })), this.container.querySelectorAll(Ss).forEach((t => {
                t.addEventListener("click", this.hideFiltersDrawer)
            })), this.container.querySelectorAll(Ls).forEach((t => {
                t.addEventListener("click", this.showFiltersDrawer)
            })), null === (t = this.container.querySelector(ks)) || void 0 === t || t.addEventListener("keyup", this.onKeyUpHandler)
        }
        onTabHandler(t) {
            if (t.code === theme.keyboardKeys.SPACE || t.code === theme.keyboardKeys.ENTER || t.code === theme.keyboardKeys.NUMPADENTER) {
                const e = t.target.previousElementSibling.value;
                this.filtersForm.querySelectorAll(Ts).forEach((t => {
                    t.checked && (t.checked = !1), t.value === e && (t.checked = !0)
                })), this.filtersForm.dispatchEvent(new Event("input", {
                    bubbles: !0
                })), t.target.dispatchEvent(new Event("click", {
                    bubbles: !0
                }))
            }
        }
        onKeyUpHandler(t) {
            t.code === theme.keyboardKeys.ESCAPE && this.hideFiltersDrawer()
        }
        onFilterToggleClick(t) {
            t.preventDefault(), b();
            this.filters.classList.contains(ao) ? this.hideFiltersDrawer() : this.showFiltersDrawer()
        }
        sortDropdownToggle() {
            this.collectionSortOptions && this.collectionSortOptions.classList.toggle(lo)
        }
        bodyClick(t) {
            if (!this.collectionSortOptions) return;
            const e = this.sortToggle.contains(t.target);
            this.collectionSortOptions.classList.contains(lo) && !e && this.sortDropdownToggle()
        }
        updateCollectionFormSort(t) {
            const e = t.target,
                i = e.value,
                s = e.closest(Cs);
            this.container.querySelectorAll(Ts).forEach((t => {
                t.value === i && (t.checked = !0)
            })), null !== s && this.filtersForm.dispatchEvent(new Event("input", {
                bubbles: !0
            }))
        }
        showFiltersDrawer() {
            this.a11y.state.trigger = document.querySelector(Es), this.a11y.trapFocus({
                container: this.filters
            }), this.mobileFiltersScrollLock()
        }
        mobileFiltersScrollLock() {
            if (window.innerWidth < theme.sizes.small) {
                const t = document.querySelector(Fs);
                this.filters.classList.contains(ao) || this.filters.classList.add(ao), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                    bubbles: !0,
                    detail: t
                }))
            }
        }
        hideFiltersOnMobile() {
            const t = this.container.querySelectorAll(`${As}:not(${Zs})`);
            window.innerWidth < theme.sizes.small && requestAnimationFrame((() => {
                t.forEach((t => {
                    const e = "true" === t.getAttribute(co);
                    t.classList.contains(oo) && !e && t.dispatchEvent(new Event("click"))
                }))
            }))
        }
        showFiltersOnDesktop() {
            const t = this.container.querySelectorAll(`${As}:not(${Zs})`),
                e = this.container.getAttribute(uo),
                i = "first-open" === e,
                s = "open" === e,
                o = "closed" === e,
                n = this.enableSorting ? 1 : 0;
            t.forEach(((t, e) => {
                const r = t.classList.contains(oo),
                    a = "true" === t.getAttribute(co),
                    l = a && !r && s;
                a && !l || (o && r || i && (!r && e === n) || i && (r && e !== n) || s && !r || l) && t.dispatchEvent(new Event("click"))
            }))
        }
        hideFiltersDrawer() {
            let t = this.filters.classList.contains(ao),
                e = this.container.classList.contains(no);
            t && (this.filters.classList.remove(ao), this.a11y.removeTrapFocus()), e || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0,
                detail: ws
            }))
        }
        filtersResizeEvents() {
            window.innerWidth >= theme.sizes.small ? (this.showFiltersOnDesktop(), this.hideFiltersDrawer()) : this.hideFiltersOnMobile()
        }
        filterShowMore() {
            this.showMore = this.container.querySelectorAll(Xs), 0 !== this.showMore.length && this.showMore.forEach((t => {
                const e = t.querySelector(As),
                    i = t.querySelector(Js);
                if (!i) return;
                const s = i.querySelector(Zs),
                    o = i.querySelector(Ys),
                    n = o.querySelectorAll(window.theme.focusable);
                "true" === o.getAttribute(mo) || n.forEach((t => {
                    t.setAttribute(po, "-1")
                })), s.addEventListener("keyup", (t => {
                    t.code !== theme.keyboardKeys.SPACE && t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER || this.updateShowMoreFocusableElements(t, n)
                })), s.addEventListener("click", (t => {
                    this.updateShowMoreFocusableElements(t, n)
                })), e.addEventListener("keyup", (t => {
                    t.code !== theme.keyboardKeys.SPACE && t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER || this.updateCollapsedContainerFocusableElements(e, s, n)
                })), e.addEventListener("click", (() => {
                    this.updateCollapsedContainerFocusableElements(e, s, n)
                }))
            }))
        }
        updateCollapsedContainerFocusableElements(t, e, i) {
            requestAnimationFrame((() => {
                const s = "true" === t.getAttribute(mo),
                    o = "true" === e.getAttribute(mo);
                i.forEach((t => {
                    !s && o && t.setAttribute(po, "-1"), s && o && t.removeAttribute(po)
                }))
            }))
        }
        updateShowMoreFocusableElements(t, e) {
            requestAnimationFrame((() => {
                requestAnimationFrame((() => {
                    const i = "true" === t.target.getAttribute(mo);
                    e.forEach(((t, e) => {
                        if (i) return t.removeAttribute(po), void(0 === e && t.focus());
                        t.setAttribute(po, "-1")
                    }))
                }))
            }))
        }
        initTagFilters() {
            "tag" != this.filterMode && "group" != this.filterMode || !this.enableFilters || (this.tags = this.container.dataset.tags.split("+").filter((t => t)), this.bindFilterTagButtonsEvents(), this.bindSortChangeEvent())
        }
        renderTagFiltersProducts(t) {
            this.startLoading(), "object" == typeof this.endlessCollection && this.endlessCollection.unload(), fetch(t).then((t => t.text())).then((e => {
                const i = e,
                    s = (new DOMParser).parseFromString(i, "text/html"),
                    o = s.querySelector($s).innerHTML,
                    n = s.querySelector(Ps).innerHTML;
                this.productGrid.innerHTML = o, this.filters.innerHTML = n, this.inputSort = this.container.querySelectorAll(Ts), this.filtersForm = document.querySelector(Ms), this.filterData = [...this.filterData, {
                    html: i,
                    url: t
                }], this.alreadyClicked = !1, this.bindFilterTagButtonsEvents(), this.bindFilterButtonsEvents(), this.bindSortChangeEvent(), this.bindToggleButtonsEvents(), this.initProductGridEvents(theme.settings.enableInfinityScroll), this.updateProductsCount(i), this.mobileFiltersScrollLock(), this.hideFiltersOnMobile(), Ji(this.container), this.collapsible = new Ct(this.container), this.filterShowMore(), history.replaceState && window.history.pushState({
                    path: t
                }, "", t)
            })).catch((t => {
                this.finishLoading(), console.log(`Error: ${t}`)
            }))
        }
        bindFilterTagButtonsEvents() {
            this.container.querySelectorAll(Hs).forEach((t => {
                t.addEventListener("click", this.onFilterTagButtonClick.bind(this))
            })), this.container.querySelectorAll(_s).forEach((t => {
                t.addEventListener("click", this.onFilterTagClearClick)
            })), this.container.querySelectorAll(Os).forEach((t => {
                t.addEventListener("click", this.onFilterTagResetClick)
            }))
        }
        bindSortChangeEvent() {
            this.container.querySelectorAll(Ts).forEach((t => {
                t.addEventListener("input", this.debouncedSortEvent.bind(this))
            }))
        }
        onFilterTagButtonClick(t) {
            if (t.preventDefault(), this.alreadyClicked) return;
            this.alreadyClicked = !0;
            const e = t.currentTarget,
                i = e.dataset.tag;
            if (e.parentNode.classList.contains(so)) {
                let t = this.tags.indexOf(i);
                e.parentNode.classList.remove(so), t > -1 && this.tags.splice(t, 1)
            } else e.parentNode.classList.add(so), this.tags.push(i);
            let s = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
            this.container.querySelector(xs).classList.remove(oo), this.container.querySelector(xs).setAttribute(mo, !1), this.container.setAttribute("data-tags", "[" + this.tags + "]"), this.renderTagFiltersProducts(s)
        }
        onFilterTagClearClick(t) {
            if (t.preventDefault(), this.alreadyClicked) return;
            this.alreadyClicked = !0;
            const e = t.currentTarget.dataset.tag,
                i = this.tags.indexOf(e);
            i > -1 && this.tags.splice(i, 1);
            const s = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
            this.container.setAttribute("data-tags", "[" + this.tags + "]"), this.renderTagFiltersProducts(s)
        }
        onSortChange() {
            let t = this.collectionHandle + "/" + this.tags.join("+") + "?sort_by=" + this.getSortValue();
            this.renderTagFiltersProducts(t)
        }
        getSortValue() {
            let t = "";
            return this.inputSort.forEach((e => {
                e.checked && (t = e.value)
            })), t
        }
        onFilterTagResetClick(t) {
            if (null == t || t.preventDefault(), this.alreadyClicked) return;
            this.alreadyClicked = !0, this.container.querySelectorAll(Ds).forEach((t => {
                t.classList.remove(so)
            })), this.container.querySelectorAll(xs).forEach((t => {
                t.classList.remove(oo), t.setAttribute(mo, !1)
            })), this.tags = [], this.container.setAttribute("data-tags", "");
            let e = this.collectionHandle + "/?sort_by=" + this.getSortValue();
            this.renderTagFiltersProducts(e)
        }
        getProductsOffsetTop() {
            return this.productGrid.getBoundingClientRect().top - document.body.getBoundingClientRect().top - this.filtersStickyBar.offsetHeight
        }
        getStickyBarOffsetTop() {
            return this.filtersStickyBar.getBoundingClientRect().top - document.body.getBoundingClientRect().top
        }
        initProductGridEvents(t) {
            if (t) return this.initInfinityScroll(), void this.initProductGridEvents(!1);
            this.productGridEvents = new ds(this.container), this.initTooltips(), setTimeout((() => {
                this.finishLoading()
            }), 1.5 * ws)
        }
        initInfinityScroll() {
            if (this.isSearchPage) {
                if (!this.enableFilters) return;
                document.dispatchEvent(new CustomEvent("theme:tab:ajaxinate", {
                    bubbles: !0,
                    detail: "product"
                }))
            } else "object" == typeof this.endlessCollection && this.endlessCollection.unload(), this.endlessCollection = new fs(this.container), 0 !== this.endlessCollection.endlessScroll.length && (this.endlessCollection.endlessScroll[0].settings.callback = () => this.initProductGridEvents(!1))
        }
        startLoading() {
            this.container.classList.add(no), window.innerWidth >= theme.sizes.small && document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            }));
            let t = this.getProductsOffsetTop();
            window.scrollTo({
                top: t,
                left: 0,
                behavior: "smooth"
            })
        }
        finishLoading() {
            const t = document.querySelectorAll(`${Bs} .${ro}`),
                e = t.length > 0;
            if (this.container.classList.remove(no), e) {
                let e = 0;
                [...t].forEach((t => {
                    t.hasAttribute(ho) && (e += 1)
                })), e === t.length && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0,
                    detail: ws
                }))
            } else window.innerWidth >= theme.sizes.small && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0,
                detail: ws
            }))
        }
        onDeselect() {
            this.productGridEvents && this.productGridEvents.onDeselect()
        }
        onUnload() {
            "object" == typeof this.endlessCollection && this.endlessCollection.unload(), this.productGridEvents && this.productGridEvents.onUnload(), this.collapsible && this.collapsible.onUnload(), this.rangeSlider && this.rangeSlider.unload(), this.filters && document.removeEventListener("theme:resize:width", this.resizeEvent), document.removeEventListener("click", this.bodyClickEvent), this.groupTagFilters.length > 0 && this.onFilterTagResetClick(), this.finishLoading()
        }
        constructor(t) {
            var e;
            this.container = t, this.sectionId = t.dataset.sectionId, this.enableFilters = "true" === t.dataset.enableFilters, this.enableSorting = "true" === t.dataset.enableSorting, this.filterMode = t.dataset.filterMode, this.collectionHandle = this.container.dataset.collection, this.isSearchPage = null != t.closest(to), this.productGrid = this.container.querySelector($s), this.productsCount = this.container.querySelector(zs), this.groupTagFilters = this.container.querySelectorAll(xs), this.filters = this.container.querySelector(Ps), this.filterTriggers = this.container.querySelectorAll(As), this.filtersStickyBar = this.container.querySelector(Is), this.filtersForm = this.container.querySelector(Ms), this.inputSort = this.container.querySelectorAll(Ts), this.sortToggle = this.container.querySelector(qs), this.collectionSortOptions = this.container.querySelector(Cs), this.a11y = _t, this.filterData = [], this.rangeSlider = null, this.sortDropdownEvent = () => this.sortDropdownToggle(), this.onTabHandlerEvent = t => this.onTabHandler(t), this.updateCollectionFormSortEvent = t => this.updateCollectionFormSort(t), this.bodyClickEvent = t => this.bodyClick(t), this.onFilterResetClick = this.onFilterResetClick.bind(this), this.onFilterTagResetClick = this.onFilterTagResetClick.bind(this), this.onFilterTagClearClick = this.onFilterTagClearClick.bind(this), this.onFilterToggleClick = this.onFilterToggleClick.bind(this), this.onKeyUpHandler = this.onKeyUpHandler.bind(this), this.updateRangeEvent = this.updateRange.bind(this), this.debouncedSubmitEvent = n((t => {
                this.onSubmitHandler(t)
            }), 500), this.debouncedSortEvent = n((t => {
                this.onSortChange(t)
            }), 500), this.productGridEvents = {}, this.filters && (this.hideFiltersDrawer = this.hideFiltersDrawer.bind(this), this.showFiltersDrawer = this.showFiltersDrawer.bind(this), this.resizeEvent = n((() => {
                this.filtersResizeEvents()
            }), 500), this.filtersResizeEvents(), document.addEventListener("theme:resize:width", this.resizeEvent)), this.initTagFilters(), this.initFacetedFilters(), this.bindToggleButtonsEvents(), this.bindFilterButtonsEvents(), this.initProductGridEvents(theme.settings.enableInfinityScroll), Ji(this.container), this.collapsible = new Ct(this.container), b(), window.addEventListener("popstate", this.onHistoryChange.bind(this)), null === (e = this.sortToggle) || void 0 === e || e.addEventListener("click", this.sortDropdownEvent), document.addEventListener("click", this.bodyClickEvent), this.filterShowMore()
        }
    };
    const fo = {
            onLoad() {
                vo[this.id] = new yo(this.container)
            }, onDeselect() {
                vo[this.id].onDeselect()
            }, onUnload() {
                vo[this.id].onUnload()
            }
        },
        bo = "[data-tabs-link]",
        wo = "[data-tab]",
        Eo = "[data-tab-ref]",
        So = "[data-custom-scrollbar]",
        Lo = "[data-custom-scrollbar-holder]",
        ko = "[data-slider]",
        Ao = "[data-tabs-contents]",
        qo = "[data-search-form]",
        Co = "[data-all-types-container]",
        To = "[data-collection-filters-form]",
        Po = "[data-current-page]",
        Fo = "[data-tooltip]",
        Io = "[data-collection-products]",
        xo = "#AjaxinateLoop",
        Do = "current",
        Ho = "hide",
        Mo = "alt",
        Oo = "aos-animate",
        _o = "aos-init",
        Bo = "is-loaded",
        $o = "data-tabs-link",
        zo = "data-tab",
        Ro = "data-tab-ref",
        Vo = "data-start-index",
        Wo = "data-search-performed",
        No = "data-type",
        Uo = "data-current-type",
        jo = "data-all-types",
        Ko = "data-current-page",
        Qo = "data-ajaxinate-id",
        Go = {};
    let Xo = class {
        assignSearchPageArguments() {
            this.isSearchPage && (this.searchForm = this.container.querySelector(qo), this.searchFormData = new FormData(this.searchForm), this.searchTerm = encodeURIComponent(this.searchFormData.get("q")), this.currentType = this.container.getAttribute(Uo), this.sectionId = this.container.dataset.sectionId, this.searchForAllTypes = "true" === this.container.getAttribute(jo), this.fetchURL = "", this.searchParams = "", this.cachedResults = {}, this.handleTabsHistory(), this.infiniteScrollListener(), this.initInfinityScroll(this.currentType))
        }
        init() {
            const t = this.container.querySelectorAll(bo),
                e = this.container.querySelector(`[${$o}="${this.container.hasAttribute(Vo)?this.container.getAttribute(Vo):0}"]`),
                i = this.container.querySelector(`[${zo}="${this.container.hasAttribute(Vo)?this.container.getAttribute(Vo):0}"]`);
            null == i || i.classList.add(Do), null == e || e.classList.add(Do), this.checkVisibleTabsLinks(), t.forEach((t => {
                this.handleTabsNavListeners(t)
            }))
        }
        handleTabsHistory() {
            window.addEventListener("popstate", this.onHistoryChange.bind(this)), this.openTabFromHistoryEvent = t => this.openTabFromHistory(t), this.tabsLink.forEach((t => {
                t.addEventListener("theme:tab:open-from-history", this.openTabFromHistoryEvent)
            }))
        }
        handleTabsNavListeners(t) {
            const e = t.getAttribute($o),
                i = this.container.querySelector(`[${zo}="${e}"]`);
            i && (t.addEventListener("click", (e => {
                this.isSearchPage && this.handleURLSearchParams(e, !0), this.tabChange(t, i)
            })), t.addEventListener("keyup", (e => {
                e.code !== theme.keyboardKeys.SPACE && e.code !== theme.keyboardKeys.ENTER && e.code !== theme.keyboardKeys.NUMPADENTER || (this.isSearchPage && this.handleURLSearchParams(e, !0), this.tabChange(t, i))
            })))
        }
        openTabFromHistory(t) {
            const e = t.target,
                i = this.container.querySelector(t.detail.element).getAttribute($o),
                s = this.container.querySelector(`[${zo}="${i}"]`);
            s && (this.handleURLSearchParams(t, !1), this.tabChange(e, s))
        }
        handleURLSearchParams(t, e = !0) {
            const i = t.target.matches(bo) ? t.target : t.target.closest(bo),
                s = i.getAttribute(No),
                o = i.getAttribute($o),
                n = this.container.querySelector(`[${zo}="${o}"]`).querySelector(Po),
                r = document.querySelector(To);
            let a = n ? `&page=${n.getAttribute(Ko)}` : "";
            if (this.searchParams = Se(this.searchForm, r, [], s), "product" === s) {
                const t = this.searchParams.replace("&type=product", "");
                this.searchParams = `${t}&type=product`
            } else this.searchParams = `q=${this.searchTerm}&type=${s}`;
            theme.settings.enableInfinityScroll || "" === a || (this.searchParams += a), this.fetchURL = `${theme.routes.searchUrl}?${this.searchParams}&section_id=${this.sectionId}`, e && history.pushState({
                searchParams: this.searchParams
            }, "", `${window.location.pathname}${this.searchParams&&"?".concat(this.searchParams)}`)
        }
        tabChangeFetchContent(t, e) {
            const i = t.getAttribute(No),
                s = t.getAttribute($o),
                o = this.container.querySelector(`[${zo}="${s}"]`),
                n = this.currentType === i;
            if (this.cachedResults[s] || n) return "product" !== i || this.searchFilters || (this.searchFilters = new yo(this.container)), void requestAnimationFrame((() => {
                this.handleActiveTabClasses(t, e), this.scrollToCurrentTabLink(t), this.triggerTabAnimations(e), this.checkVisibleTabsLinks(), this.updateAjaxify(e, i)
            }));
            fetch(this.fetchURL).then((t => {
                if (!t.ok) {
                    throw new Error(t.status)
                }
                return t.text()
            })).then((n => {
                const r = (new DOMParser).parseFromString(n, "text/html").querySelector(`[${zo}="${s}"]`).innerHTML;
                var a;
                this.searchForAllTypes && (null === (a = this.container.querySelector(Co)) || void 0 === a || a.remove());
                this.cachedResults[s] = r, o.innerHTML = r, "product" !== i || this.searchFilters || (this.searchFilters = new yo(this.container)), requestAnimationFrame((() => {
                    this.handleActiveTabClasses(t, e), this.scrollToCurrentTabLink(t), this.triggerTabAnimations(e), this.checkVisibleTabsLinks(), this.initInfinityScroll(i)
                }))
            })).catch((t => {
                throw t
            }))
        }
        onHistoryChange(t) {
            var e;
            const i = (null === (e = t.state) || void 0 === e ? void 0 : e.searchParams) || window.location.search,
                s = i.indexOf("type=product") > -1,
                o = i.indexOf("type=article") > -1,
                n = i.indexOf("type=page") > -1,
                r = s || o || n,
                a = this.container.querySelector(`${bo}[${No}="product"]`),
                l = this.container.querySelector(`${bo}[${No}="article"]`),
                c = this.container.querySelector(`${bo}[${No}="page"]`);
            r ? (s && (null == a || a.dispatchEvent(new CustomEvent("theme:tab:open-from-history", {
                bubbles: !0,
                detail: {
                    element: `[${No}="product"]`
                }
            }))), o && (null == l || l.dispatchEvent(new CustomEvent("theme:tab:open-from-history", {
                bubbles: !0,
                detail: {
                    element: `[${No}="article"]`
                }
            }))), n && (null == c || c.dispatchEvent(new CustomEvent("theme:tab:open-from-history", {
                bubbles: !0,
                detail: {
                    element: `[${No}="page"]`
                }
            })))) : window.location = i
        }
        initCustomScrollbar() {
            this.scrollable && !this.customScrollbar && (this.customScrollbar = new Ce(this.container))
        }
        infiniteScrollListener() {
            theme.settings.enableInfinityScroll && (this.ajaxifyFromFiltersEvent = t => this.ajaxifyFromFilters(t), document.addEventListener("theme:tab:ajaxinate", this.ajaxifyFromFiltersEvent))
        }
        ajaxifyFromFilters(t) {
            this.initInfinityScroll(t.detail)
        }
        initInfinityScroll(t) {
            if (!theme.settings.enableInfinityScroll) return;
            if (0 === this.container.querySelectorAll(xo).length) return;
            const e = this.container.querySelector(`${wo}.${Do}`),
                i = null == e ? void 0 : e.querySelector(xo),
                s = null == i ? void 0 : i.classList.contains(Bo);
            e ? (!i && this.endlessCollection && this.updateAjaxinateInstancesSettings(t), i && !s && this.initAjaxyfy(t)) : this.initAjaxyfy(t)
        }
        updateAjaxinateInstancesSettings(t) {
            setTimeout((() => {
                if (0 === this.endlessCollection.endlessScroll.length) return;
                [...this.endlessCollection.endlessScroll].forEach((t => {
                    const e = t.containerElement,
                        i = [...this.tab].find((t => t.classList.contains(Do)));
                    !(null !== e.closest(`${wo}.${Do}`)) && i && (t.settings.method = "click")
                }));
                const e = () => this.initProductGridEvents();
                if ("product" === t || "all" === t) {
                    const t = t => t.settings.container.indexOf("resultsProducts") > -1 || t.settings.container.indexOf("allTypes") > -1,
                        i = [...this.endlessCollection.endlessScroll].find(t);
                    if (!i) return;
                    i.settings.callback = e
                }
            }))
        }
        initAjaxyfy(t) {
            if ("object" != typeof this.endlessCollection) return this.endlessCollection = new fs(this.container), void this.updateAjaxinateInstancesSettings(t);
            this.endlessCollection.endlessScroll.length > 0 && (this.endlessCollection.unload(), this.endlessCollection = new fs(this.container), this.updateAjaxinateInstancesSettings(t))
        }
        updateAjaxify(t, e) {
            var i;
            if (0 === (null === (i = this.endlessCollection) || void 0 === i ? void 0 : i.endlessScroll.length)) return;
            const s = t.querySelector(xo),
                o = `${xo}[${Qo}="${null==s?void 0:s.dataset.ajaxinateId}"]`;
            s && (this.endlessCollection.update(o), this.updateAjaxinateInstancesSettings(e))
        }
        initProductGridEvents() {
            this.productGridEvents = new ds(this.container), this.initTooltips()
        }
        initTooltips() {
            var t, e;
            (this.tooltips = this.container.querySelectorAll(Fo), this.productGrid = this.container.querySelector(Io), window.innerWidth < theme.sizes.small) && (this.tooltips = null === (e = this.productGrid) || void 0 === e ? void 0 : e.querySelectorAll(Fo));
            null === (t = this.tooltips) || void 0 === t || t.forEach((t => {
                new ze(t)
            }))
        }
        tabChange(t, e) {
            t.classList.contains(Do) || (this.isSearchPage ? this.tabChangeFetchContent(t, e) : (this.handleActiveTabClasses(t, e), this.scrollToCurrentTabLink(t), this.triggerTabAnimations(e), this.handleTabSliders(e), this.checkVisibleTabsLinks()))
        }
        handleActiveTabClasses(t, e) {
            var i;
            const s = this.container.querySelector(`${wo}.${Do}`),
                o = this.container.querySelector(`${bo}.${Do}`);
            null == s || s.classList.remove(Do), null == o || o.classList.remove(Do), t.classList.add(Do), e.classList.add(Do), t.classList.contains(Ho) && e.classList.add(Ho), null === (i = this.tabRef) || void 0 === i || i.forEach((t => {
                const i = t.classList.contains(Do),
                    s = t.getAttribute(Ro) === e.getAttribute(zo);
                t.classList.toggle(Do, !i && s)
            }))
        }
        scrollToCurrentTabLink(t) {
            const e = t.closest(Lo) ? t.closest(Lo) : t.parentElement,
                i = parseInt(window.getComputedStyle(e).getPropertyValue("padding-left"));
            e.scrollTo({
                top: 0,
                left: t.offsetLeft - e.offsetWidth / 2 + t.offsetWidth / 2 + i,
                behavior: "smooth"
            }), t.dispatchEvent(new CustomEvent("theme:custom-scrollbar:change", {
                bubbles: !0,
                detail: {
                    element: t
                }
            }))
        }
        triggerTabAnimations(t) {
            "false" != theme.settings.animations && (this.tabsContents.querySelectorAll(`.${_o}`).forEach((t => {
                t.classList.remove(Oo)
            })), this.animateElementsTimer && clearTimeout(this.animateElementsTimer), this.animateElementsTimer = setTimeout((() => {
                t.querySelectorAll(`.${_o}`).forEach((t => {
                    t.classList.add(Oo)
                }))
            }), 150))
        }
        handleTabSliders(t) {
            const e = t.querySelector(ko);
            e && e.dispatchEvent(new CustomEvent("theme:tab:change", {
                bubbles: !1
            }))
        }
        checkVisibleTabsLinks() {
            const t = this.container.querySelectorAll(bo),
                e = this.container.querySelectorAll(`${bo}.${Ho}`);
            t.length - e.length < 2 ? this.container.classList.add(Mo) : this.container.classList.remove(Mo)
        }
        onBlockSelect(t) {
            const e = t.target;
            e && (e.dispatchEvent(new Event("click")), e.parentNode.scrollTo({
                top: 0,
                left: e.offsetLeft - e.clientWidth,
                behavior: "smooth"
            }))
        }
        onUnload() {
            this.customScrollbar && this.customScrollbar.unload(), this.isSearchPage && theme.settings.enableInfinityScroll && document.removeEventListener("theme:tab:ajaxinate", this.ajaxifyFromFiltersEvent)
        }
        constructor(t) {
            this.container = t, this.tabsContents = t.querySelector(Ao), this.animateElementsTimer = null, this.isSearchPage = null != t.closest(`[${Wo}="true"]`), this.container && (this.scrollable = this.container.querySelector(So), this.tabRef = this.container.querySelectorAll(Eo), this.tabsLink = this.container.querySelectorAll(bo), this.tab = this.container.querySelectorAll(wo), this.assignSearchPageArguments(), this.init(), this.initCustomScrollbar())
        }
    };
    const Jo = {
            onLoad() {
                Go[this.id] = new Xo(this.container)
            }, onBlockSelect(t) {
                Go[this.id].onBlockSelect(t)
            }, onUnload() {
                Go[this.id].onUnload()
            }
        },
        Yo = "[data-drawer]",
        Zo = "[data-drawer-toggle]",
        tn = "[data-scroll]",
        en = "[data-quick-view-item]",
        sn = "is-open",
        on = "js-drawer-open",
        nn = "cv-h",
        rn = "site-header",
        an = "aria-expanded",
        ln = "aria-controls";
    let cn = {},
        hn = class {
            initListeners() {
                this.drawerToggleButtons.forEach((t => {
                    t.addEventListener("click", this.drawerToggleEvent)
                })), this.drawers.forEach((t => {
                    t.addEventListener("keyup", this.keyPressCloseEvent), this.collapsible = new Ct(t), this.tabs = new Xo(t)
                })), document.addEventListener("click", this.drawerCloseEvent), document.addEventListener("theme:drawer:closing", this.drawerCloseEvent)
            }
            toggle(t) {
                t.preventDefault();
                const e = document.querySelector(`#${t.target.getAttribute(ln)}`);
                if (!e) return;
                e.classList.contains(sn) ? this.close() : this.open(t)
            }
            open(t) {
                const e = t.target,
                    i = document.querySelector(`#${t.target.getAttribute(ln)}`);
                if (!i) return;
                const s = i.querySelector(tn) || i;
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                    bubbles: !0,
                    detail: s
                })), document.dispatchEvent(new CustomEvent("theme:drawer:open"), {
                    bubbles: !0
                }), document.body.classList.add(on), i.classList.add(sn), i.classList.remove(nn), e.setAttribute(an, !0), setTimeout((() => {
                    this.a11y.state.trigger = e, this.a11y.trapFocus({
                        container: i
                    })
                }))
            }
            close() {
                if (!document.body.classList.contains(on)) return;
                const t = document.querySelector(`${Yo}.${sn}`);
                this.drawerToggleButtons.forEach((t => {
                    t.setAttribute(an, !1)
                })), this.a11y.removeTrapFocus({
                    container: t
                }), t.classList.remove(sn);
                const e = i => {
                    i.target === t && (requestAnimationFrame((() => {
                        t.classList.add(nn), document.dispatchEvent(new CustomEvent("theme:drawer:close"), {
                            bubbles: !0
                        }), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                            bubbles: !0
                        }))
                    })), t.removeEventListener("transitionend", e))
                };
                t.addEventListener("transitionend", e), document.body.classList.remove(on)
            }
            onUnload() {
                this.close(), this.drawerToggleButtons.forEach((t => {
                    t.removeEventListener("click", this.drawerToggleEvent)
                })), this.drawers.forEach((t => {
                    t.removeEventListener("keyup", this.keyPressCloseEvent)
                })), document.removeEventListener("click", this.drawerCloseEvent), document.removeEventListener("theme:drawer:closing", this.drawerCloseEvent), this.collapsible && this.collapsible.onUnload(), this.tabs && this.tabs.onUnload()
            }
            constructor(t) {
                this.container = t, this.drawers = this.container.querySelectorAll(Yo), this.drawerToggleButtons = this.container.querySelectorAll(Zo), this.a11y = _t, this.drawerToggleEvent = gt((t => {
                    this.toggle(t)
                }), 150), this.keyPressCloseEvent = gt((t => {
                    t.code === theme.keyboardKeys.ESCAPE && this.close(t)
                }), 150), this.drawerCloseEvent = t => {
                    const e = document.querySelector(`${Yo}.${sn}`);
                    let i = !1;
                    if (!e) return;
                    "click" === t.type && (i = t.target.matches(Zo));
                    const s = !!e && e.contains(t.target),
                        o = e.closest(en),
                        n = !!o && o.contains(t.target);
                    i || s || n || this.close()
                }, this.initListeners()
            }
        };
    const dn = {
            onLoad() {
                this.container.classList.contains(rn) && (this.container = this.container.parentNode), cn[this.id] = new hn(this.container)
            }, onUnload() {
                cn[this.id].onUnload()
            }
        },
        un = (t, e = !1, i = "block") => {
            t && (e ? t.style.removeProperty("display") : t.style.display = i)
        },
        pn = t => {
            t && (t.style.display = "none")
        },
        mn = "[data-header-sticky]",
        gn = "[data-header-height]",
        vn = "[data-store-availability-list]",
        yn = {
            close: ".js-modal-close",
            open: ".js-modal-open-store-availability-modal",
            openClass: "modal--is-active",
            openBodyClass: "modal--is-visible",
            closeModalOnClick: !1,
            scrollIntoView: !1
        };
    const fn = "body",
        bn = "[data-store-availability-modal]",
        wn = "[data-store-availability-modal-open]",
        En = "[data-store-availability-modal-close]",
        Sn = "[data-store-availability-modal-product__title]",
        Ln = "store-availabilities-modal--active";
    const kn = "[data-product-form]",
        An = "[data-option-position]",
        qn = '[name^="options"], [data-popout-option]',
        Cn = "sold-out",
        Tn = "unavailable",
        Pn = "data-option-position",
        Fn = "data-value";
    const In = 1,
        xn = "data-notification-popup",
        Dn = {
            history: !1,
            focus: !1,
            mainClass: "pswp--notification pswp--not-close-btn",
            closeOnVerticalDrag: !1
        };
    let Hn = class {
        init() {
            const t = [{
                html: this.notificationPopupHtml
            }];
            this.a11y.state.trigger = this.button, new dl(t, Dn, In)
        }
        constructor(t) {
            this.button = t, this.a11y = _t, this.notificationPopupHtml = this.button.getAttribute(xn), "" !== this.notificationPopupHtml.trim() && this.init()
        }
    };
    const Mn = "[data-product]",
        On = "[data-product-form]",
        _n = "[data-add-to-cart]",
        Bn = "[data-add-to-cart-text]",
        $n = "[data-buy-it-now]",
        zn = "[data-compare-price]",
        Rn = "[data-form-wrapper]",
        Vn = "[data-site-header]",
        Wn = "[data-product-select]",
        Nn = "_preorder",
        Un = "[data-price-wrapper]",
        jn = "[data-price-off]",
        Kn = "[data-price-off-type]",
        Qn = "[data-price-off-amount]",
        Gn = "[data-product-slide]",
        Xn = "[data-product-image]",
        Jn = "[data-product-single-media-slider]",
        Yn = "[data-product-json]",
        Zn = "[data-product-price]",
        tr = "[data-product-unit-price]",
        er = "[data-product-base]",
        ir = "[data-product-unit]",
        sr = "[data-subscription-watch-price]",
        or = "[data-subscription-selectors]",
        nr = "[data-toggles-group]",
        rr = "data-group-toggle",
        ar = "[data-plan-description]",
        lr = "[data-remaining-count]",
        cr = "[data-remaining-wrapper]",
        hr = "[data-product-remaining-json]",
        dr = "[data-store-availability-container]",
        ur = "[data-upsell-btn]",
        pr = ".shopify-section",
        mr = "[data-quick-view-item]",
        gr = "[data-notification-button-text]",
        vr = "[data-swatches-container]",
        yr = "[data-swatches-more]",
        fr = "[data-option-position]",
        br = "hidden",
        wr = "variant--soldout",
        Er = "variant--unavailabe",
        Sr = "product__price--sale",
        Lr = "product__price--hidden",
        kr = "count-is-low",
        Ar = "count-is-in",
        qr = "count-is-out",
        Cr = "count-is-unavailable",
        Tr = "selector-wrapper--visible",
        Pr = "data-image-id",
        Fr = "data-tall-layout",
        Ir = "data-enable-history-state",
        xr = "data-notification-popup",
        Dr = "data-swatch-variant";
    let Hr = class {
        init() {
            let t = null;
            const e = this.container.querySelector(Yn);
            e && (t = e.innerHTML), t ? (this.productJSON = JSON.parse(t), this.linkForm(), this.sellout = new class {
                init() {
                    this.update()
                }
                update() {
                    this.getCurrentState(), this.optionElements.forEach((t => {
                        const e = t.value || t.getAttribute(Fn),
                            i = t.closest(An);
                        if (!i) return;
                        const s = i.getAttribute(Pn),
                            o = parseInt(s, 10) - 1;
                        let n = [...this.selections];
                        n[o] = e;
                        const r = this.productJSON.variants.find((t => {
                            let e = !0;
                            for (let i = 0; i < n.length; i++) t.options[i] !== n[i] && (e = !1);
                            return e
                        }));
                        t.parentElement.classList.remove(Cn, Tn), void 0 === r ? t.parentElement.classList.add(Tn) : !1 === (null == r ? void 0 : r.available) && t.parentElement.classList.add(Cn)
                    }))
                }
                getCurrentState() {
                    for (var t of(this.formData = new FormData(this.form), this.selections = [], this.formData.entries())) t[0].includes("options[") && this.selections.push(t[1])
                }
                constructor(t, e) {
                    this.container = t, this.productJSON = e, this.form = this.container.querySelector(kn), this.formData = new FormData(this.form), this.optionElements = this.container.querySelectorAll(qn), this.productJSON && this.form && this.init()
                }
            }(this.container, this.productJSON)) : console.error("Missing product JSON")
        }
        destroy() {
            this.productForm.destroy()
        }
        linkForm() {
            this.productForm = new class {
                destroy() {
                    this._listeners.removeAll()
                }
                options() {
                    return this._serializeInputValues(this.optionInputs, (function(t) {
                        return t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2], t
                    }))
                }
                variant() {
                    const t = this.options();
                    return t.length ? oi(this.product, t) : this.product.variants[0]
                }
                plan(t) {
                    let e = {
                        allocation: null,
                        group: null,
                        detail: null
                    };
                    const i = new FormData(this.form).get("selling_plan");
                    return i && t && (e.allocation = t.selling_plan_allocations.find((function(t) {
                        return t.selling_plan_id.toString() === i.toString()
                    }))), e.allocation && (e.group = this.product.selling_plan_groups.find((function(t) {
                        return t.id.toString() === e.allocation.selling_plan_group_id.toString()
                    }))), e.group && (e.detail = e.group.selling_plans.find((function(t) {
                        return t.id.toString() === i.toString()
                    }))), e && e.allocation && e.detail && e.allocation ? e : null
                }
                properties() {
                    return this._serializeInputValues(this.propertyInputs, (function(t) {
                        return t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2], t
                    }))
                }
                quantity() {
                    return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1
                }
                getFormState() {
                    const t = this.variant();
                    return {
                        options: this.options(),
                        variant: t,
                        properties: this.properties(),
                        quantity: this.quantity(),
                        plan: this.plan(t)
                    }
                }
                _setIdInputValue(t) {
                    t && t.id ? this.variantElement.value = t.id.toString() : this.variantElement.value = "", this.variantElement.dispatchEvent(new Event("change"))
                }
                _onSubmit(t, e) {
                    e.dataset = this.getFormState(), t.onFormSubmit && t.onFormSubmit(e)
                }
                _onOptionChange(t) {
                    this._setIdInputValue(t.dataset.variant)
                }
                _onFormEvent(t) {
                    return void 0 === t ? Function.prototype.bind() : function(e) {
                        e.dataset = this.getFormState(), this._setIdInputValue(e.dataset.variant), t(e)
                    }.bind(this)
                }
                _initInputs(t, e) {
                    return Array.prototype.slice.call(this.element.querySelectorAll(t)).map(function(t) {
                        return this._listeners.add(t, "change", this._onFormEvent(e)), t
                    }.bind(this))
                }
                _serializeInputValues(t, e) {
                    return t.reduce((function(t, i) {
                        return (i.checked || "radio" !== i.type && "checkbox" !== i.type) && t.push(e({
                            name: i.name,
                            value: i.value
                        })), t
                    }), [])
                }
                _validateProductObject(t) {
                    if ("object" != typeof t) throw new TypeError(t + " is not an object.");
                    if (void 0 === t.variants[0].options) throw new TypeError("Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route");
                    return t
                }
                constructor(t, e, i) {
                    this.element = t, this.form = "FORM" == this.element.tagName ? this.element : this.element.querySelector("form"), this.product = this._validateProductObject(e), this.variantElement = this.element.querySelector(ri), i = i || {}, this._listeners = new si, this._listeners.add(this.element, "submit", this._onSubmit.bind(this, i)), this.optionInputs = this._initInputs(li, i.onOptionChange), this.planInputs = this._initInputs(ai, i.onPlanChange), this.quantityInputs = this._initInputs(ci, i.onQuantityChange), this.propertyInputs = this._initInputs(hi, i.onPropertyChange)
                }
            }(this.productForm, this.productJSON, {
                onOptionChange: this.onOptionChange.bind(this),
                onPlanChange: this.onPlanChange.bind(this)
            });
            const t = this.productForm.getFormState();
            if (this.pushState(t, !0), this.subsToggleListeners(), this.swatchesContainer) {
                this.observeSwatch(t);
                const e = this.swatchesContainer.closest(fr),
                    i = e.querySelector(yr);
                null == i || i.addEventListener("click", (t => {
                    t.preventDefault(), e.classList.contains(Tr) ? e.classList.remove(Tr) : e.classList.add(Tr)
                }))
            }
        }
        onOptionChange(t) {
            this.pushState(t.dataset), this.updateProductImage(t)
        }
        onPlanChange(t) {
            this.subPrices && this.pushState(t.dataset)
        }
        pushState(t, e = !1) {
            var i;
            this.productState = this.setProductState(t), this.updateAddToCartState(t), this.updateProductPrices(t), this.updateSaleText(t), this.updateSubscriptionText(t), this.fireHookEvent(t), this.updateRemaining(t), null === (i = this.sellout) || void 0 === i || i.update(t), this.enableHistoryState && !e && this.updateHistoryState(t), this.storeAvailability && (t.variant ? this.storeAvailability.updateContent(t.variant.id, this.productForm.product.title) : this.storeAvailability.clearContent())
        }
        updateAddToCartState(t) {
            const e = t.variant,
                i = this.container.querySelectorAll(Un),
                s = this.container.querySelectorAll(_n),
                o = this.container.querySelectorAll(Bn),
                n = this.container.querySelectorAll(Rn),
                r = this.container.querySelector($n);
            let a = theme.strings.add_to_cart;
            this.productJSON.tags.includes(Nn) && (a = theme.strings.preorder), null == i || i.forEach((t => {
                t.classList.toggle(Lr, !e)
            })), null == s || s.forEach((t => {
                var i;
                if (t.matches(ur)) return;
                if (t.disabled = !0, null == r || r.classList.add(br), !e) return;
                if (t.disabled = !1, e.available && (null == r || r.classList.remove(br)), !t.hasAttribute(xr)) return;
                const s = t.id.replace("AddToCart", "NotificationForm"),
                    o = this.sessionStorage.getItem("notification_form_id");
                let n = !1,
                    a = e.id,
                    l = e.title;
                if (o) {
                    const t = o.substring(0, o.lastIndexOf("--")),
                        e = o.split("--").slice(-1)[0];
                    n = s === t, n && (this.latestVariantId = a, this.latestVariantTitle = l, a = Number(e), this.productJSON.variants.forEach((t => {
                        t.id === a && (l = t.title)
                    })))
                }
                let c = t.getAttribute(xr);
                const h = null === (i = (new DOMParser).parseFromString(c, "text/html").querySelector(gr)) || void 0 === i ? void 0 : i.innerHTML;
                if ("" != this.latestVariantId && "" != this.latestVariantTitle) {
                    var d;
                    c = c.replaceAll(this.latestVariantId, a), c = c.replaceAll(this.latestVariantTitle, l);
                    const t = null === (d = (new DOMParser).parseFromString(c, "text/html").querySelector(gr)) || void 0 === d ? void 0 : d.innerHTML;
                    c = c.replace(t, h)
                }
                t.setAttribute(xr, c), n && (this.scrollToForm(this.product.closest(pr)), new Hn(t)), this.latestVariantId = a, this.latestVariantTitle = l
            })), null == o || o.forEach((t => {
                if (e) {
                    if (e.available) t.innerHTML = a;
                    else if (t.innerHTML = theme.strings.sold_out, t.parentNode.hasAttribute(xr)) {
                        if (t.closest(mr)) return;
                        t.innerHTML = `${theme.strings.sold_out} - ${theme.strings.newsletter_product_availability}`
                    }
                } else t.innerHTML = theme.strings.unavailable
            })), null == n || n.forEach((t => {
                if (!e) return t.classList.add(Er), void t.classList.remove(wr);
                const i = t.querySelector(Wn);
                if (i && (i.value = e.id), !e.available) return t.classList.add(wr), void t.classList.remove(Er);
                t.classList.remove(wr, Er)
            }))
        }
        updateHistoryState(t) {
            const e = t.variant,
                i = t.plan,
                s = window.location.href;
            if (e && s.includes("/product")) {
                const t = new window.URL(s),
                    o = t.searchParams;
                o.set("variant", e.id), i && i.detail && i.detail.id && this.productState.hasPlan ? o.set("selling_plan", i.detail.id) : o.delete("selling_plan"), t.search = o.toString();
                const n = t.toString();
                window.history.replaceState({
                    path: n
                }, "", n)
            }
        }
        updateRemaining(t) {
            const e = t.variant,
                i = [Ar, qr, Cr, kr];
            if (e && this.remainingWrapper && this.remainingJSON) {
                const t = this.remainingJSON[e.id];
                ("out" === t || t < 1) && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(qr)), ("in" === t || t >= this.remainingMaxInt) && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(Ar)), ("low" === t || t > 0 && t < this.remainingMaxInt) && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(kr), this.remainingCount && (this.remainingCount.innerHTML = t))
            } else !e && this.remainingWrapper && (this.remainingWrapper.classList.remove(...i), this.remainingWrapper.classList.add(Cr))
        }
        getBaseUnit(t) {
            return 1 === t.unit_price_measurement.reference_value ? t.unit_price_measurement.reference_unit : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit
        }
        subsToggleListeners() {
            this.container.querySelectorAll(nr).forEach((t => {
                t.addEventListener("change", function(t) {
                    const e = t.target.value.toString(),
                        i = this.container.querySelector(`[${rr}="${e}"]`),
                        s = this.container.querySelectorAll(`[${rr}]`);
                    if (i) {
                        i.classList.remove(br);
                        const t = i.querySelector('[name="selling_plan"]');
                        t.checked = !0, t.dispatchEvent(new Event("change"))
                    }
                    s.forEach((t => {
                        if (t !== i) {
                            t.classList.add(br);
                            t.querySelectorAll('[name="selling_plan"]').forEach((t => {
                                t.checked = !1, t.dispatchEvent(new Event("change"))
                            }))
                        }
                    }))
                }.bind(this))
            }))
        }
        updateSaleText(t) {
            this.productState.planSale ? this.updateSaleTextSubscription(t) : this.productState.onSale ? this.updateSaleTextStandard(t) : this.priceOffWrap && this.priceOffWrap.classList.add(br)
        }
        updateSaleTextStandard(t) {
            if (!this.priceOffType) return;
            this.priceOffType.innerHTML = window.theme.strings.sale_badge_text || "sale";
            const e = t.variant;
            if (window.theme.settings.savingBadgeType && "percentage" === window.theme.settings.savingBadgeType) {
                const t = (e.compare_at_price - e.price) / e.compare_at_price,
                    i = Math.floor(100 * t);
                this.priceOffAmount.innerHTML = `${i}%`
            } else {
                const t = e.compare_at_price - e.price;
                this.priceOffAmount.innerHTML = i.formatMoney(t, theme.moneyFormat)
            }
            this.priceOffWrap.classList.remove(br)
        }
        updateSaleTextSubscription(t) {
            const e = t.variant,
                s = this.productForm.product.selling_plan_groups.find((t => t.id === e.selling_plan_allocations[0].selling_plan_group_id)),
                o = t.plan ? t.plan.detail.price_adjustments[0] : s.selling_plans[0].price_adjustments[0],
                n = o.value || 0,
                r = "percentage" === o.value_type ? `${n}%` : i.formatMoney(e.price - n, theme.moneyFormat);
            this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton", this.priceOffAmount.innerHTML = r, this.priceOffWrap.classList.remove(br)
        }
        updateSubscriptionText(t) {
            t.plan && this.planDecription && null !== t.plan.detail.description ? (this.planDecription.innerHTML = t.plan.detail.description, this.planDecription.classList.remove(br)) : this.planDecription && this.planDecription.classList.add(br)
        }
        updateProductPrices(t) {
            const e = t.variant,
                s = t.plan;
            this.container.querySelectorAll(Un).forEach((t => {
                const o = t.querySelector(zn),
                    n = t.querySelector(Zn);
                let r = "",
                    a = "";
                if (this.productState.available && (r = e.compare_at_price, a = e.price), this.productState.hasPlan) {
                    a = s ? s.allocation.price : e.selling_plan_allocations[0].per_delivery_price
                }
                if (this.productState.planSale) {
                    const t = s ? s.allocation.price : e.selling_plan_allocations[0].per_delivery_price;
                    r = s ? s.allocation.compare_at_price : e.selling_plan_allocations[0].compare_at_price, a = t
                }
                o && (this.productState.onSale || this.productState.planSale ? (o.classList.remove(br), n.classList.add(Sr)) : (o.classList.add(br), n.classList.remove(Sr)), o.innerHTML = theme.settings.currency_code_enable ? i.formatMoney(r, theme.moneyWithCurrencyFormat) : i.formatMoney(r, theme.moneyFormat)), n.innerHTML = 0 === a ? window.theme.strings.free : theme.settings.currency_code_enable ? i.formatMoney(a, theme.moneyWithCurrencyFormat) : i.formatMoney(a, theme.moneyFormat)
            })), this.hasUnitPricing && this.updateProductUnits(t)
        }
        updateProductUnits(t) {
            const e = t.variant,
                s = t.plan;
            let o = null;
            if (e && e.unit_price && (o = e.unit_price), s && (null == s ? void 0 : s.allocation) && (null == s ? void 0 : s.allocation.unit_price) && (o = s.allocation.unit_price), !s && e.selling_plan_allocations && e.selling_plan_allocations.length > 0) {
                o = e.selling_plan_allocations[0].unit_price
            }
            if (o) {
                const t = this.getBaseUnit(e),
                    s = 0 === o ? window.theme.strings.free : i.formatMoney(o, theme.moneyFormat);
                this.container.querySelector(tr).innerHTML = s, this.container.querySelector(er).innerHTML = t, un(this.container.querySelector(ir))
            } else pn(this.container.querySelector(ir))
        }
        fireHookEvent(t) {
            const e = t.variant;
            this.container.dispatchEvent(new CustomEvent("theme:variant:change", {
                detail: {
                    variant: e
                },
                bubbles: !0
            }))
        }
        setProductState(t) {
            const e = t.variant,
                i = t.plan,
                s = {
                    available: !0,
                    soldOut: !1,
                    onSale: !1,
                    showUnitPrice: !1,
                    requiresPlan: !1,
                    hasPlan: !1,
                    planPerDelivery: !1,
                    planSale: !1
                };
            if (e) {
                const t = e.requires_selling_plan || !1;
                e.available || (s.soldOut = !0), e.compare_at_price > e.price && (s.onSale = !0), e.unit_price && (s.showUnitPrice = !0), this.product && this.product.requires_selling_plan && (s.requiresPlan = !0), i && this.subPrices && (s.hasPlan = !0, i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0), e.price > i.allocation.price && (s.planSale = !0)), !i && t && (s.hasPlan = !0, e.selling_plan_allocations[0].per_delivery_price !== e.selling_plan_allocations[0].price && (s.planPerDelivery = !0), e.price > e.selling_plan_allocations[0].price && (s.planSale = !0))
            } else s.available = !1;
            return s
        }
        updateProductImage(t) {
            const i = t.dataset.variant;
            if (!i || !(null == i ? void 0 : i.featured_media)) return;
            const s = this.container.querySelector(`${Xn}[${Pr}="${i.featured_media.id}"]`),
                o = null == s ? void 0 : s.closest(Gn);
            if (o) {
                const t = parseInt([...o.parentElement.children].indexOf(o)),
                    n = this.container.querySelector(Jn),
                    r = e.data(n);
                if (r && r.isActive) {
                    const t = n.querySelector(`[data-id="${i.featured_media.id}"]`);
                    if (t) {
                        const e = parseInt([...t.parentNode.children].indexOf(t));
                        r.select(e)
                    }
                    return
                }
                if (this.tallLayout) {
                    const e = s.getBoundingClientRect().top;
                    if (0 === t && e + window.scrollY > window.pageYOffset) return;
                    document.dispatchEvent(new CustomEvent("theme:tooltip:close", {
                        bubbles: !1,
                        detail: {
                            hideTransition: !1
                        }
                    })), (t => {
                        const e = document.querySelector(mn) && document.querySelector(gn) ? document.querySelector(gn).getBoundingClientRect().height : 0;
                        window.scrollTo({
                            top: t + window.scrollY - e,
                            left: 0,
                            behavior: "smooth"
                        })
                    })(e)
                }
            }
        }
        observeSwatch(t) {
            const e = this.swatchesContainer.querySelector(`[${Dr}*="${t.variant.id}"]`);
            this.swatchesContainer.closest(fr).classList.remove(Tr), new IntersectionObserver(((t, e) => {
                t.forEach((t => {
                    0 == t.intersectionRatio && this.swatchesContainer.closest(fr).classList.add(Tr)
                }))
            }), {
                root: this.container,
                threshold: [.95, 1]
            }).observe(e)
        }
        scrollToForm(t) {
            var e;
            const i = null === (e = document.querySelector(Vn)) || void 0 === e ? void 0 : e.dataset.height;
            visibilityHelper.isElementPartiallyVisible(t) || visibilityHelper.isElementTotallyVisible(t) || setTimeout((() => {
                const e = t.getBoundingClientRect().top - i;
                window.scrollTo({
                    top: e,
                    left: 0,
                    behavior: "smooth"
                })
            }), 400)
        }
        constructor(t) {
            if (this.container = t, this.product = this.container.querySelector(Mn), this.productForm = this.container.querySelector(On), this.tallLayout = "true" === this.container.getAttribute(Fr), !this.product || !this.productForm) {
                return void new Ot(this.container).init()
            }
            this.storeAvailabilityContainer = this.container.querySelector(dr), this.enableHistoryState = "true" === this.container.getAttribute(Ir), this.hasUnitPricing = this.container.querySelector(ir), this.subSelectors = this.container.querySelector(or), this.subPrices = this.container.querySelector(sr), this.priceOffWrap = this.container.querySelector(jn), this.priceOffAmount = this.container.querySelector(Qn), this.priceOffType = this.container.querySelector(Kn), this.planDecription = this.container.querySelector(ar), this.swatchesContainer = this.container.querySelector(vr), this.latestVariantId = "", this.latestVariantTitle = "", this.sellout = null, this.sessionStorage = window.sessionStorage, this.remainingWrapper = this.container.querySelector(cr), this.remainingWrapper && (this.remainingMaxInt = parseInt(this.remainingWrapper.dataset.remainingMax, 10), this.remainingCount = this.container.querySelector(lr), this.remainingJSONWrapper = this.container.querySelector(hr), this.remainingJSON = null, this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML && (this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML))), this.storeAvailabilityContainer && (this.storeAvailability = new class {
                updateContent(t, e) {
                    this._fetchStoreAvailabilities(t, e)
                }
                clearContent() {
                    this.container.innerHTML = ""
                }
                _initModal() {
                    return new class {
                        init() {
                            this.openElement.addEventListener("click", this.open.bind(this)), this.modal.querySelector(this.config.close).addEventListener("click", this.closeModal.bind(this))
                        }
                        open(t) {
                            let e = !1;
                            if (t ? t.preventDefault() : e = !0, this.modalIsOpen && !e) return void this.closeModal();
                            this.modal.classList.add(this.config.openClass), this.nodes.parents.forEach((t => {
                                t.classList.add(this.config.openBodyClass)
                            })), this.modalIsOpen = !0;
                            const i = document.querySelector(vn);
                            document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                                bubbles: !0,
                                detail: i
                            })), this.config.scrollIntoView && this.scrollIntoView(), this.bindEvents(), this.a11y.trapFocus({
                                container: this.modal
                            })
                        }
                        closeModal() {
                            if (this.modalIsOpen) {
                                document.activeElement.blur(), this.modal.classList.remove(this.config.openClass);
                                var t = this;
                                this.nodes.parents.forEach((function(e) {
                                    e.classList.remove(t.config.openBodyClass)
                                })), this.modalIsOpen = !1, this.openElement.focus(), this.unbindEvents(), this.a11y.removeTrapFocus({
                                    container: this.modal
                                }), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                                    bubbles: !0,
                                    detail: 400
                                }))
                            }
                        }
                        bindEvents() {
                            this.keyupHandler = this.keyupHandler.bind(this), this.clickHandler = this.clickHandler.bind(this), document.body.addEventListener("keyup", this.keyupHandler), document.body.addEventListener("click", this.clickHandler)
                        }
                        unbindEvents() {
                            document.body.removeEventListener("keyup", this.keyupHandler), document.body.removeEventListener("click", this.clickHandler)
                        }
                        keyupHandler(t) {
                            t.code === theme.keyboardKeys.ESCAPE && this.closeModal()
                        }
                        clickHandler(t) {
                            !this.config.closeModalOnClick || this.modal.contains(t.target) || t.target.matches(this.config.open) || this.closeModal()
                        }
                        scrollIntoView() {
                            this.focusOnOpen.scrollIntoView({
                                behavior: "smooth"
                            })
                        }
                        constructor(t, e) {
                            if (this.modal = document.getElementById(t), !this.modal) return !1;
                            this.nodes = {
                                parents: [document.querySelector("html"), document.body]
                            }, this.config = Object.assign(yn, e), this.modalIsOpen = !1, this.focusOnOpen = this.config.focusOnOpen ? document.getElementById(this.config.focusOnOpen) : this.modal, this.openElement = document.querySelector(this.config.open), this.a11y = _t, this.init()
                        }
                    }("StoreAvailabilityModal", {
                        close: En,
                        open: wn,
                        closeModalOnClick: !0,
                        openClass: Ln,
                        scrollIntoView: !1
                    })
                }
                _fetchStoreAvailabilities(t, e) {
                    const i = "/variants/" + t + "/?section_id=store-availability";
                    this.clearContent();
                    const s = this;
                    fetch(i).then((function(t) {
                        return t.text()
                    })).then((function(t) {
                        const i = document.querySelector(fn);
                        let o = i.querySelector(bn);
                        o && o.remove(), s.container.innerHTML = t, s.container.innerHTML = s.container.firstElementChild.innerHTML, "" !== s.container.firstElementChild.innerHTML.trim() ? s.container.querySelector(wn) && (s.modal = s._initModal(), s._updateProductTitle(e), o = s.container.querySelector(bn), o && i.appendChild(o)) : s.clearContent()
                    }))
                }
                _updateProductTitle(t) {
                    this.container.querySelector(Sn).textContent = t
                }
                constructor(t) {
                    this.container = t
                }
            }(this.storeAvailabilityContainer));
            new Ot(this.container).init(), this.init()
        }
    };
    const Mr = {
            onLoad() {
                this.section = new Hr(this.container)
            }
        },
        Or = "form",
        _r = "[data-popout]",
        Br = "[data-popout-list]",
        $r = "[data-popout-toggle]",
        zr = "[data-popout-input]",
        Rr = "[data-popout-option]",
        Vr = "[data-popout-text]",
        Wr = "[aria-current]",
        Nr = "[data-product-image]",
        Ur = "[data-product-grid-item]",
        jr = "select-popout__list--visible",
        Kr = "select-popout--alt",
        Qr = "--current",
        Gr = "is-visible",
        Xr = "aria-current",
        Jr = "aria-expanded",
        Yr = "data-value",
        Zr = "data-popout-prevent",
        ta = "data-quantity-field",
        ea = "data-quick-view-item";
    let ia = {},
        sa = class {
            unload() {
                this.popoutOptions.length && this.popoutOptions.forEach((t => {
                    t.removeEventListener("theme:popout:click", this.popupOptionsClickEvent), t.removeEventListener("click", this._connectOptionsDispatchEvent)
                })), this.popoutToggle.removeEventListener("click", this.popupToggleClickEvent), this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusoutEvent), this.popoutList.removeEventListener("focusout", this.popupListFocusoutEvent), this.popout.removeEventListener("keyup", this.popoutKeyupEvent), document.removeEventListener("theme:cart:update", this.updatePopout), document.body.removeEventListener("click", this.bodyClick)
            }
            popupToggleClick(t) {
                const e = "true" === t.currentTarget.getAttribute(Jr);
                if (this.popoutList.closest(Ur)) {
                    const t = this.popoutList.closest(Ur).querySelector(Nr);
                    t && t.classList.toggle(Gr, !e)
                }
                t.currentTarget.setAttribute(Jr, !e), this.popoutList.classList.toggle(jr)
            }
            popupToggleFocusout(t) {
                if (!t.relatedTarget) return;
                const e = this.popout.contains(t.relatedTarget),
                    i = t.relatedTarget.hasAttribute(ea);
                e || i || this._hideList()
            }
            popupListFocusout(t) {
                const e = t.currentTarget.contains(t.relatedTarget);
                this.popoutList.classList.contains(jr) && !e && this._hideList()
            }
            popupOptionsClick(t) {
                if ("#" === t.target.closest(Rr).attributes.href.value) {
                    t.preventDefault();
                    let e = "";
                    if (t.currentTarget.getAttribute(Yr) && (e = t.currentTarget.getAttribute(Yr)), this.popoutInput.value = e, this.popoutPrevent) {
                        this.popoutInput.dispatchEvent(new Event("change")), !t.detail.preventTrigger && this.popoutInput.hasAttribute(ta) && this.popoutInput.dispatchEvent(new Event("input"));
                        const i = this.popoutList.querySelector(`[class*="${Qr}"]`);
                        let s = Qr;
                        if (i && i.classList.length)
                            for (const t of i.classList)
                                if (t.includes(Qr)) {
                                    s = t;
                                    break
                                }
                        const o = this.popoutList.querySelector(`.${s}`);
                        o && (o.classList.remove(`${s}`), t.currentTarget.parentElement.classList.add(`${s}`));
                        const n = this.popoutList.querySelector(Wr);
                        n && (n.removeAttribute(Xr), t.currentTarget.setAttribute(Xr, "true")), "" !== e && (this.popoutText.textContent = e), this.popupToggleFocusout(t), this.popupListFocusout(t)
                    } else this._submitForm(e)
                }
            }
            updatePopout() {
                const t = this.popoutList.querySelector(`[${Yr}="${this.popoutInput.value}"]`);
                t ? (t.dispatchEvent(new CustomEvent("theme:popout:click", {
                    cancelable: !0,
                    bubbles: !0,
                    detail: {
                        preventTrigger: !0
                    }
                })), t.parentElement.nextSibling || this.popout.classList.add(Kr)) : this.popout.classList.add(Kr)
            }
            popoutKeyup(t) {
                t.code === theme.keyboardKeys.ESCAPE && (this._hideList(), this.popoutToggle.focus())
            }
            bodyClick(t) {
                const e = this.popout.contains(t.target);
                this.popoutList.classList.contains(jr) && !e && this._hideList()
            }
            _connectToggle() {
                this.popoutToggle.addEventListener("click", this.popupToggleClickEvent)
            }
            _connectOptions() {
                this.popoutOptions.length && this.popoutOptions.forEach((t => {
                    t.addEventListener("theme:popout:click", this.popupOptionsClickEvent), t.addEventListener("click", this._connectOptionsDispatchEvent)
                }))
            }
            _connectOptionsDispatch(t) {
                const e = new CustomEvent("theme:popout:click", {
                    cancelable: !0,
                    bubbles: !0,
                    detail: {
                        preventTrigger: !1
                    }
                });
                t.target.dispatchEvent(e) || t.preventDefault()
            }
            _onFocusOut() {
                this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent), this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent), this.popout.addEventListener("keyup", this.popoutKeyupEvent), document.body.addEventListener("click", this.bodyClick)
            }
            _submitForm() {
                const t = this.popout.closest(Or);
                t && t.submit()
            }
            _hideList() {
                this.popoutList.classList.remove(jr), this.popoutToggle.setAttribute(Jr, !1)
            }
            constructor(t) {
                this.popout = t, this.popoutList = this.popout.querySelector(Br), this.popoutToggle = this.popout.querySelector($r), this.popoutText = this.popout.querySelector(Vr), this.popoutInput = this.popout.querySelector(zr), this.popoutOptions = this.popout.querySelectorAll(Rr), this.popoutPrevent = "true" === this.popout.getAttribute(Zr), this.popupToggleFocusoutEvent = t => this.popupToggleFocusout(t), this.popupListFocusoutEvent = t => this.popupListFocusout(t), this.popupToggleClickEvent = t => this.popupToggleClick(t), this.popoutKeyupEvent = t => this.popoutKeyup(t), this.popupOptionsClickEvent = t => this.popupOptionsClick(t), this._connectOptionsDispatchEvent = t => this._connectOptionsDispatch(t), this.bodyClick = this.bodyClick.bind(this), this.updatePopout = this.updatePopout.bind(this), this._connectOptions(), this._connectToggle(), this._onFocusOut(), this.popoutInput && this.popoutInput.hasAttribute(ta) && document.addEventListener("theme:cart:update", this.updatePopout)
            }
        };
    const oa = {
            onLoad() {
                ia[this.id] = [];
                this.container.querySelectorAll(_r).forEach((t => {
                    ia[this.id].push(new sa(t))
                }))
            }, onUnload() {
                ia[this.id].forEach((t => {
                    "function" == typeof t.unload && t.unload()
                }))
            }
        },
        na = "[data-add-to-cart]",
        ra = "[data-deferred-media]",
        aa = "[data-deferred-media-button]",
        la = "[data-popup-close]",
        ca = "[data-popout]",
        ha = "[data-quick-view-inner]",
        da = "[data-quick-view-item-holder]",
        ua = "[data-product]",
        pa = "[data-product-form]",
        ma = "[data-product-single-media-slider]",
        ga = "[data-product-single-media-wrapper]",
        va = "[data-model]",
        ya = "[data-product-json]",
        fa = "[data-quick-view-foot-inner]",
        ba = "[data-shop-the-look-thumb]",
        wa = "[data-tooltip]",
        Ea = "[data-drawer-toggle]",
        Sa = "has-media-active",
        La = "is-active",
        ka = "is-loading",
        Aa = "media--hidden",
        qa = "no-outline",
        Ca = "notification-popup-visible",
        Ta = "popup-quick-view--animate-in",
        Pa = "popup-quick-view--animate-out",
        Fa = "popup-quick-view--animated",
        Ia = "popup-quick-view",
        xa = "js-quick-view-visible",
        Da = "js-quick-view-from-cart",
        Ha = "js-drawer-open",
        Ma = "id",
        Oa = "data-media-id",
        _a = "data-section-id",
        Ba = "loaded",
        $a = "tabindex",
        za = "data-quick-view-onboarding",
        Ra = "data-hotspot",
        Va = "data-hotspot-ref",
        Wa = "AddToCartForm--",
        Na = "AddToCart--";
    const Ua = 400,
        ja = ".pswp",
        Ka = ".pswp__custom-close",
        Qa = "iframe, video",
        Ga = ".pswp__custom-iframe",
        Xa = ".pswp__thumbs",
        Ja = ".pswp__button, .pswp__caption-close",
        Ya = "is-current",
        Za = "pswp--custom-loader",
        tl = "pswp--custom-opening",
        el = "pswp__loader",
        il = "pswp--open",
        sl = "pswp__button--close",
        ol = "pswp--notification",
        nl = "popup-quick-view",
        rl = "js-drawer-open-cart",
        al = "popup-quick-view--animate-out",
        ll = "data-pswp-option-classes",
        cl = "data-video-type",
        hl = `<div class="${el}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`;
    let dl = class {
        init() {
            document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), this.pswpElement.classList.add(tl), this.initLoader(), $t({
                url: window.theme.assets.photoswipe
            }).then((() => this.loadPopup())).catch((t => console.error(t)))
        }
        initLoader() {
            if (this.pswpElement.classList.contains(Za) && "" !== this.options && this.options.mainClass) {
                this.pswpElement.setAttribute(ll, this.options.mainClass);
                let t = document.createElement("div");
                t.innerHTML = hl, t = t.firstChild, this.pswpElement.appendChild(t)
            } else this.pswpElement.setAttribute(ll, "")
        }
        loadPopup() {
            const t = window.themePhotoswipe.PhotoSwipe.default,
                e = window.themePhotoswipe.PhotoSwipeUI.default;
            this.pswpElement.classList.contains(Za) && this.pswpElement.classList.remove(Za), this.pswpElement.classList.remove(tl), this.popup = new t(this.pswpElement, e, this.items, this.options), this.popup.listen("afterInit", this.dispatchPopupInitEventCallback), this.popup.listen("imageLoadComplete", this.setCurrentThumbCallback), this.popup.listen("beforeChange", this.setCurrentThumbCallback), this.popup.listen("close", this.onCloseCallback), this.popup.init(), this.initPopupCallback()
        }
        initPopupCallback() {
            this.isVideo && this.hideUnusedButtons(), this.initVideo(), this.thumbsActions(), this.a11y.trapFocus({
                container: this.pswpElement
            }), this.pswpElement.classList.contains(nl) && new class {
                initTooltips() {
                    this.tooltips = this.pswpElement.querySelectorAll(wa), this.tooltips.forEach((t => {
                        new ze(t)
                    }))
                }
                initPopouts() {
                    var t;
                    this.popoutElements = this.pswpElement.querySelectorAll(ca), this.popouts = {}, null === (t = this.popoutElements) || void 0 === t || t.forEach(((t, e) => {
                        this.popouts[e] = new sa(t)
                    }))
                }
                handleDraggable(t, e) {
                    t && (t.options.draggable = Boolean(e), t.updateDraggable())
                }
                initItems(t, e) {
                    this.addFormSuffix(t), this.initProductSlider(t, e), this.initProductVideo(t), this.initProductModel(t), this.initShopifyXrLaunch(t), Ji(t), this.pswpElement.querySelectorAll(Ea).length && new hn(t), W(t);
                    const i = new Hr(t.parentNode);
                    this.productForms.push(i), Shopify.PaymentButton && Shopify.PaymentButton.init(), t.classList.remove(ka)
                }
                init() {
                    document.addEventListener("submit", this.prevent3dModelSubmitEvent), this.popupCloseButtons.forEach((t => {
                        t.addEventListener("keyup", (t => {
                            t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER && t.code !== theme.keyboardKeys.SPACE || this.closePopup(t)
                        })), t.addEventListener("click", (t => {
                            this.closePopup(t)
                        }))
                    })), this.pswpElement.addEventListener("click", this.outerCloseEvent), document.dispatchEvent(new CustomEvent("theme:popup:open", {
                        bubbles: !0
                    })), this.popup.listen("preventDragEvent", ((t, e, i) => {
                        i.prevent = !1
                    })), this.pswpElement.addEventListener("mousedown", (() => {
                        this.popup.framework.unbind(window, "pointermove pointerup pointercancel", this.popup)
                    })), this.popup.listen("initialZoomInEnd", (() => {
                        document.body.classList.add(xa), this.a11y.trapFocus({
                            container: this.quickViewInner
                        })
                    })), this.pswpElement.addEventListener("animationend", this.closeOnAnimationEndEvent), this.popup.listen("destroy", (() => {
                        this.flkty.length > 0 && requestAnimationFrame((() => {
                            this.flkty.forEach((t => t.pausePlayer()))
                        })), document.body.classList.remove(xa), document.removeEventListener("keyup", this.closeOnEscapeEvent), document.addEventListener("keyup", this.closeOnEscapeEvent), this.pswpElement.removeEventListener("click", this.outerCloseEvent), this.pswpElement.removeEventListener("animationend", this.closeOnAnimationEndEvent), document.removeEventListener("submit", this.prevent3dModelSubmitEvent), this.deferredMedias.forEach((t => {
                            t.removeAttribute(Ba)
                        }))
                    })), document.addEventListener("keyup", this.closeOnEscapeEvent), document.addEventListener("theme:cart:added", (() => {
                        this.pswpElement.classList.contains(Ia) && this.pswpElement.classList.add(Pa)
                    })), this.animateInQuickview(), this.initShopTheLookListeners()
                }
                initShopTheLookListeners() {
                    var t;
                    null === (t = this.buttonsShopTheLookThumb) || void 0 === t || t.forEach((t => {
                        t.addEventListener("click", (t => {
                            t.preventDefault();
                            const e = t.target.matches(ba) ? t.target : t.target.closest(ba),
                                i = this.pswpElement.querySelector(`[${Ra}="${e.getAttribute(Va)}"]`);
                            !e.classList.contains(La) && i && (this.flkty.length > 0 && requestAnimationFrame((() => {
                                this.flkty.forEach((t => {
                                    t.resize();
                                    const e = this.quickViewInner.querySelectorAll(ga);
                                    e.length && e.forEach((t => {
                                        t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                                            bubbles: !0
                                        }), t.classList.add(Aa)
                                    }))
                                }))
                            })), i.classList.add(La), this.quickViewItemHolders.forEach((t => {
                                t !== i && t.classList.remove(La)
                            })))
                        }))
                    }))
                }
                prevent3dModelSubmit(t) {
                    t.submitter.closest(ra) && t.submitter.closest(pa) && t.preventDefault()
                }
                closeQuickviewOnMobile() {
                    window.innerWidth < window.theme.sizes.large && document.body.classList.contains(xa) && this.popup.close()
                }
                animateInQuickview() {
                    this.pswpElement.classList.add(Ta), this.quickViewFoot.addEventListener("animationend", (t => {
                        this.handleAnimatedState(t)
                    })), this.pswpElement.addEventListener("animationend", (t => {
                        this.handleAnimatedState(t, !0)
                    }))
                }
                handleAnimatedState(t, e = !1) {
                    if ("quickViewAnimateInUp" == t.animationName) {
                        if (e && window.innerWidth >= window.theme.sizes.small) return;
                        this.pswpElement.classList.add(Fa), this.pswpElement.classList.remove(Ta), document.body.classList.remove(Da), j(this.pswpElement)
                    }
                }
                closePopup(t) {
                    null == t || t.preventDefault(), document.body.classList.contains(Ha) && document.dispatchEvent(new CustomEvent("theme:drawer:closing", {
                        bubbles: !0
                    })), this.pswpElement.classList.add(Pa), this.productForms.length > 0 && this.productForms.forEach((t => {
                        t.destroy()
                    })), this.swatchesContainer.onUnload()
                }
                closeOnAnimationEnd(t) {
                    "quickViewAnimateOutRight" != t.animationName && "quickViewAnimateOutDown" != t.animationName || (this.popup.template.classList.remove(Pa, Fa), this.popup.close())
                }
                closeOnEscape(t) {
                    const e = document.body.classList.contains(xa),
                        i = document.body.classList.contains(Ca);
                    t.code === theme.keyboardKeys.ESCAPE && e && !i && this.closePopup(t)
                }
                initProductSlider(t, i) {
                    const s = t.querySelector(ma),
                        o = t.querySelectorAll(ga);
                    if (o.length > 1) {
                        const n = new e(s, {
                            wrapAround: !0,
                            cellAlign: "left",
                            pageDots: !1,
                            prevNextButtons: !0,
                            adaptiveHeight: !1,
                            pauseAutoPlayOnHover: !1,
                            selectedAttraction: .2,
                            friction: 1,
                            autoPlay: !1,
                            on: {
                                ready: () => {
                                    s.setAttribute($a, "-1"), requestAnimationFrame((() => {
                                        n.resize()
                                    }))
                                },
                                settle: () => {
                                    const e = n.selectedElement,
                                        i = e.getAttribute(Oa);
                                    e.setAttribute($a, "0"), n.cells.forEach((t => {
                                        t.element !== e && t.element.setAttribute($a, "-1")
                                    })), this.switchMedia(t, i)
                                }
                            }
                        });
                        this.flkty.push(n), o.length && o.forEach((t => {
                            t.addEventListener("theme:media:play", (() => {
                                this.handleDraggable(this.flkty[i], !1), t.closest(ma).classList.add(Sa)
                            })), t.addEventListener("theme:media:pause", (() => {
                                this.handleDraggable(this.flkty[i], !0), t.closest(ma).classList.remove(Sa)
                            }))
                        })), ae(s)
                    }
                }
                switchMedia(t, e) {
                    const i = this.quickViewInner.querySelectorAll(ga),
                        s = t.querySelector(`${ga}[${Oa}="${e}"]`),
                        o = !document.body.classList.contains(qa);
                    i.length && i.forEach((t => {
                        t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                            bubbles: !0
                        }), t.classList.add(Aa)
                    })), o && s.focus(), s.closest(ma).classList.remove(Sa), s.classList.remove(Aa), s.dispatchEvent(new CustomEvent("theme:media:visible"), {
                        bubbles: !0
                    });
                    const n = s.querySelector(ra);
                    n && "true" !== n.getAttribute(Ba) && s.querySelector(aa).dispatchEvent(new Event("click"))
                }
                initProductVideo(t) {
                    const e = new Ee(t);
                    this.videos.push(e)
                }
                initProductModel(t) {
                    const e = t.getAttribute(_a),
                        i = t.querySelectorAll(va);
                    i.length && i.forEach((t => {
                        theme.ProductModel.init(t, e)
                    }))
                }
                initShopifyXrLaunch(t) {
                    document.addEventListener("shopify_xr_launch", (() => {
                        t.querySelector(`${va}:not(.${Aa})`).dispatchEvent(new CustomEvent("xrLaunch"))
                    }))
                }
                addFormSuffix(t) {
                    const e = `${t.getAttribute(_a)}-${JSON.parse(t.querySelector(ya).innerHTML).handle}`,
                        i = t.querySelector(pa),
                        s = t.querySelector(na);
                    i.setAttribute(Ma, Wa + e), s.setAttribute(Ma, Na + e)
                }
                constructor(t, e) {
                    this.popup = t, this.pswpElement = e, this.quickViewFoot = this.pswpElement.querySelector(fa), this.quickViewInner = this.pswpElement.querySelector(ha), this.product = this.pswpElement.querySelectorAll(ua), this.flkty = [], this.videos = [], this.productForms = [], this.deferredMedias = this.pswpElement.querySelectorAll(ra), this.buttonsShopTheLookThumb = this.pswpElement.querySelectorAll(ba), this.quickViewItemHolders = this.pswpElement.querySelectorAll(da), this.popupCloseButtons = this.quickViewInner.querySelectorAll(la), this.a11y = _t, this.prevent3dModelSubmitEvent = t => this.prevent3dModelSubmit(t), this.closeOnAnimationEndEvent = t => this.closeOnAnimationEnd(t), this.closeOnEscapeEvent = t => this.closeOnEscape(t), this.outerCloseEvent = t => {
                        if (!this.quickViewInner.contains(t.target)) {
                            const e = this.quickViewInner.nextElementSibling;
                            if (e && e.contains(t.target)) return;
                            this.closePopup(t)
                        }
                    }, this.product.forEach(((t, e) => {
                        t.hasAttribute(za) || this.initItems(t, e)
                    })), this.init(), this.initTooltips(), this.initPopouts(), this.swatchesContainer = new Xi(this.pswpElement)
                }
            }(this.popup, this.pswpElement), this.pswpElement.classList.contains(ol) && new class {
                init() {
                    this.popup.listen("preventDragEvent", ((t, e, i) => {
                        i.prevent = !1
                    }));
                    const t = -1 !== window.location.search.indexOf("?customer_posted=true");
                    this.notificationForm = this.pswpElement.querySelector(ie);
                    const e = this.pswpElement.querySelector(oe);
                    document.body.classList.add(re), this.pswpElement.addEventListener("mousedown", (() => {
                        this.popup.framework.unbind(window, "pointermove pointerup pointercancel", this.popup)
                    })), t && this.pswpElement.classList.add(ne), this.notificationForm.addEventListener("submit", (t => this.notificationSubmitEvent(t))), this.pswpElement.addEventListener("click", this.outerCloseEvent), e.addEventListener("click", (() => {
                        this.popup.close()
                    })), this.popup.listen("destroy", (() => {
                        this.notificationRemoveStorage(), this.pswpElement.removeEventListener("click", this.outerCloseEvent), document.body.classList.remove(re)
                    }))
                }
                notificationSubmitEvent(t) {
                    this.notificationStopSubmit && (t.preventDefault(), this.notificationRemoveStorage(), this.notificationWriteStorage(), this.notificationStopSubmit = !1, this.notificationForm.submit())
                }
                notificationWriteStorage() {
                    void 0 !== this.sessionStorage && this.sessionStorage.setItem("notification_form_id", this.notificationForm.id)
                }
                notificationRemoveStorage() {
                    this.sessionStorage.removeItem("notification_form_id")
                }
                constructor(t, e) {
                    this.popup = t, this.pswpElement = e, this.notificationForm = null, this.notificationStopSubmit = !0, this.sessionStorage = window.sessionStorage;
                    const i = this.pswpElement.querySelector(se);
                    this.outerCloseEvent = t => {
                        i.contains(t.target) || this.popup.close()
                    }, this.init()
                }
            }(this.popup, this.pswpElement), this.closePopup = () => {
                this.pswpElement.classList.contains(nl) ? this.pswpElement.classList.add(al) : this.popup.close()
            }, this.closeBtn && this.closeBtn.addEventListener("click", this.closePopup), document.addEventListener("theme:cart:added", this.closePopup)
        }
        dispatchPopupInitEvent() {
            this.triggerBtn && this.triggerBtn.dispatchEvent(new CustomEvent("theme:popup:init", {
                bubbles: !0
            }))
        }
        initVideo() {
            const t = this.pswpElement.querySelector(Ga);
            if (t) {
                const e = t.getAttribute(cl);
                this.isVideo = !0, "youtube" == e ? new class {
                    init() {
                        window.isYoutubeAPILoaded ? this.loadYoutubePlayer() : $t({
                            url: "https://www.youtube.com/iframe_api"
                        }).then((() => this.loadYoutubePlayer()))
                    }
                    loadYoutubePlayer() {
                        const t = {
                            height: "720",
                            width: "1280",
                            playerVars: this.videoOptionsVars,
                            events: {
                                onReady: t => {
                                    const e = t.target.getIframe(),
                                        i = e.id,
                                        s = "true" === document.querySelector(`#${i}`).getAttribute(Xt);
                                    e.setAttribute("tabindex", "-1"), s ? t.target.unMute() : t.target.mute(), t.target.playVideo(), this.checkPlayerVisibilityFlag && (this.checkPlayerVisibility(i), window.addEventListener("scroll", gt((() => {
                                        this.checkPlayerVisibility(i)
                                    }), 150)))
                                },
                                onStateChange: t => {
                                    0 == t.data && t.target.playVideo(), 1 == t.data && t.target.getIframe().parentElement.classList.add(te)
                                }
                            }
                        };
                        t.videoId = this.videoID, this.videoID.length && YT.ready((() => {
                            ee[this.playerID] = new YT.Player(this.playerID, t)
                        })), window.isYoutubeAPILoaded = !0
                    }
                    checkPlayerVisibility(t) {
                        let e;
                        if ("string" == typeof t) e = t;
                        else {
                            if (null == t.data) return;
                            e = t.data.id
                        }
                        const i = document.getElementById(e + "-container");
                        if (!i) return;
                        const s = ee[e],
                            o = i.getBoundingClientRect();
                        let n = visibilityHelper.isElementPartiallyVisible(i) || visibilityHelper.isElementTotallyVisible(i);
                        o.top < 0 && i.clientHeight + o.top >= 0 && (n = !0), n && s && "function" == typeof s.playVideo ? s.playVideo() : !n && s && "function" == typeof s.pauseVideo && s.pauseVideo()
                    }
                    onUnload() {
                        const t = "youtube-" + this.container.getAttribute(Gt);
                        ee[t] && ee[t].destroy()
                    }
                    constructor(t) {
                        this.container = t, this.player = this.container.querySelector(Qt.videoIframe), this.player && (this.videoOptionsVars = {}, this.videoID = this.player.getAttribute(Yt), this.videoType = this.player.getAttribute(Zt), "youtube" == this.videoType && (this.checkPlayerVisibilityFlag = "true" === this.player.getAttribute(Jt), this.playerID = this.player.querySelector(Qt.youtubeWrapper) ? this.player.querySelector(Qt.youtubeWrapper).id : this.player.id, this.player.hasAttribute(Qt.dataHideOptions) && (this.videoOptionsVars = {
                            cc_load_policy: 0,
                            iv_load_policy: 3,
                            modestbranding: 1,
                            playsinline: 1,
                            autohide: 0,
                            controls: 0,
                            branding: 0,
                            showinfo: 0,
                            rel: 0,
                            fs: 0,
                            wmode: "opaque"
                        }), this.init(), this.container.addEventListener("touchstart", (function(t) {
                            if (t.target.matches(Qt.videoWrapper) || t.target.closest(Qt.videoWrapper)) {
                                const e = t.target.querySelector(Qt.videoIframe).id;
                                ee[e].playVideo()
                            }
                        }), {
                            passive: !0
                        })))
                    }
                }(t.parentElement) : "vimeo" == e && new class {
                    init() {
                        this.loadVimeoPlayer()
                    }
                    loadVimeoPlayer() {
                        const t = "https://vimeo.com/" + this.videoID;
                        let e = "";
                        const i = this.player,
                            s = {
                                url: t,
                                background: this.enableBackground,
                                muted: this.disableSound,
                                autoplay: this.enableAutoplay,
                                loop: this.enableLoop
                            };
                        for (let t in s) e += encodeURIComponent(t) + "=" + encodeURIComponent(s[t]) + "&";
                        fetch(`https://vimeo.com/api/oembed.json?${e}`).then((t => t.json())).then((function(t) {
                            i.innerHTML = t.html, setTimeout((function() {
                                i.parentElement.classList.add(Rt)
                            }), 1e3)
                        })).catch((function() {
                            console.log("error")
                        }))
                    }
                    constructor(t) {
                        this.container = t, this.player = this.container.querySelector(zt), this.player && (this.videoID = this.player.getAttribute(jt), this.videoType = this.player.getAttribute(Kt), this.enableBackground = "true" === this.player.getAttribute(Wt), this.disableSound = "false" === this.player.getAttribute(Vt), this.enableAutoplay = "false" !== this.player.getAttribute(Nt), this.enableLoop = "false" !== this.player.getAttribute(Ut), "vimeo" == this.videoType && this.init())
                    }
                }(t.parentElement)
            }
        }
        thumbsActions() {
            this.popupThumbsContainer && this.popupThumbsContainer.firstChild && (this.popupThumbsContainer.addEventListener("wheel", (t => this.stopDisabledScroll(t))), this.popupThumbsContainer.addEventListener("mousewheel", (t => this.stopDisabledScroll(t))), this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t => this.stopDisabledScroll(t))), this.popupThumbs = this.pswpElement.querySelectorAll(`${Xa} > *`), this.popupThumbs.forEach(((t, e) => {
                t.addEventListener("click", (i => {
                    i.preventDefault(), t.parentElement.querySelector(`.${Ya}`).classList.remove(Ya), t.classList.add(Ya), this.popup.goTo(e)
                }))
            })))
        }
        hideUnusedButtons() {
            this.pswpElement.querySelectorAll(Ja).forEach((t => {
                t.classList.contains(sl) || (t.style.display = "none")
            }))
        }
        stopDisabledScroll(t) {
            t.stopPropagation()
        }
        onClose() {
            const t = this.pswpElement.querySelector(Qa);
            if (t && t.parentNode.removeChild(t), this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
                for (; this.popupThumbsContainer.firstChild;) this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
            this.pswpElement.setAttribute(ll, "");
            const e = this.pswpElement.querySelector(`.${el}`);
            e && this.pswpElement.removeChild(e), document.body.classList.contains(rl) || this.a11y.removeTrapFocus(), document.removeEventListener("theme:cart:added", this.closePopup), setTimeout((() => {
                const t = this.recentlyOpenedPopupsCount(),
                    e = document.body.classList.contains(rl);
                0 !== t || e || document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0
                }))
            }), Ua)
        }
        recentlyOpenedPopupsCount() {
            let t = 0;
            return this.pswpElements.forEach((e => {
                e.classList.contains(il) && (t += 1)
            })), t
        }
        setCurrentThumb() {
            if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild) return;
            const t = this.pswpElement.querySelector(`${Xa} > .${Ya}`);
            if (t && t.classList.remove(Ya), !this.popupThumbs) return;
            const e = this.popupThumbs[this.popup.getCurrentIndex()];
            e.classList.add(Ya), this.scrollThumbs(e)
        }
        scrollThumbs(t) {
            const e = this.popupThumbsContainer.scrollLeft + this.popupThumbsContainer.offsetWidth,
                i = t.offsetLeft;
            if (e <= i + t.offsetWidth || e > i) {
                const e = parseInt(window.getComputedStyle(t).marginLeft);
                this.popupThumbsContainer.scrollTo({
                    top: 0,
                    left: i - e,
                    behavior: "smooth"
                })
            }
        }
        constructor(t, e = "", i = 0, s = null) {
            this.items = t, this.triggerBtn = s, this.pswpElements = document.querySelectorAll(ja), this.pswpElement = this.pswpElements[i], this.popup = null, this.popupThumbs = null, this.popupThumbsContainer = this.pswpElement.querySelector(Xa), this.closeBtn = this.pswpElement.querySelector(Ka);
            this.options = "" !== e ? e : {
                history: !1,
                focus: !1,
                mainClass: ""
            }, this.onCloseCallback = () => this.onClose(), this.dispatchPopupInitEventCallback = () => this.dispatchPopupInitEvent(), this.setCurrentThumbCallback = () => this.setCurrentThumb(), this.a11y = _t, this.init()
        }
    };
    const ul = 0,
        pl = "[data-button-quick-view]",
        ml = "[data-quick-view-items-template]",
        gl = "[data-cart-drawer]",
        vl = "[data-shop-the-look-quick-view-button]",
        yl = "[data-shop-the-look-thumb]",
        fl = "[data-quick-view-item-holder]",
        bl = "is-loading",
        wl = "is-active",
        El = "js-quick-view-from-cart",
        Sl = "popup-quick-view pswp--not-close-btn",
        Ll = "popup-quick-view popup-quick-view--shop-the-look pswp--not-close-btn",
        kl = "data-handle",
        Al = "data-variant-id",
        ql = "data-shop-the-look-quick-view",
        Cl = "data-hotspot",
        Tl = "data-initialized",
        Pl = {
            history: !1,
            focus: !1,
            mainClass: Sl,
            showHideOpacity: !1,
            closeOnVerticalDrag: !1,
            closeOnScroll: !1,
            modal: !1,
            escKey: !1
        };
    let Fl = class {
        popupInit(t) {
            var e, i;
            const s = this.loadPhotoswipe.pswpElement.querySelector(`[${Cl}="${t.getAttribute(Cl)}"]`),
                o = this.loadPhotoswipe.pswpElement.querySelectorAll(fl);
            s.classList.add(wl), o.forEach((t => {
                t !== s && t.classList.remove(wl)
            })), this.toggleQuickViewButtonsLoadingClasses(!0), this.toggleQuickViewThumbsLoadingClasses(!0);
            const n = t => {
                "quickViewAnimateInUp" === t.animationName && requestAnimationFrame((() => {
                    this.toggleQuickViewThumbsLoadingClasses(!1)
                })), "quickViewAnimateOutDown" === t.animationName && this.loadPhotoswipe.pswpElement.removeEventListener("animationend", n)
            };
            this.loadPhotoswipe.pswpElement.addEventListener("animationend", n), null === (e = this.loadPhotoswipe) || void 0 === e || null === (i = e.popup) || void 0 === i || i.listen("destroy", (() => {
                this.toggleQuickViewButtonsLoadingClasses(!1), this.toggleQuickViewThumbsLoadingClasses(!1)
            }))
        }
        toggleQuickViewButtonsLoadingClasses(t = !0) {
            var e, i;
            t ? null === (i = this.buttonsQuickView) || void 0 === i || i.forEach((t => {
                t.classList.add(bl)
            })) : null === (e = this.buttonsQuickView) || void 0 === e || e.forEach((t => {
                t.classList.remove(bl)
            }))
        }
        toggleQuickViewThumbsLoadingClasses(t = !0) {
            var e, i, s;
            (this.buttonsShopTheLookThumb = null === (e = this.loadPhotoswipe) || void 0 === e ? void 0 : e.pswpElement.querySelectorAll(yl), t) ? null === (s = this.buttonsShopTheLookThumb) || void 0 === s || s.forEach((t => {
                t.classList.add(bl)
            })): null === (i = this.buttonsShopTheLookThumb) || void 0 === i || i.forEach((t => {
                t.classList.remove(bl)
            }))
        }
        initPhotoswipe(t) {
            t.preventDefault();
            const e = t.target.matches(pl) ? t.target : t.target.closest(pl),
                i = window.innerWidth < theme.sizes.small;
            let s = "",
                o = !1;
            if (e.hasAttribute(ql)) {
                if (!i) return;
                o = !0
            }
            Pl.mainClass = Sl, e.classList.add(bl), e.closest(gl) && document.body.classList.add(El), this.a11y.state.trigger = e, e.hasAttribute(Al) && (s = `&variant=${e.getAttribute(Al)}`);
            const n = `${theme.routes.root}products/${e.getAttribute(kl)}?section_id=api-quickview${s}`;
            if (o) {
                Pl.mainClass = Ll, this.buttonsQuickView.forEach((t => {
                    t.classList.add(bl)
                }));
                const t = new XMLSerializer,
                    i = this.container.querySelector(ml).content.firstElementChild.cloneNode(!0),
                    s = t.serializeToString(i);
                this.loadPhotoswipeWithTemplate(s, e)
            } else this.loadPhotoswipeFromFetch(n, e)
        }
        loadPhotoswipeWithTemplate(t, e) {
            const i = [{
                html: t
            }];
            this.loadPhotoswipe = new dl(i, Pl, ul, e)
        }
        loadPhotoswipeFromFetch(t, e) {
            fetch(t).then((t => t.text())).then((t => {
                const i = [{
                    html: t
                }];
                this.loadPhotoswipe = new dl(i, Pl, ul, e)
            })).catch((t => console.log("error: ", t)))
        }
        constructor(t) {
            var e, i;
            this.container = t, this.a11y = _t, this.buttonsQuickView = this.container.querySelectorAll(pl), this.buttonsShopTheLookQuickView = this.container.querySelectorAll(vl), this.popupInitCallback = t => this.popupInit(t), null === (e = this.buttonsQuickView) || void 0 === e || e.forEach((t => {
                t.hasAttribute(Tl) || (t.addEventListener("click", (t => this.initPhotoswipe(t))), t.addEventListener("theme:popup:init", (() => {
                    t.classList.remove(bl), t.hasAttribute(ql) && this.popupInitCallback(t)
                })), t.setAttribute(Tl, ""))
            })), null === (i = this.buttonsShopTheLookQuickView) || void 0 === i || i.forEach((t => {
                t.addEventListener("click", (() => {
                    var t;
                    null === (t = this.buttonsQuickView[0]) || void 0 === t || t.dispatchEvent(new Event("click"))
                }))
            }))
        }
    };
    const Il = {
            cartDrawerEnabled: "drawer" === window.theme.settings.cartType,
            timers: {
                addProductTimeout: 1e3
            },
            animations: {
                data: "data-aos",
                method: "fade-up"
            }
        },
        xl = {
            outerSection: "[data-section-id]",
            aos: "[data-aos]",
            additionalCheckoutButtons: "[data-additional-checkout-button]",
            apiContent: "[data-api-content]",
            apiLineItems: "[data-api-line-items]",
            apiUpsellItems: "[data-api-upsell-items]",
            apiCartPrice: "[data-api-cart-price]",
            buttonAddToCart: "[data-add-to-cart]",
            upsellButtonByHandle: "[data-handle]",
            cartCloseError: "[data-cart-error-close]",
            cartDrawer: "[data-cart-drawer]",
            cartDrawerTemplate: "[data-cart-drawer-template]",
            cartDrawerToggle: "[data-cart-drawer-toggle]",
            cartDrawerBody: "[data-cart-drawer-body]",
            cartErrors: "[data-cart-errors]",
            cartForm: "[data-cart-form]",
            cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
            cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
            cartCheckoutButton: "[data-cart-checkout-button]",
            cartItemRemove: "[data-item-remove]",
            cartItemsQty: "[data-cart-items-qty]",
            cartTotal: "[data-cart-total]",
            cartTotalPrice: "[data-cart-total-price]",
            cartMessage: "[data-cart-message]",
            cartMessageDefault: "[data-message-default]",
            cartPage: "[data-cart-page]",
            cartProgress: "[data-cart-message-progress]",
            emptyMessage: "[data-empty-message]",
            buttonHolder: "[data-foot-holder]",
            item: "[data-cart-item]",
            itemsHolder: "[data-items-holder]",
            itemsWrapper: "[data-items-wrapper]",
            formCloseError: "[data-close-error]",
            formErrorsContainer: "[data-cart-errors-container]",
            upsellHolder: "[data-upsell-holder]",
            errorMessage: "[data-error-message]",
            termsErrorMessage: "[data-terms-error-message]",
            pairProductsHolder: "[data-pair-products-holder]",
            pairProducts: "[data-pair-products]",
            priceHolder: "[data-cart-price-holder]",
            leftToSpend: "[data-left-to-spend]",
            quickBuyForm: "[data-quickbuy-form]",
            qtyInput: "[data-quantity-field]",
            productMediaContainer: "[data-product-media-container]",
            formWrapper: "[data-form-wrapper]",
            productForm: "[data-product-form]",
            popupQuickView: ".popup-quick-view",
            popupClose: "[data-popup-close]",
            error: "[data-error]",
            quickViewOnboarding: "[data-quick-view-onboarding]",
            flickityEnabled: ".flickity-enabled"
        },
        Dl = "hidden",
        Hl = "is-hidden",
        Ml = "js-drawer-open-cart",
        Ol = "is-open",
        _l = "is-visible",
        Bl = "is-expanded",
        $l = "is-loading",
        zl = "is-disabled",
        Rl = "is-success",
        Vl = "cart__toggle--has-items",
        Wl = "variant--soldout",
        Nl = "is-removed",
        Ul = "aos-animate",
        jl = "is-updated",
        Kl = "no-outline",
        Ql = "product-grid-item__image--error",
        Gl = "cv-h",
        Xl = "data-limit",
        Jl = "data-cart-message",
        Yl = "data-cart-total",
        Zl = "aria-expanded",
        tc = "disabled",
        ec = "value",
        ic = "data-id",
        sc = "data-item",
        oc = "data-item-index",
        nc = "data-item-title",
        rc = "data-atc-trigger",
        ac = "data-notification-popup",
        lc = "data-recipient-errors";
    let cc = {},
        hc = class {
            init() {
                var t;
                this.cartToggleButtons = document.querySelectorAll(xl.cartDrawerToggle), this.cartPage = document.querySelector(xl.cartPage), this.cartDrawer = document.querySelector(xl.cartDrawer), this.cart = this.cartDrawer || this.cartPage, this.cartCount = this.getCartItemCount(), this.assignArguments(), this.recipientErrors = "true" === (null === (t = this.form) || void 0 === t ? void 0 : t.getAttribute(lc)), this.flktyUpsell = null, this.form = null, this.collapsible = null, this.a11y = _t, this.build = this.build.bind(this), this.addToCart = this.addToCart.bind(this), this.updateCart = this.updateCart.bind(this), this.openCartDrawer = this.openCartDrawer.bind(this), this.closeCartDrawer = this.closeCartDrawer.bind(this), this.toggleCartDrawer = this.toggleCartDrawer.bind(this), this.formSubmitHandler = gt(this.formSubmitHandler.bind(this), 50), this.closeCartError = () => {
                    this.cartErrorHolder.classList.remove(Bl)
                }, this.cartDrawerCloseEvent = null, this.hasItemsInCart = this.hasItemsInCart.bind(this), this.isCartPage = Boolean(this.cart && null === this.cartDrawer), this.showAnimations = Boolean("true" === document.body.dataset.animations), this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this), this.totalItems = 0, this.isCartDrawerOpen = !1, this.isCartDrawerLoaded = !1, this.cartDiscounts = 0, this.cartDrawerEnabled = Il.cartDrawerEnabled, this.cartAnimationTimer = 0, this.cartUpdateFailed = !1, this.cartEvents(), this.cartAddEvent(), this.cartDrawerToggleEvents(), this.initQuantity(), this.buttonHolder && (this.collapsible = new Ct(this.buttonHolder)), this.isCartPage && this.renderPairProducts(), document.addEventListener("theme:popup:open", this.closeCartDrawer)
            }
            assignArguments() {
                this.cartDrawerBody = document.querySelector(xl.cartDrawerBody), this.emptyMessage = document.querySelector(xl.emptyMessage), this.buttonHolder = document.querySelector(xl.buttonHolder), this.itemsHolder = document.querySelector(xl.itemsHolder), this.cartItemsQty = document.querySelector(xl.cartItemsQty), this.itemsWrapper = document.querySelector(xl.itemsWrapper), this.items = document.querySelectorAll(xl.item), this.cartTotal = document.querySelector(xl.cartTotal), this.cartTotalPrice = document.querySelectorAll(xl.cartTotalPrice), this.cartMessage = document.querySelectorAll(xl.cartMessage), this.cartOriginalTotal = document.querySelector(xl.cartOriginalTotal), this.cartErrorHolder = document.querySelector(xl.cartErrors), this.cartCloseErrorMessage = document.querySelector(xl.cartCloseError), this.pairProductsHolder = document.querySelector(xl.pairProductsHolder), this.pairProducts = document.querySelector(xl.pairProducts), this.priceHolder = document.querySelector(xl.priceHolder), this.upsellHolders = document.querySelectorAll(xl.upsellHolder), this.cartTermsCheckbox = document.querySelector(xl.cartTermsCheckbox), this.cartCheckoutButtonWrapper = document.querySelector(xl.cartCheckoutButtonWrapper), this.cartCheckoutButton = document.querySelector(xl.cartCheckoutButton), this.cartForm = document.querySelector(xl.cartForm), this.cartItemCount = 0, this.subtotal = window.theme.subtotal, this.button = null, this.cartMessage.length > 0 && (this.cartFreeLimitShipping = 100 * Number(this.cartMessage[0].getAttribute(Xl)) * window.Shopify.currency.rate), this.updateProgress()
            }
            initQuantity() {
                var t;
                this.items = document.querySelectorAll(xl.item), null === (t = this.items) || void 0 === t || t.forEach((t => {
                    new Ot(t, !0).init(), this.cartUpdateEvent(t)
                }))
            }
            cartUpdateEvent(t) {
                t.addEventListener("theme:cart:update", (e => {
                    this.updateCart({
                        id: e.detail.id,
                        quantity: e.detail.quantity
                    }, t)
                }))
            }
            cartEvents() {
                const t = document.querySelectorAll(xl.cartItemRemove);
                this.totalItems = t.length, null == t || t.forEach((t => {
                    const e = t.closest(xl.item);
                    t.addEventListener("click", (i => {
                        i.preventDefault(), t.classList.contains(zl) || this.updateCart({
                            id: e.getAttribute(ic),
                            quantity: 0
                        }, e)
                    }))
                })), this.cartCloseErrorMessage && (this.cartCloseErrorMessage.removeEventListener("click", this.closeCartError), this.cartCloseErrorMessage.addEventListener("click", this.closeCartError)), this.cartTermsCheckbox && (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler), this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler), this.cartForm.removeEventListener("submit", this.formSubmitHandler), this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler), this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler), this.cartForm.addEventListener("submit", this.formSubmitHandler))
            }
            cartAddEvent() {
                document.addEventListener("click", (t => {
                    const e = t.target,
                        i = null == e ? void 0 : e.matches(xl.buttonAddToCart),
                        s = null == e ? void 0 : e.closest(xl.buttonAddToCart);
                    if (i || s) {
                        var o, n, r;
                        t.preventDefault(), this.button = i ? e : s, this.form = e.closest("form"), this.recipientErrors = "true" === (null === (o = this.form) || void 0 === o ? void 0 : o.getAttribute(lc)), this.formWrapper = this.button.closest(xl.formWrapper);
                        const a = null === (n = this.formWrapper) || void 0 === n ? void 0 : n.classList.contains(Wl),
                            l = this.button.hasAttribute(tc),
                            c = this.button.closest(xl.quickViewOnboarding),
                            h = this.button.hasAttribute(rc),
                            d = this.button.hasAttribute(ac),
                            u = null === (r = this.form) || void 0 === r ? void 0 : r.querySelector('[type="file"]');
                        if (l || u || c) return;
                        if (a && d) return void new Hn(this.button);
                        h && (this.a11y.state.trigger = this.button);
                        const p = new FormData(this.form);
                        this.addToCart(p), document.dispatchEvent(new CustomEvent("theme:cart:add", {
                            bubbles: !0,
                            detail: {
                                selector: e
                            }
                        }))
                    }
                }))
            }
            getCart() {
                if (this.cartDrawer && !this.isCartDrawerLoaded) {
                    const t = !1;
                    this.renderCartDrawer(t)
                }
                fetch(theme.routes.cart_url + "?section_id=api-cart-items").then(this.handleErrors).then((t => t.text())).then((t => {
                    const e = document.createElement("div");
                    e.innerHTML = t;
                    const i = e.querySelector(xl.apiContent);
                    this.build(i)
                })).catch((t => console.log(t)))
            }
            addToCart(t) {
                this.cartDrawerEnabled && this.button && (this.button.classList.add($l), this.button.setAttribute(tc, !0)), fetch(theme.routes.cart_add_url, {
                    method: "POST",
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        Accept: "application/javascript"
                    },
                    body: t
                }).then((t => t.json())).then((t => {
                    if (this.button.disabled = !0, this.addLoadingClass(), t.status) return this.addToCartError(t), void this.removeLoadingClass();
                    this.hideAddToCartErrorMessage(), this.cartDrawerEnabled ? this.getCart() : window.location = theme.routes.cart_url
                })).catch((t => console.log(t)))
            }
            updateCart(t = {}, e = null) {
                let i = t.quantity;
                null !== e && (i ? e.classList.add($l) : e.classList.add(Nl)), this.disableCartButtons(), this.addLoadingClass();
                const s = this.cart.querySelector(`[${sc}="${t.id}"]`) || e,
                    o = (null == s ? void 0 : s.hasAttribute(oc)) ? parseInt(s.getAttribute(oc)) : 0,
                    n = (null == s ? void 0 : s.hasAttribute(nc)) ? s.getAttribute(nc) : null;
                if (0 === o) return;
                const r = {
                    line: o,
                    quantity: i
                };
                fetch(theme.routes.cart_change_url, {
                    method: "post",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify(r)
                }).then((t => {
                    if (400 === t.status) {
                        const e = new Error(t.status);
                        throw this.cartDrawerEnabled ? this.getCart() : window.location = theme.routes.cart_url, e
                    }
                    return t.text()
                })).then((t => {
                    if (JSON.parse(t).errors) return this.cartUpdateFailed = !0, this.updateErrorText(n), this.toggleErrorMessage(), this.resetLineItem(e), this.enableCartButtons(), void this.removeLoadingClass();
                    this.getCart()
                })).catch((t => {
                    console.log(t), this.enableCartButtons(), this.removeLoadingClass()
                }))
            }
            resetLineItem(t) {
                const e = t.querySelector(xl.qtyInput),
                    i = e.getAttribute("value");
                e.value = i, t.classList.remove($l)
            }
            disableCartButtons() {
                const t = this.cart.querySelectorAll("input"),
                    e = this.cart.querySelectorAll(`button, ${xl.cartItemRemove}`);
                t.length && t.forEach((t => {
                    t.classList.add(zl), t.blur(), t.disabled = !0
                })), e.length && e.forEach((t => {
                    t.setAttribute(tc, !0)
                }))
            }
            enableCartButtons() {
                const t = this.cart.querySelectorAll("input"),
                    e = this.cart.querySelectorAll(`button, ${xl.cartItemRemove}`);
                t.length && t.forEach((t => {
                    t.classList.remove(zl), t.disabled = !1
                })), e.length && e.forEach((t => {
                    t.removeAttribute(tc)
                }))
            }
            updateErrorText(t) {
                this.cartErrorHolder.querySelector(xl.errorMessage).innerText = t
            }
            toggleErrorMessage() {
                if (this.cartErrorHolder) {
                    if (this.cartErrorHolder.classList.toggle(Bl, this.cartUpdateFailed), this.cartUpdateFailed) {
                        const t = this.cartErrorHolder.querySelector(xl.cartCloseError);
                        this.focusOnErrorMessage(this.cartErrorHolder, t)
                    }
                    this.cartUpdateFailed = !1
                }
            }
            handleErrors(t) {
                return t.ok ? t : t.json().then((function(e) {
                    throw new vt({
                        status: t.statusText,
                        headers: t.headers,
                        json: e
                    })
                }))
            }
            addToCartError(t) {
                const e = this.button.closest(xl.quickBuyForm),
                    i = this.button.closest(xl.upsellHolder),
                    s = !document.body.classList.contains(Kl);
                let o = (this.button.closest(xl.productForm) ? this.button.closest(xl.productForm) : this.button.closest(xl.upsellHolder)).querySelector(xl.formErrorsContainer);
                i && (o = i.querySelector(xl.formErrorsContainer)), this.cartDrawerEnabled && this.button && null !== this.button.closest(xl.cartDrawer) && !this.button.closest(xl.cartDrawer) && this.closeCartDrawer(), this.button.classList.remove($l), this.button.removeAttribute(tc);
                const n = e ? "" : `\n      <button type="button" class="errors__button-close" data-close-error>\n        ${theme.icons.close}\n      </button>\n    `;
                let r = `${t.message}: ${t.description}`;
                if (this.recipientErrors && t.description && "object" == typeof t.description && (r = Object.entries(t.description).map((([t, e]) => `${e}`)).join("<br>")), o.innerHTML = `\n      <div class="errors" data-error autofocus>\n        ${r}\n        ${n}\n      </div>\n    `, e) {
                    const t = o.closest(xl.productMediaContainer);
                    t.classList.add(Ql), o.querySelector(xl.error).addEventListener("animationend", (() => {
                        t.classList.remove(Ql), o.innerHTML = "", s || document.activeElement.blur()
                    }))
                } else o.classList.add(_l), o.addEventListener("transitionend", (() => {
                    this.resizeSliders(o)
                })), this.handleCloseErrorMessages(o)
            }
            handleCloseErrorMessages(t) {
                const e = t.querySelector(xl.formCloseError);
                null == e || e.addEventListener("click", (e => {
                    const i = e.target;
                    (i.matches(xl.formCloseError) || i.closest(xl.formCloseError)) && (e.preventDefault(), t.classList.remove(_l), t.querySelector(xl.error).addEventListener("transitionend", (() => {
                        t.innerHTML = "", this.resizeSliders(i)
                    })))
                })), this.focusOnErrorMessage(t, e)
            }
            focusOnErrorMessage(t, e) {
                !document.body.classList.contains(Kl) && t.addEventListener("transitionend", (() => {
                    requestAnimationFrame((() => null == e ? void 0 : e.focus({
                        focusVisible: !0
                    })))
                }))
            }
            hideAddToCartErrorMessage() {
                const t = this.button.closest(xl.upsellHolder) ? this.button.closest(xl.upsellHolder) : this.button.closest(xl.productForm),
                    e = null == t ? void 0 : t.querySelector(xl.formErrorsContainer);
                null == e || e.classList.remove(_l)
            }
            resizeSliders(t) {
                const i = t.closest(xl.flickityEnabled);
                if (!i) return;
                const s = e.data(i);
                requestAnimationFrame((() => s.resize()))
            }
            renderCartDrawer(t = !0) {
                const e = document.querySelector(xl.cartDrawerTemplate);
                e && (this.cartDrawer.innerHTML = e.innerHTML, this.assignArguments(), this.initQuantity(), this.cartEvents(), this.buttonHolder && (this.collapsible = new Ct(this.buttonHolder)), this.cartDrawerToggle = this.cartDrawer.querySelector(xl.cartDrawerToggle), this.cartDrawerToggle.addEventListener("click", this.cartDrawerToggleClickEvent), this.isCartDrawerLoaded = !0, this.renderPairProducts(), document.dispatchEvent(new CustomEvent("theme:cart:loaded", {
                    bubbles: !0
                })), t && this.openCartDrawer())
            }
            openCartDrawer() {
                this.isCartDrawerOpen || (this.isCartDrawerLoaded ? (document.dispatchEvent(new CustomEvent("theme:cart:open", {
                    bubbles: !0
                })), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                    bubbles: !0,
                    detail: this.cartDrawer
                })), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                    bubbles: !0,
                    detail: this.cartDrawerBody
                })), document.body.classList.add(Ml), this.cartDrawer.classList.add(Ol), this.cartDrawer.classList.remove(Gl), this.cartDrawer.querySelectorAll(xl.aos).forEach((t => {
                    requestAnimationFrame((() => {
                        t.classList.add(Ul)
                    }))
                })), this.cartToggleButtons.forEach((t => {
                    t.setAttribute(Zl, !0)
                })), this.a11y.trapFocus({
                    container: this.cartDrawer
                }), this.observeAdditionalCheckoutButtons(), this.isCartDrawerOpen = !0) : this.renderCartDrawer())
            }
            closeCartDrawer() {
                if (!this.isCartDrawerOpen) return;
                document.dispatchEvent(new CustomEvent("theme:cart:close", {
                    bubbles: !0
                })), this.cartAnimationTimer && clearTimeout(this.cartAnimationTimer), this.cartAnimationTimer = setTimeout((() => {
                    this.cartDrawer.querySelectorAll(xl.aos).forEach((t => {
                        t.classList.remove(Ul)
                    }))
                }), 300), this.cartErrorHolder.classList.remove(Bl), this.a11y.removeTrapFocus(), this.cartToggleButtons.forEach((t => {
                    t.setAttribute(Zl, !1)
                })), document.body.classList.remove(Ml), this.cartDrawer.classList.remove(Ol), this.itemsHolder.classList.remove(jl);
                const t = e => {
                    e.target === this.cartDrawer && (requestAnimationFrame((() => {
                        this.cartDrawer.classList.add(Gl)
                    })), this.cartDrawer.removeEventListener("transitionend", t))
                };
                this.cartDrawer.addEventListener("transitionend", t);
                !document.body.classList.contains(Kl) || requestAnimationFrame((() => {
                    document.activeElement.blur()
                }));
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                    bubbles: !0,
                    detail: 400
                })), this.isCartDrawerOpen = !1
            }
            toggleCartDrawer() {
                this.isCartDrawerOpen ? this.closeCartDrawer() : this.openCartDrawer()
            }
            cartDrawerToggleEvents() {
                this.cartDrawer && (this.cartDrawer.addEventListener("keyup", (t => {
                    t.code === theme.keyboardKeys.ESCAPE && this.closeCartDrawer()
                })), this.cartDrawerToggleClickEvent = t => {
                    t.preventDefault();
                    const e = t.target;
                    "false" === e.getAttribute(Zl) && (this.a11y.state.trigger = e), this.toggleCartDrawer()
                }, this.cartDrawerCloseEvent = t => {
                    const e = t.target.matches(xl.cartDrawerToggle),
                        i = document.querySelector(xl.cartDrawer).contains(t.target),
                        s = t.target.closest(xl.popupQuickView);
                    e || i || s || this.closeCartDrawer()
                }, this.cartToggleButtons.forEach((t => {
                    t.addEventListener("click", this.cartDrawerToggleClickEvent)
                })), document.addEventListener("mousedown", this.cartDrawerCloseEvent))
            }
            toggleClassesOnContainers() {
                const t = this;
                this.emptyMessage.classList.toggle(Dl, t.hasItemsInCart()), this.buttonHolder.classList.toggle(Dl, !t.hasItemsInCart()), this.itemsHolder.classList.toggle(Dl, !t.hasItemsInCart()), this.cartItemsQty.classList.toggle(Dl, !t.hasItemsInCart())
            }
            build(t) {
                const e = t.querySelector(xl.apiLineItems),
                    s = t.querySelector(xl.apiUpsellItems),
                    o = Boolean(null === e && null === s),
                    n = t.querySelector(xl.apiCartPrice),
                    r = t.querySelector(xl.cartTotal);
                this.priceHolder && n && (this.priceHolder.innerHTML = n.innerHTML), this.emptyMessage.querySelectorAll(xl.aos).forEach((t => {
                    t.classList.remove(Ul)
                })), o ? (this.itemsHolder.innerHTML = "", this.pairProductsHolder && (this.pairProductsHolder.innerHTML = "")) : (this.itemsHolder.innerHTML = e.innerHTML, this.pairProductsHolder && (this.pairProductsHolder.innerHTML = s.innerHTML), this.renderPairProducts()), this.newTotalItems = e && e.querySelectorAll(xl.item).length ? e.querySelectorAll(xl.item).length : 0, this.subtotal = r && r.hasAttribute(Yl) ? parseInt(r.getAttribute(Yl)) : 0, this.cartCount = this.getCartItemCount(), this.cartMessage.length > 0 && this.updateProgress(), this.cartToggleButtons.forEach((t => {
                    t.classList.remove(Vl), this.newTotalItems > 0 && t.classList.add(Vl)
                })), this.toggleErrorMessage(), this.updateItemsQuantity(this.cartCount), this.cartTotalPrice.forEach((t => {
                    t.innerHTML = 0 === this.subtotal ? window.theme.strings.free : i.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)
                })), this.totalItems !== this.newTotalItems && (this.totalItems = this.newTotalItems, this.toggleClassesOnContainers()), this.isCartDrawerOpen && this.itemsHolder.classList.add(jl), this.cartEvents(), this.initQuantity(), this.enableCartButtons(), this.resetButtonClasses(), this.removeLoadingClass(), document.dispatchEvent(new CustomEvent("theme:cart:added", {
                    bubbles: !0
                })), this.cartDrawer && this.openCartDrawer()
            }
            getCartItemCount() {
                return this.cart ? Array.from(this.cart.querySelectorAll(xl.qtyInput)).reduce(((t, e) => t + parseInt(e.value)), 0) : 0
            }
            hasItemsInCart() {
                return this.totalItems > 0
            }
            freeShippingMessageHandle(t) {
                this.cartMessage.length > 0 && document.querySelectorAll(xl.cartMessage).forEach((e => {
                    const i = e.hasAttribute(Jl) && "true" === e.getAttribute(Jl) && 0 !== t,
                        s = e.querySelector(xl.cartMessageDefault);
                    e.classList.toggle(Rl, t >= this.cartFreeLimitShipping && i), e.classList.toggle(Hl, 0 === t), s.classList.toggle(Hl, t >= this.cartFreeLimitShipping)
                }))
            }
            updateProgress() {
                const t = this.subtotal / this.cartFreeLimitShipping * 100,
                    e = theme.settings.currency_code_enable ? i.formatMoney(this.cartFreeLimitShipping - this.subtotal, theme.moneyWithCurrencyFormat) : i.formatMoney(this.cartFreeLimitShipping - this.subtotal, theme.moneyFormat);
                this.cartMessage.length > 0 && document.querySelectorAll(xl.cartMessage).forEach((i => {
                    const s = i.querySelectorAll(xl.cartProgress),
                        o = i.querySelector(xl.leftToSpend);
                    o && (o.innerHTML = e.replace(".00", "").replace(",00", "")), s.length && s.forEach(((e, i) => {
                        e.classList.toggle(Hl, this.subtotal / this.cartFreeLimitShipping >= 1), e.style.setProperty("--progress-width", `${t}%`), 0 === i && e.setAttribute(ec, t)
                    })), this.freeShippingMessageHandle(this.subtotal)
                }))
            }
            renderPairProducts() {
                if (this.flktyUpsell = null, this.pairProductsHolder = document.querySelector(xl.pairProductsHolder), this.pairProducts = document.querySelector(xl.pairProducts), this.upsellHolders = document.querySelectorAll(xl.upsellHolder), null === this.pairProductsHolder || void 0 === this.pairProductsHolder) return;
                const t = this;
                this.upsellHolders.length > 1 ? this.flktyUpsell = new e(this.pairProducts, {
                    wrapAround: !0,
                    pageDots: !0,
                    adaptiveHeight: !0,
                    prevNextButtons: !1,
                    on: {
                        ready: function() {
                            new Fl(t.cart), this.reloadCells(), requestAnimationFrame((() => this.resize()))
                        }
                    }
                }) : new Fl(this.cart)
            }
            updateItemsQuantity(t) {
                let e = theme.strings.cart_items_one,
                    i = theme.strings.cart_items_many;
                e = e.split("}}")[1], i = i.split("}}")[1], this.cartItemsQty && (this.cartItemsQty.textContent = 1 === t ? `${t} ${e}` : `${t} ${i}`)
            }
            observeAdditionalCheckoutButtons() {
                const t = this.cart.querySelector(xl.additionalCheckoutButtons);
                if (t) {
                    const e = new MutationObserver((() => {
                        this.a11y.removeTrapFocus(), this.a11y.trapFocus({
                            container: this.cart
                        }), e.disconnect()
                    }));
                    e.observe(t, {
                        subtree: !0,
                        childList: !0
                    })
                }
            }
            formSubmitHandler() {
                const t = document.querySelector(xl.cartTermsCheckbox).checked,
                    e = document.querySelector(xl.termsErrorMessage);
                if (t) e.classList.remove(Bl), this.cartCheckoutButton.removeAttribute(tc);
                else {
                    if (document.querySelector(xl.termsErrorMessage).length > 0) return;
                    e.innerText = theme.strings.cart_acceptance_error, this.cartCheckoutButton.setAttribute(tc, !0), e.classList.add(Bl)
                }
            }
            resetButtonClasses() {
                const t = document.querySelectorAll(xl.buttonAddToCart);
                t && t.forEach((t => {
                    t.classList.contains($l) && (t.classList.remove($l), t.classList.add(Rl), setTimeout((() => {
                        t.removeAttribute(tc), t.classList.remove(Rl)
                    }), Il.timers.addProductTimeout))
                }))
            }
            addLoadingClass() {
                this.cartDrawer ? this.cartDrawer.classList.add($l) : this.itemsWrapper && this.itemsWrapper.classList.add($l)
            }
            removeLoadingClass() {
                this.cartDrawer ? this.cartDrawer.classList.remove($l) : this.itemsWrapper && this.itemsWrapper.classList.remove($l)
            }
            unload() {
                this.cartDrawerToggle && this.cartDrawerToggle.removeEventListener("click", this.cartDrawerToggleClickEvent), this.cartToggleButtons.forEach((t => {
                    t.removeEventListener("click", this.cartDrawerToggleClickEvent)
                })), document.removeEventListener("mousedown", this.cartDrawerCloseEvent), null !== this.collapsible && this.collapsible.onUnload()
            }
            constructor() {
                "/password" !== window.location.pathname && this.init()
            }
        };
    ct("cart-template", {
        onLoad() {
            cc[this.id] = new hc
        }, onUnload() {
            "function" == typeof cc[this.id].unload && cc[this.id].unload()
        }
    });
    const dc = "is-visible",
        uc = document.querySelector("[data-scroll-top-button]");
    uc && (uc.addEventListener("click", (() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        })
    })), document.addEventListener("scroll", gt((() => {
        uc.classList.toggle(dc, window.pageYOffset > window.innerHeight)
    }), 150)));
    const pc = "details",
        mc = "[data-popdown-body]",
        gc = "[data-popdown-close]",
        vc = "[data-popdown-toggle]",
        yc = "[data-search-form-inner]",
        fc = "[data-popular-searches-link]",
        bc = "[data-site-header]",
        wc = "[data-nav]",
        Ec = "[data-nav-items-compress]",
        Sc = "[data-nav-icons]",
        Lc = "[data-mobile-menu]",
        kc = "predictive-search",
        Ac = "search-form",
        qc = "data-popdown-in-header",
        Cc = "data-popdown-in-page",
        Tc = "data-search-performed",
        Pc = "search-opened",
        Fc = "site-header--menu-opened",
        Ic = "nav--compress";
    let xc = class extends HTMLElement {
        connectedCallback() {
            this.isPopdownInHeader && (this.details.addEventListener("keyup", (t => "ESCAPE" === t.code.toUpperCase() && this.close())), this.popdownClose.addEventListener("click", (() => this.close())), this.popdownToggle.addEventListener("click", (t => this.onPopdownToggleClick(t))), this.popdownToggle.setAttribute("role", "button")), this.isPopdownInPage && (this.popdownClose.addEventListener("click", (() => this.triggerPopdownClose())), this.searchFormWrapper.addEventListener("focusout", (() => this.onFocusOut())), this.searchFormWrapper.input.addEventListener("click", (t => this.triggerPopdownOpen(t)))), this.searchFormInner.addEventListener("transitionend", (t => {
                t.target === this.searchFormInner && this.details.hasAttribute("open") && "false" == this.details.getAttribute("open") && this.onClose()
            })), this.popularSearchesLink.forEach((t => {
                t.addEventListener("click", (t => {
                    t.preventDefault();
                    const e = t.target.textContent;
                    this.searchFormWrapper.input.value = e, this.searchFormWrapper.submit()
                }))
            }))
        }
        onPopdownToggleClick(t) {
            t.preventDefault(), t.target.closest(pc).hasAttribute("open") ? this.close() : this.open(t)
        }
        onBodyClick(t) {
            var e;
            const i = this.contains(t.target);
            (null === (e = this.header) || void 0 === e ? void 0 : e.classList.contains(Fc)) || i || i || this.close()
        }
        onFocusOut() {
            this.predictiveSearch && requestAnimationFrame((() => {
                this.searchFormWrapper.contains(document.activeElement) || this.searchFormWrapper.close()
            }))
        }
        triggerPopdownOpen(t) {
            const e = this.closest(`[${Tc}="false"]`),
                i = matchMedia("(pointer:coarse)").matches,
                s = window.innerWidth < theme.sizes.small,
                o = i || s,
                n = null != e;
            if (this.nav && this.mobileMenu && (o || n)) {
                t.preventDefault();
                const e = this.nav.classList.contains(Ic);
                let s = this.mobileMenu.querySelector(vc);
                i || (s = e ? this.nav.querySelector(`${Ec} ${vc}`) : this.nav.querySelector(`${Sc} ${vc}`)), setTimeout((() => {
                    null == s || s.dispatchEvent(new Event("click", {
                        bubbles: !0
                    }))
                }), 300)
            }
        }
        open(t) {
            this.onBodyClickEvent = t => this.onBodyClick(t), t.target.closest(pc).setAttribute("open", ""), this.searchFormWrapper.input.setAttribute("aria-expanded", !0), document.body.classList.add(Pc), document.body.addEventListener("click", this.onBodyClickEvent), document.addEventListener("theme:resize", this.ensureClosingOnResizeEvent), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                bubbles: !0
            })), this.a11y.state.trigger = t.target, requestAnimationFrame((() => {
                requestAnimationFrame((() => {
                    t.target.closest(pc).setAttribute("open", "true"), this.a11y.trapFocus({
                        container: this.searchFormInner
                    })
                }))
            }))
        }
        close() {
            this.a11y.removeTrapFocus(), this.details.setAttribute("open", "false"), this.predictiveSearch && this.searchFormWrapper.close(), this.searchFormWrapper.handleFocusableDescendants(!0)
        }
        triggerPopdownClose() {
            this.predictiveSearch && this.searchFormWrapper.close(), this.searchFormWrapper.popularSearches && requestAnimationFrame((() => document.activeElement.blur()))
        }
        onClose() {
            this.details.removeAttribute("open"), document.dispatchEvent(new CustomEvent("theme:search:close", {
                bubbles: !0
            })), document.body.classList.remove(Pc), document.body.removeEventListener("click", this.onBodyClickEvent), document.removeEventListener("theme:resize", this.ensureClosingOnResizeEvent), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                bubbles: !0
            }))
        }
        ensureClosingOnResize() {
            null === this.offsetParent && this.onClose()
        }
        constructor() {
            var t, e, i;
            super(), this.isPopdownInHeader = this.hasAttribute(qc), this.isPopdownInPage = this.hasAttribute(Cc), this.popdownBody = this.querySelector(mc), this.popdownClose = this.querySelector(gc), this.searchFormInner = this.querySelector(yc), this.popularSearchesLink = this.querySelectorAll(fc), this.searchFormWrapper = this.querySelector(Ac) ? this.querySelector(Ac) : this.querySelector(kc), this.predictiveSearch = this.searchFormWrapper.matches(kc), this.header = document.querySelector(bc), this.headerSection = null === (t = this.header) || void 0 === t ? void 0 : t.parentNode, this.nav = null === (e = this.header) || void 0 === e ? void 0 : e.querySelector(wc), this.mobileMenu = null === (i = this.headerSection) || void 0 === i ? void 0 : i.querySelector(Lc), this.a11y = _t, this.ensureClosingOnResizeEvent = () => this.ensureClosingOnResize(), this.isPopdownInHeader && (this.details = this.querySelector(pc), this.popdownToggle = this.querySelector(vc))
        }
    };
    customElements.define("search-popdown", xc), theme.ProductModel = function() {
        let t = {},
            e = {},
            i = {};
        const s = {
                productMediaWrapper: "[data-product-single-media-wrapper]",
                mediaGroup: "[data-product-single-media-group]",
                productXr: "[data-shopify-xr]",
                mediaId: "data-media-id",
                model3d: "data-shopify-model3d-id",
                modelViewer: "model-viewer",
                modelJson: "#ModelJson-",
                deferredMedia: "[data-deferred-media]",
                deferredMediaButton: "[data-deferred-media-button]"
            },
            o = {
                isLoading: "is-loading",
                mediaHidden: "media--hidden"
            };

        function n(t, n) {
            if (t.querySelector(s.deferredMedia).getAttribute("loaded")) return;
            t.classList.add(o.isLoading);
            const l = document.createElement("div");
            l.appendChild(t.querySelector("template").content.firstElementChild.cloneNode(!0));
            const c = l.querySelector("model-viewer"),
                h = t.querySelector(s.deferredMedia);
            h.appendChild(c), h.setAttribute("loaded", !0);
            const d = t.dataset.mediaId,
                u = c.dataset.modelId,
                p = t.closest(s.mediaGroup).parentElement.querySelector(s.productXr);
            i[n] = {
                element: p,
                defaultId: u
            }, e[d] = {
                modelId: u,
                mediaId: d,
                sectionId: n,
                container: t,
                element: c
            }, window.ShopifyXR ? a() : window.Shopify.loadFeatures([{
                name: "shopify-xr",
                version: "1.0",
                onLoad: r
            }, {
                name: "model-viewer-ui",
                version: "1.0",
                onLoad: a
            }])
        }

        function r(e) {
            if (e) console.warn(e);
            else if (window.ShopifyXR) {
                for (const e in t)
                    if (t.hasOwnProperty(e)) {
                        const i = t[e];
                        if (i.loaded) continue;
                        const o = document.querySelector(`${s.modelJson}${e}`);
                        o && (window.ShopifyXR.addModels(JSON.parse(o.innerHTML)), i.loaded = !0)
                    }
                window.ShopifyXR.setupXRElements()
            } else document.addEventListener("shopify_xr_initialized", (function() {
                r()
            }))
        }

        function a(t) {
            if (t) console.warn(t);
            else
                for (const t in e)
                    if (e.hasOwnProperty(t)) {
                        const i = e[t];
                        i.modelViewerUi || (i.modelViewerUi = new Shopify.ModelViewerUI(i.element), l(i))
                    }
        }

        function l(t) {
            const e = i[t.sectionId];
            t.container.addEventListener("theme:media:visible", (function() {
                e.element.setAttribute(s.model3d, t.modelId), window.theme.touch || (t.modelViewerUi.play(), t.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                    bubbles: !0
                }))
            })), t.container.addEventListener("theme:media:hidden", (function() {
                t.modelViewerUi.pause()
            })), t.container.addEventListener("xrLaunch", (function() {
                t.modelViewerUi.pause()
            })), t.element.addEventListener("load", (() => {
                e.element.setAttribute(s.model3d, t.modelId), t.container.classList.remove(o.isLoading), t.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                    bubbles: !0
                })
            })), t.element.addEventListener("shopify_model_viewer_ui_toggle_play", (function() {
                c(t.mediaId), setTimeout((() => {
                    t.container.dispatchEvent(new CustomEvent("theme:media:play"), {
                        bubbles: !0
                    })
                }), 50)
            })), t.element.addEventListener("shopify_model_viewer_ui_toggle_pause", (function() {
                t.container.dispatchEvent(new CustomEvent("theme:media:pause"), {
                    bubbles: !0
                })
            })), c(t.mediaId)
        }

        function c(t) {
            const e = `[${s.mediaId}="${t}"]`,
                i = document.querySelectorAll(`${s.productMediaWrapper}:not(${e})`);
            i.length && i.forEach((t => {
                t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                    bubbles: !0
                }), t.classList.add(o.mediaHidden)
            }))
        }
        return {
            init: function(e, i) {
                t[i] = {
                    loaded: !1
                };
                const o = e.querySelector(s.deferredMediaButton);
                o && o.addEventListener("click", n.bind(this, e, i))
            },
            loadContent: n,
            removeSectionModels: function(i) {
                for (const t in e)
                    if (e.hasOwnProperty(t)) {
                        e[t].sectionId === i && delete e[t]
                    }
                delete t[i], delete theme.mediaInstances[i]
            }
        }
    }(), ct("collection-template", fo);
    const Dc = ".template-customers-addresses",
        Hc = "[data-form]",
        Mc = "[data-form-new]",
        Oc = "[data-button-new]",
        _c = "[data-button-edit]",
        Bc = "[data-button-delete]",
        $c = "[data-button-cancel]",
        zc = "data-form-edit",
        Rc = "AddressCountryNew",
        Vc = "AddressProvinceNew",
        Wc = "AddressProvinceContainerNew",
        Nc = "[data-country-option]",
        Uc = "AddressCountry",
        jc = "AddressProvince",
        Kc = "AddressProvinceContainer",
        Qc = 'input[type="text"]:not(.optional)',
        Gc = "data-form-id",
        Xc = "is-hidden",
        Jc = "validation--showup";
    const Yc = document.querySelector(Dc);
    Yc && new class {
        init() {
            if (this.addressNewForm) {
                const t = this.section,
                    e = this.addressNewForm;
                this.customerAddresses();
                const i = t.querySelectorAll(Oc);
                i.length && i.forEach((t => {
                    t.addEventListener("click", (function(i) {
                        i.preventDefault(), t.classList.add(Xc), e.classList.remove(Xc)
                    }))
                }));
                const s = t.querySelectorAll(_c);
                s.length && s.forEach((e => {
                    e.addEventListener("click", (function(e) {
                        e.preventDefault();
                        const i = this.getAttribute(Gc);
                        t.querySelector(`[${zc}="${i}"]`).classList.toggle(Xc)
                    }))
                }));
                const o = t.querySelectorAll(Bc);
                o.length && o.forEach((t => {
                    t.addEventListener("click", (function(t) {
                        t.preventDefault();
                        const e = this.getAttribute(Gc);
                        confirm(theme.strings.delete_confirm) && Shopify.postLink("/account/addresses/" + e, {
                            parameters: {
                                _method: "delete"
                            }
                        })
                    }))
                }));
                const n = t.querySelectorAll($c);
                n.length && n.forEach((t => {
                    t.addEventListener("click", (function(t) {
                        t.preventDefault(), this.closest(Hc).classList.add(Xc), document.querySelector(Oc).classList.remove(Xc)
                    }))
                }))
            }
        }
        customerAddresses() {
            Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(Rc, Vc, {
                hideElement: Wc
            }), this.section.querySelectorAll(Nc).forEach((t => {
                const e = t.getAttribute(Gc),
                    i = `${Uc}_${e}`,
                    s = `${jc}_${e}`,
                    o = `${Kc}_${e}`;
                new Shopify.CountryProvinceSelector(i, s, {
                    hideElement: o
                })
            }))
        }
        validate() {
            this.accountForms.forEach((t => {
                const e = t.querySelector("form"),
                    i = e.querySelectorAll(Qc);
                e.addEventListener("submit", (t => {
                    let e = !1;
                    i.forEach((t => {
                        t.value ? t.nextElementSibling.classList.remove(Jc) : (t.nextElementSibling.classList.add(Jc), e = !0)
                    })), e && t.preventDefault()
                }))
            }))
        }
        constructor(t) {
            this.section = t, this.addressNewForm = this.section.querySelector(Mc), this.accountForms = this.section.querySelectorAll(Hc), this.init(), this.validate()
        }
    }(Yc);
    const Zc = "[data-account-form]",
        th = "[data-show-reset]",
        eh = "[data-hide-reset]",
        ih = "[data-recover-password]",
        sh = "[data-login-form]",
        oh = "[data-recover-success]",
        nh = "[data-recover-success-text]",
        rh = "#recover",
        ah = "is-hidden";
    const lh = document.querySelector(Zc);
    lh && new class {
        init() {
            window.location.hash == rh ? this.showRecoverPasswordForm() : this.hideRecoverPasswordForm(), this.success && this.successText.classList.remove(ah), this.showButton.addEventListener("click", (t => {
                t.preventDefault(), this.showRecoverPasswordForm()
            }), !1), this.hideButton.addEventListener("click", (t => {
                t.preventDefault(), this.hideRecoverPasswordForm()
            }), !1)
        }
        showRecoverPasswordForm() {
            return this.recover.classList.remove(ah), this.login.classList.add(ah), window.location.hash = rh, !1
        }
        hideRecoverPasswordForm() {
            return this.login.classList.remove(ah), this.recover.classList.add(ah), window.location.hash = "", !1
        }
        constructor(t) {
            this.form = t, this.showButton = t.querySelector(th), this.hideButton = t.querySelector(eh), this.recover = t.querySelector(ih), this.login = t.querySelector(sh), this.success = t.querySelector(oh), this.successText = t.querySelector(nh), this.init()
        }
    }(lh), ct("search-template", [fo, Jo]);
    const ch = "[data-ticker-scale]",
        hh = "[data-ticker-text]",
        dh = "data-clone",
        uh = "data-marquee-speed",
        ph = "ticker--animated",
        mh = "ticker--unloaded",
        gh = "ticker__comparitor",
        vh = 1.63,
        yh = 100;
    const fh = "[data-bar]",
        bh = "[data-slide]",
        wh = "[data-top-bar-slide]",
        Eh = "[data-ticker-frame]",
        Sh = "[data-slider]",
        Lh = "[data-ticker-scale]",
        kh = "[data-ticker-text]",
        Ah = "data-slide",
        qh = "data-slider-speed",
        Ch = "data-stop",
        Th = "style",
        Ph = "data-target-referrer",
        Fh = "desktop",
        Ih = "mobile",
        xh = "ticker--animated",
        Dh = {};
    const Hh = {
        onLoad() {
            Dh[this.id] = [];
            const t = this.container.querySelector(fh);
            t && Dh[this.id].push(new class {
                init() {
                    this.removeAnnouncement(), this.slider && (this.initSlider(), document.addEventListener("theme:resize:width", this.initSlider.bind(this))), this.slider || (this.initTickers(!0), this.tickerAnimationPause())
                }
                removeAnnouncement() {
                    for (let t = 0; t < this.slides.length; t++) {
                        const e = this.slides[t];
                        e.hasAttribute(Ph) && (-1 !== this.locationPath.indexOf(e.getAttribute(Ph)) || window.Shopify.designMode || e.parentNode.removeChild(e))
                    }
                }
                initSlider() {
                    if (this.slider.querySelectorAll(bh)) {
                        let t = `${bh}`;
                        t = window.innerWidth < theme.sizes.small ? `${bh}:not(.${Fh})` : `${bh}:not(.${Ih})`, null != this.flkty && this.flkty.destroy(), this.flkty = new e(this.slider, {
                            cellSelector: t,
                            pageDots: !1,
                            prevNextButtons: !1,
                            wrapAround: !0,
                            autoPlay: parseInt(this.slider.getAttribute(qh), 10),
                            on: {
                                ready: () => {
                                    setTimeout((() => {
                                        this.slider.dispatchEvent(new CustomEvent("slider-is-loaded", {
                                            bubbles: !0,
                                            detail: {
                                                slider: this
                                            }
                                        }))
                                    }), 10)
                                }
                            }
                        }), this.flkty.reposition()
                    }
                    this.slider.addEventListener("slider-is-loaded", (() => {
                        this.initTickers()
                    }))
                }
                initTickers(t = !1) {
                    this.barHolder.querySelectorAll(Eh).forEach((e => {
                        const i = new class {
                            listen() {
                                document.addEventListener("theme:resize:width", this.resizeEvent), this.checkWidth()
                            }
                            checkWidth() {
                                const t = 2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
                                if (this.frame.clientWidth - t < this.comparitor.clientWidth || this.stopClone) {
                                    if (1 === this.scale.childElementCount) {
                                        if (this.text.classList.add(ph), this.clone = this.text.cloneNode(!0), this.clone.setAttribute(dh, ""), this.scale.appendChild(this.clone), this.stopClone)
                                            for (let t = 0; t < 10; t++) {
                                                const t = this.text.cloneNode(!0);
                                                t.setAttribute(dh, ""), this.scale.appendChild(t)
                                            }
                                        let t = this.frame.getAttribute(uh);
                                        null === t && (t = 100);
                                        const e = vh * (100 / parseInt(t, 10)),
                                            i = this.text.clientWidth / yh * e;
                                        this.scale.style.setProperty("--animation-time", `${i}s`)
                                    }
                                } else {
                                    this.text.classList.add(ph);
                                    let t = this.scale.querySelector(`[${dh}]`);
                                    t && this.scale.removeChild(t), this.text.classList.remove(ph)
                                }
                            }
                            unload() {
                                document.removeEventListener("theme:resize:width", this.resizeEvent)
                            }
                            constructor(t, e = !1) {
                                this.frame = t, this.stopClone = e, this.scale = this.frame.querySelector(ch), this.text = this.frame.querySelector(hh), this.comparitor = this.text.cloneNode(!0), this.comparitor.classList.add(gh), this.frame.appendChild(this.comparitor), this.scale.classList.remove(mh), this.resizeEvent = n((() => this.checkWidth()), 100), this.listen()
                            }
                        }(e, t);
                        this.tickers.push(i);
                        const s = e.querySelectorAll(bh);
                        if (0 !== s.length) {
                            const t = e.querySelectorAll(`${bh}.${Ih}`),
                                i = e.querySelectorAll(`${bh}.${Fh}`);
                            s.length === t.length ? e.parentNode.classList.add(Ih) : s.length === i.length && e.parentNode.classList.add(Fh)
                        }
                    }))
                }
                toggleTicker(t, e) {
                    const i = t.target.closest(Lh),
                        s = document.querySelector(`[${Ah}="${t.detail.blockId}"]`);
                    e && s && (i.setAttribute(Ch, ""), i.querySelectorAll(kh).forEach((t => {
                        t.classList.remove(xh), t.style.transform = `translate3d(${-(s.offsetLeft-parseInt(getComputedStyle(s).marginLeft,10))}px, 0, 0)`
                    }))), !e && s && (i.querySelectorAll(kh).forEach((t => {
                        t.classList.add(xh), t.removeAttribute(Th)
                    })), i.removeAttribute(Ch))
                }
                tickerAnimationPause() {
                    let t = 0,
                        e = !1;
                    const i = this.barHolder.querySelector(wh);
                    i.addEventListener("mouseenter", (() => {
                        e = !0, t = setTimeout((() => {
                            e && i.querySelectorAll(kh).forEach((t => {
                                t.style.animationPlayState = "paused"
                            })), clearTimeout(t)
                        }), 500)
                    })), i.addEventListener("mouseleave", (() => {
                        e = !1, i.querySelectorAll(kh).forEach((t => {
                            t.style.animationPlayState = "running"
                        }))
                    }))
                }
                onBlockSelect(t) {
                    const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    this.slider && null !== this.flkty && (this.flkty.select(e), this.flkty.pausePlayer()), this.slider || this.toggleTicker(t, !0)
                }
                onBlockDeselect(t) {
                    this.slider && null !== this.flkty && this.flkty.unpausePlayer(), this.slider || this.toggleTicker(t, !1)
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.initSlider.bind(this)), this.tickers.length > 0 && this.tickers.forEach((t => {
                        t.unload()
                    }))
                }
                constructor(t) {
                    this.barHolder = t, this.locationPath = location.href, this.slides = this.barHolder.querySelectorAll(bh), this.slider = this.barHolder.querySelector(Sh), this.tickers = [], this.flkty = null, this.init()
                }
            }(t))
        }, onBlockSelect(t) {
            Dh[this.id].length && Dh[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        }, onBlockDeselect(t) {
            Dh[this.id].length && Dh[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockDeselect(t)
            }))
        }, onUnload() {
            Dh[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        }
    };
    ct("announcement-bar", Hh), ct("marquee", Hh);
    const Mh = "[data-collapsible-trigger]",
        Oh = "is-expanded";
    ct("accordions", [{
        onBlockSelect(t) {
            const e = t.target.querySelector(Mh);
            requestAnimationFrame((() => {
                e.classList.contains(Oh) || e.dispatchEvent(new Event("click"))
            }))
        }
    }, Tt]);
    const _h = "[data-share-button]",
        Bh = "[data-share-button-tooltip]",
        $h = "is-visible",
        zh = "is-hiding",
        Rh = {};
    const Vh = {
        onLoad() {
            Rh[this.id] = new class {
                init() {
                    this.button && this.button.addEventListener("click", (() => {
                        let t = window.location.href;
                        this.button.dataset.shareLink && (t = this.button.dataset.shareLink), this.tooltip.classList.contains($h) || navigator.clipboard.writeText(t).then((() => {
                            this.tooltip.classList.add($h), setTimeout((() => {
                                this.tooltip.classList.add(zh), this.tooltip.classList.remove($h), this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout), this.hideTransitionTimeout = setTimeout((() => {
                                    this.tooltip.classList.remove(zh)
                                }), this.transitionSpeed)
                            }), 1500)
                        }))
                    }))
                }
                constructor(t) {
                    this.container = t, this.button = this.container.querySelector(_h), this.tooltip = this.container.querySelector(Bh), this.transitionSpeed = 200, this.hideTransitionTimeout = 0, this.init()
                }
            }(this.container)
        }
    };
    ct("article", [Vh]);
    const Wh = "[data-video-play]",
        Nh = "data-video-play";
    const Uh = {
            onLoad() {
                new class {
                    init() {
                        this.videoPlay.length && this.videoPlay.forEach((t => {
                            t.addEventListener("click", (e => {
                                if (t.hasAttribute(Nh) && "" !== t.getAttribute(Nh).trim()) {
                                    e.preventDefault();
                                    const i = [{
                                        html: t.getAttribute(Nh)
                                    }];
                                    this.a11y.state.trigger = t, new dl(i)
                                }
                            }))
                        }))
                    }
                    constructor(t) {
                        this.container = t, this.videoPlay = this.container.querySelectorAll(Wh), this.a11y = _t, this.init()
                    }
                }(this.container)
            }
        },
        jh = "[data-site-header]",
        Kh = "[data-main]";
    let Qh = {};
    const Gh = {
        onLoad() {
            Qh[this.id] = new class {
                init() {
                    var t;
                    if ("true" !== this.container.dataset.zoomAnimation) return;
                    const e = this.container,
                        i = document.body.querySelector(Kh).children[0],
                        s = this.container.parentNode === i,
                        o = "true" == (null === (t = this.header) || void 0 === t ? void 0 : t.dataset.transparent),
                        n = () => {
                            var t, i;
                            const n = s & o ? 0 : parseInt((null === (t = this.header) || void 0 === t ? void 0 : t.dataset.height) || (null === (i = this.header) || void 0 === i ? void 0 : i.offsetHeight)),
                                r = e.getBoundingClientRect(),
                                a = e.offsetHeight,
                                l = s ? n - r.top : n - r.top + window.innerHeight;
                            let c = .1;
                            s && (c *= 1.5);
                            let h = 1 + l / a * c;
                            h = h > 1 ? h : 1, e.style.setProperty("--scale", h)
                        };
                    n(), this.zoomOnScrollEvent = gt(n, 5), new IntersectionObserver((t => {
                        t[0].isIntersecting ? window.addEventListener("scroll", this.zoomOnScrollEvent) : window.removeEventListener("scroll", this.zoomOnScrollEvent)
                    }), {
                        root: null,
                        rootMargin: "0px",
                        threshold: 0
                    }).observe(e)
                }
                onUnload() {
                    null !== this.zoomOnScrollEvent && window.removeEventListener("scroll", this.zoomOnScrollEvent)
                }
                constructor(t) {
                    this.container = t, this.header = document.querySelector(jh), this.init()
                }
            }(this.container)
        }, onUnload() {
            Qh[this.id].onUnload()
        }
    };
    ct("banner-image", [Gh, Uh]);
    const Xh = "[data-banner]",
        Jh = "[data-slider]",
        Yh = "[data-banners-media]",
        Zh = "data-index",
        td = "data-slider-single-image";
    let ed = {};
    ct("banner-with-text-columns", {
        onLoad() {
            ed[this.id] = new class {
                initSliders() {
                    if (this.slider.children.length <= 1) return;
                    let t = window.innerWidth < window.theme.sizes.small;
                    this.sliderMedia.children.length > 1 && (this.flktyMedia = new e(this.sliderMedia, {
                        draggable: !1,
                        wrapAround: !1,
                        fade: !0,
                        prevNextButtons: !1,
                        adaptiveHeight: !1,
                        pageDots: !1,
                        setGallerySize: !1
                    }), ae(this.sliderMedia)), this.flkty = new e(this.slider, {
                        draggable: t,
                        prevNextButtons: !1,
                        pageDots: !0,
                        cellAlign: "left",
                        adaptiveHeight: !1,
                        imagesLoaded: !0,
                        lazyLoad: !0,
                        on: {
                            ready: () => {
                                this.links.forEach((t => {
                                    t.addEventListener("focus", (() => {
                                        const e = Number(t.closest(Xh).getAttribute(Zh));
                                        window.innerWidth >= theme.sizes.small && this.syncContent(e)
                                    }))
                                })), this.banners.forEach((t => {
                                    t.addEventListener("mouseenter", (() => {
                                        const e = Number(t.getAttribute(Zh));
                                        window.innerWidth >= theme.sizes.small && !window.theme.touch && this.syncContent(e)
                                    })), t.addEventListener("pointerup", (() => {
                                        const e = Number(t.getAttribute(Zh));
                                        window.innerWidth >= theme.sizes.small && window.theme.touch && this.syncContent(e)
                                    }))
                                }))
                            },
                            change: t => {
                                window.innerWidth < theme.sizes.small && !this.singleImageEnabled && this.flktyMedia.select(t)
                            }
                        }
                    }), ae(this.slider)
                }
                syncContent(t = 0) {
                    this.flkty.selectCell(t), this.flktyMedia && this.flktyMedia.selectCell(t)
                }
                resizeSlider() {
                    this.flkty && (this.flkty.resize(), this.toggleDraggable()), this.flktyMedia && this.flktyMedia.resize()
                }
                toggleDraggable() {
                    this.flkty.options.draggable = window.innerWidth < window.theme.sizes.small, this.flkty.updateDraggable()
                }
                onBlockSelect(t) {
                    const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    this.flktyMedia && this.flktyMedia.selectCell(e)
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.sliderResizeEvent)
                }
                constructor(t) {
                    var e;
                    this.container = t.container, this.slider = this.container.querySelector(Jh), this.singleImageEnabled = null === (e = this.slider) || void 0 === e ? void 0 : e.hasAttribute(td), this.banners = this.container.querySelectorAll(Xh), this.links = this.container.querySelectorAll("a"), this.sliderMedia = this.container.querySelector(Yh), this.flkty = null, this.flktyMedia = null, this.sliderResizeEvent = () => this.resizeSlider(), this.slider && (this.initSliders(), document.addEventListener("theme:resize:width", this.sliderResizeEvent))
                }
            }(this)
        }, onBlockSelect(t) {
            ed[this.id].onBlockSelect(t)
        }
    }), ct("blog-posts", bs);
    const id = "[data-slider]",
        sd = "[data-slider-item]",
        od = "[data-media-container]",
        nd = "a, button",
        rd = ".flickity-button",
        ad = "carousel--inactive",
        ld = "tabindex",
        cd = {};
    const hd = {
        onLoad() {
            cd[this.id] = new class {
                initSlider() {
                    this.slider.classList.remove(ad), this.flkty = new e(this.slider, {
                        pageDots: !1,
                        cellAlign: "left",
                        groupCells: !0,
                        contain: !0,
                        on: {
                            ready: () => {
                                this.setSliderArrowsPosition(this.slider), setTimeout((() => {
                                    this.changeTabIndex()
                                }), 0)
                            },
                            change: () => {
                                this.changeTabIndex()
                            }
                        }
                    })
                }
                destroySlider() {
                    this.slider.classList.add(ad), null !== this.flkty && (this.flkty.destroy(), this.flkty = null)
                }
                checkSlidesSize() {
                    const t = this.container.querySelector(sd).currentStyle || window.getComputedStyle(this.container.querySelector(sd));
                    this.gutter = parseInt(t.marginRight);
                    const e = this.slider.offsetWidth < this.getItemsWidth();
                    window.innerWidth >= theme.sizes.small && e ? this.initSlider() : this.destroySlider()
                }
                changeTabIndex() {
                    const t = this.flkty.selectedIndex;
                    this.flkty.slides.forEach(((e, i) => {
                        e.cells.forEach((e => {
                            e.element.querySelectorAll(nd).forEach((e => {
                                e.setAttribute(ld, t === i ? "0" : "-1")
                            }))
                        }))
                    }))
                }
                getItemsWidth() {
                    let t = 0;
                    const e = this.slider.querySelectorAll(sd);
                    return e.length && e.forEach((e => {
                        t += e.offsetWidth + this.gutter
                    })), t
                }
                listen() {
                    this.slider && (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize))
                }
                setSliderArrowsPosition(t) {
                    const e = t.querySelectorAll(rd),
                        i = t.querySelector(od);
                    e.length && i && e.forEach((t => {
                        t.style.top = i.offsetHeight / 2 + "px"
                    }))
                }
                onBlockSelect(t) {
                    if (null !== this.flkty) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s)
                    } else {
                        const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                            i = parseInt(e.paddingLeft),
                            s = t.target.offsetLeft - i;
                        this.slider.scrollTo({
                            top: 0,
                            left: s,
                            behavior: "smooth"
                        })
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize)
                }
                constructor(t) {
                    this.container = t.container, this.slider = this.container.querySelector(id), this.flkty = null, this.gutter = 0, this.checkSlidesSizeOnResize = () => this.checkSlidesSize(), this.listen()
                }
            }(this)
        }, onUnload(t) {
            cd[this.id].onUnload(t)
        }, onBlockSelect(t) {
            cd[this.id].onBlockSelect(t)
        }
    };
    ct("columns-with-image", [hd, Uh]);
    const dd = "[data-form-message-close]",
        ud = "[data-form-message]",
        pd = "hide-down",
        md = "notification-visible";
    let gd = {};
    ct("contact-form", {
        onLoad() {
            gd[this.id] = new class {
                hidePopups() {
                    document.body.classList.add(md)
                }
                showPopups() {
                    document.body.classList.remove(md)
                }
                closeFormMessage() {
                    this.closeButton.addEventListener("click", this.closeMessage.bind(this))
                }
                closeMessage(t) {
                    t.preventDefault(), this.messageWrapper.classList.add(pd), this.showPopups()
                }
                autoHideMessage() {
                    setTimeout((() => {
                        this.messageWrapper.classList.add(pd), this.showPopups()
                    }), 1e4)
                }
                constructor(t) {
                    this.container = t.container, this.closeButton = this.container.querySelector(dd), this.messageWrapper = this.container.querySelector(ud), this.messageWrapper && (this.hidePopups(), this.closeFormMessage(), this.autoHideMessage())
                }
            }(this)
        }
    });
    const vd = "[data-video-id]",
        yd = "[data-video-player]",
        fd = "[data-video-template]",
        bd = "[data-video-autoplay]",
        wd = "[data-video-wrapper]",
        Ed = "[data-video-bg-play]",
        Sd = "is-loading",
        Ld = "is-paused",
        kd = {};
    const Ad = {
        onLoad() {
            kd[this.id] = [];
            this.container.querySelectorAll(wd).forEach((t => {
                kd[this.id].push(new class {
                    init() {
                        this.videoId && (new IntersectionObserver(((t, e) => {
                            t.forEach((t => {
                                if (t.isIntersecting) {
                                    const i = this.videoTemplate.innerHTML;
                                    this.videoPlayer.innerHTML = i, this.video = this.container.querySelector(bd), this.videoPlayer.classList.remove(Sd), this.container.classList.add(Ld), this.listen(), e.unobserve(t.target)
                                }
                            }))
                        }), {
                            root: null,
                            rootMargin: "300px",
                            threshold: [0, .1, .25, .5, .75, 1]
                        }).observe(this.videoPlayer), this.videoPlayButton.addEventListener("click", (t => {
                            var e;
                            t.preventDefault(), null === (e = this.video) || void 0 === e || e.play()
                        })))
                    }
                    listen() {
                        this.video.addEventListener("play", (() => {
                            this.container.classList.remove(Ld)
                        })), this.container.addEventListener("touchstart", (() => {
                            this.video.play()
                        }), {
                            passive: !0
                        })
                    }
                    constructor(t) {
                        this.container = t, this.videoId = this.container.querySelector(vd), this.videoPlayer = this.container.querySelector(yd), this.videoTemplate = this.container.querySelector(fd), this.videoPlayButton = this.container.querySelector(Ed), this.init()
                    }
                }(t))
            }))
        }
    };
    let qd = class {
        write() {
            (-1 !== document.cookie.indexOf("; ") && !document.cookie.split("; ").find((t => t.startsWith(this.name))) || -1 === document.cookie.indexOf("; ")) && (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`)
        }
        read() {
            if (-1 !== document.cookie.indexOf("; ") && document.cookie.split("; ").find((t => t.startsWith(this.name)))) {
                return document.cookie.split("; ").find((t => t.startsWith(this.name))).split("=")[1]
            }
            return !1
        }
        destroy() {
            document.cookie.split("; ").find((t => t.startsWith(this.name))) && (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`)
        }
        constructor(t, e) {
            this.configuration = {
                expires: null,
                path: "/",
                domain: window.location.hostname,
                sameSite: "none",
                secure: !0
            }, this.name = t, this.value = e
        }
    };
    const Cd = "[data-newsletter-form]",
        Td = "[data-popup]",
        Pd = "has-success",
        Fd = "has-error",
        Id = "newsletter_form_id",
        xd = {};
    const Dd = {
            onLoad() {
                xd[this.id] = [];
                this.container.querySelectorAll(Cd).forEach((t => {
                    xd[this.id].push(new class {
                        init() {
                            this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage()
                        }
                        newsletterSubmitEvent(t) {
                            this.stopSubmit && (t.preventDefault(), this.removeStorage(), this.writeStorage(), this.stopSubmit = !1, this.newsletter.submit())
                        }
                        checkForChallengePage() {
                            this.isChallengePage = window.location.pathname === theme.routes.root + "challenge"
                        }
                        writeStorage() {
                            void 0 !== this.sessionStorage && this.sessionStorage.setItem(Id, this.newsletter.id)
                        }
                        readStorage() {
                            this.formID = this.sessionStorage.getItem(Id)
                        }
                        removeStorage() {
                            this.sessionStorage.removeItem(Id)
                        }
                        showMessage() {
                            if (this.readStorage(), this.newsletter.id === this.formID) {
                                const t = document.getElementById(this.formID),
                                    e = -1 !== window.location.search.indexOf("?customer_posted=true"),
                                    i = -1 !== window.location.search.indexOf("accepts_marketing");
                                e ? (t.classList.remove(Fd), t.classList.add(Pd), this.popup && (this.cookie = new qd(this.popup.dataset.cookieName, "user_has_closed"), this.cookie.write())) : i && (t.classList.remove(Pd), t.classList.add(Fd)), (e || i) && this.scrollToForm(t)
                            }
                        }
                        scrollToForm(t) {
                            const e = t.getBoundingClientRect();
                            visibilityHelper.isElementPartiallyVisible(t) || visibilityHelper.isElementTotallyVisible(t) || setTimeout((() => {
                                window.scrollTo({
                                    top: e.top,
                                    left: 0,
                                    behavior: "smooth"
                                })
                            }), 400)
                        }
                        onUnload() {
                            this.newsletter.removeEventListener("submit", this.newsletterSubmit)
                        }
                        constructor(t) {
                            this.newsletter = t, this.sessionStorage = window.sessionStorage, this.popup = this.newsletter.closest(Td), this.stopSubmit = !0, this.isChallengePage = !1, this.formID = null, this.formIdSuccess = null, this.checkForChallengePage(), this.newsletterSubmit = t => this.newsletterSubmitEvent(t), this.isChallengePage || this.init()
                        }
                    }(t))
                }))
            }, onUnload() {
                xd[this.id].forEach((t => {
                    "function" == typeof t.onUnload && t.onUnload()
                }))
            }
        },
        Hd = "[data-product]",
        Md = "[data-slider]",
        Od = "[data-slide]",
        _d = "[data-product-media-container]",
        Bd = ".flickity-button",
        $d = "a, button",
        zd = "tabindex",
        Rd = {};
    const Vd = {
        onLoad() {
            Rd[this.id] = new class {
                checkSlider() {
                    window.innerWidth >= theme.sizes.small ? this.productSlider.forEach((t => {
                        this.initProductSlider(t)
                    })) : this.productSlider.forEach((t => {
                        this.destroyProductSlider(t)
                    }))
                }
                initProductSlider(t) {
                    const i = t.querySelectorAll(Od).length,
                        s = t.dataset.slider;
                    i > 1 && (void 0 !== this.flkty[s] && this.flkty[s].isActive ? this.setSliderArrowsPosition(t) : this.flkty[s] = new e(t, {
                        prevNextButtons: !0,
                        pageDots: !0,
                        wrapAround: !0,
                        on: {
                            ready: () => {
                                this.setSliderArrowsPosition(t)
                            },
                            change: t => {
                                this.flkty[s].cells.forEach(((e, i) => {
                                    e.element.querySelectorAll($d).forEach((e => {
                                        e.setAttribute(zd, i === t ? "0" : "-1")
                                    }))
                                }))
                            }
                        }
                    }))
                }
                destroyProductSlider(t) {
                    const e = t.dataset.slider;
                    "object" == typeof this.flkty[e] && this.flkty[e].destroy()
                }
                setSliderArrowsPosition(t) {
                    const e = t.querySelectorAll(Bd),
                        i = t.querySelector(_d);
                    e.length && i && e.forEach((t => {
                        t.style.top = i.offsetHeight / 2 + "px"
                    }))
                }
                listen() {
                    this.checkSlider(), document.addEventListener("theme:resize:width", this.checkSliderOnResize)
                }
                onUnload() {
                    if (this.flkty)
                        for (const t in this.flkty) this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
                    document.removeEventListener("theme:resize:width", this.checkSliderOnResize)
                }
                constructor(t) {
                    this.container = t, this.product = this.container.querySelectorAll(Hd), this.productSlider = this.container.querySelectorAll(Md), this.checkSliderOnResize = () => this.checkSlider(), this.flkty = [], this.videoObj = [], this.quickViewObj = [], this.listen()
                }
            }(this.container)
        }, onUnload(t) {
            Rd[this.id].onUnload(t)
        }
    };
    ct("custom-content", [Vd, Dd, Uh, Ad, us]);
    const Wd = "[data-slider]",
        Nd = "[data-slide]",
        Ud = "[data-product-media-container]",
        jd = "a, button",
        Kd = ".flickity-button",
        Qd = "[data-promo]",
        Gd = "carousel",
        Xd = "carousel--inactive",
        Jd = "is-last-slide-visible",
        Yd = "featured-collection",
        Zd = "collection-promo--full",
        tu = "collection-promo--two-columns",
        eu = "data-slider-id",
        iu = "data-slider-show-image",
        su = "tabindex",
        ou = {};
    let nu = class {
        initSlider(t) {
            const i = t.getAttribute(eu);
            t.classList.remove(Xd), void 0 !== this.flkty[i] && this.flkty[i].isActive ? this.setSliderArrowsPosition(t) : (this.flkty[i] = new e(t, {
                pageDots: !1,
                cellSelector: Nd,
                cellAlign: "left",
                groupCells: !0,
                contain: !0,
                wrapAround: !1,
                adaptiveHeight: !1,
                on: {
                    ready: () => {
                        this.setSliderArrowsPosition(t), setTimeout((() => {
                            this.changeTabIndex(t)
                        }), 0)
                    },
                    change: () => {
                        this.changeTabIndex(t)
                    }
                }
            }), this.handleLastSlideOverlayOnTablet(t))
        }
        destroySlider(t) {
            const e = t.getAttribute(eu);
            t.classList.contains(Gd) && t.classList.add(Xd), "object" == typeof this.flkty[e] && this.flkty[e].destroy()
        }
        resetSlider(t) {
            const e = t.target,
                i = e.getAttribute(eu);
            "object" == typeof this.flkty[i] ? this.flkty[i].select(0, !1, !0) : e.scrollTo({
                left: 0,
                behavior: "instant"
            })
        }
        checkSlidesSize() {
            this.sliders.length && this.sliders.forEach((t => {
                const e = this.columns,
                    i = window.innerWidth >= theme.sizes.large,
                    s = window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large,
                    o = t.querySelectorAll(Nd);
                let n = o.length;
                const r = t.querySelectorAll(Qd);
                let a = !1;
                if (r.length && i && r.forEach((t => {
                        t.classList.contains(Zd) ? n += e - 1 : t.classList.contains(tu) && (n += 1)
                    })), t.hasAttribute(iu) && (n += 1), e) a = n > e;
                else {
                    const e = window.getComputedStyle(t, null);
                    let i = t.clientWidth;
                    i -= parseFloat(e.paddingLeft) + parseFloat(e.paddingRight), a = this.getSlidesWidth(o) > i
                }
                i && a || s && n > 2 ? this.initSlider(t) : this.destroySlider(t)
            }))
        }
        changeTabIndex(t) {
            const e = t.getAttribute(eu),
                i = this.flkty[e].selectedIndex;
            this.flkty[e].slides.forEach(((t, e) => {
                t.cells.forEach((t => {
                    t.element.querySelectorAll(jd).forEach((t => {
                        t.setAttribute(su, i === e ? "0" : "-1")
                    }))
                }))
            }))
        }
        getSlidesWidth(t) {
            let e = 0;
            return t.length && t.forEach((t => {
                e += t.offsetWidth
            })), e
        }
        setSliderArrowsPosition(t) {
            const e = t.querySelectorAll(Kd),
                i = t.querySelector(Ud);
            e.length && i && e.forEach((t => {
                t.style.top = i.offsetHeight / 2 + "px"
            }))
        }
        handleLastSlideOverlayOnTablet(t) {
            const e = t.getAttribute(eu);
            this.flkty[e].on("select", (() => {
                if (!(window.innerWidth >= theme.sizes.small && window.innerWidth < theme.sizes.large)) return;
                const i = this.flkty[e].selectedIndex,
                    s = this.flkty[e].slides.length - 1 === i;
                t.parentNode.classList.toggle(Jd, s)
            }))
        }
        handleLastSlideOverlayOnMobile() {
            this.sliders.forEach((t => {
                t.addEventListener("scroll", (e => {
                    if (!(window.innerWidth < theme.sizes.small)) return;
                    const i = e.target.offsetWidth,
                        s = Array.from(t.children).pop().getBoundingClientRect().left + 80 < i;
                    t.parentNode.classList.toggle(Jd, s)
                }))
            }))
        }
        listen() {
            this.sliders.length && (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize), this.sliders.forEach((t => {
                t.addEventListener("theme:tab:change", this.resetSliderEvent)
            })))
        }
        onBlockSelect(t) {
            const i = t.target.closest(Wd),
                s = e.data(i) || null;
            if (!i) return;
            let o = t.target.parentNode,
                n = t.target;
            if (this.container.classList.contains(Yd) && (o = o.parentNode, n = n.parentNode), null !== s && s.isActive) {
                const t = parseInt([...o.children].indexOf(n)),
                    e = parseInt(s.slides[0].cells.length),
                    i = Math.floor(t / e);
                s.select(i)
            } else {
                const t = i.currentStyle || window.getComputedStyle(i),
                    e = parseInt(t.paddingLeft),
                    s = n.offsetLeft - e;
                i.scrollTo({
                    top: 0,
                    left: s,
                    behavior: "smooth"
                })
            }
        }
        onUnload() {
            if (this.flkty)
                for (const t in this.flkty) this.flkty.hasOwnProperty(t) && this.flkty[t].destroy();
            document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize), this.sliders.length && this.sliders.forEach((t => {
                t.removeEventListener("theme:tab:change", this.resetSliderEvent)
            }))
        }
        constructor(t) {
            this.container = t, this.columns = parseInt(this.container.dataset.columns), this.sliders = this.container.querySelectorAll(Wd), this.checkSlidesSizeOnResize = () => this.checkSlidesSize(), this.resetSliderEvent = t => this.resetSlider(t), this.flkty = [], this.listen(), this.handleLastSlideOverlayOnMobile()
        }
    };
    const ru = {
        onLoad() {
            ou[this.id] = [];
            this.container.querySelectorAll(Wd).forEach((t => {
                ou[this.id].push(new nu(this.container))
            }))
        }, onUnload() {
            ou[this.id].forEach((t => {
                "function" == typeof t.onUnload && t.onUnload()
            }))
        }, onBlockSelect(t) {
            ou[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        }
    };
    ct("featured-collection", [us, Re, ru]), ct("featured-video", [Uh, Ad]);
    const au = "[data-collapsible-trigger-mobile]",
        lu = "is-expanded";
    ct("footer", [oa, Dd, Tt, {
        onBlockSelect(t) {
            const e = t.target.querySelector(au);
            requestAnimationFrame((() => {
                e && !e.classList.contains(lu) && e.dispatchEvent(new Event("click"))
            }))
        }, onBlockDeselect(t) {
            const e = t.target.querySelector(au);
            requestAnimationFrame((() => {
                e && e.classList.contains(lu) && e.dispatchEvent(new Event("click"))
            }))
        }
    }]);
    const cu = "[data-hover-disclosure]",
        hu = "[data-site-header]",
        du = "[data-top-link]",
        uu = "[data-header-background]",
        pu = "[data-nav-item]",
        mu = "is-visible",
        gu = "grandparent",
        vu = "site-header--menu-opened",
        yu = "has-scrolled",
        fu = "site-header--hovered",
        bu = "data-hover-disclosure-toggle",
        wu = "aria-haspopup",
        Eu = "aria-expanded",
        Su = "aria-controls";
    let Lu = {};
    const ku = {
            onLoad() {
                Lu[this.id] = [];
                this.container.querySelectorAll(cu).forEach((t => {
                    Lu[this.id].push(new class {
                        showDisclosure() {
                            this.hasScrolled = document.body.classList.contains(yu), this.headerHeight = this.hasScrolled ? window.stickyHeaderHeight : this.header.offsetHeight, this.grandparent ? (this.dropdown.style.height = "auto", this.dropdownHeight = this.dropdown.offsetHeight) : this.dropdownHeight = this.headerHeight, this.background.style.setProperty("--header-background-height", `${this.dropdownHeight}px`), this.trigger.setAttribute(Eu, !0), this.trigger.classList.add(mu), this.header.classList.add(vu), this.updateHeaderHover()
                        }
                        hideDisclosure() {
                            this.background.style.removeProperty("--header-background-height"), this.trigger.classList.remove(mu), this.trigger.setAttribute(Eu, !1), this.header.classList.remove(vu)
                        }
                        updateHeaderHover() {
                            requestAnimationFrame((() => {
                                const t = this.header.matches(":hover"),
                                    e = this.header.classList.contains(fu);
                                t && !e && this.header.classList.add(fu)
                            }))
                        }
                        handleTablets() {
                            this.trigger.addEventListener("touchstart", (t => {
                                if (!this.trigger.classList.contains(mu)) {
                                    t.preventDefault();
                                    const e = this.header.querySelectorAll(`.${mu}${pu}`);
                                    if (e.length > 0) return void e.forEach((t => {
                                        if (t !== this.trigger) {
                                            t.dispatchEvent(new Event("mouseleave", {
                                                bubbles: !0
                                            }));
                                            const e = () => {
                                                requestAnimationFrame((() => {
                                                    this.showDisclosure()
                                                })), t.removeEventListener("transitionend", e)
                                            };
                                            t.addEventListener("transitionend", e)
                                        }
                                    }));
                                    this.showDisclosure()
                                }
                            }))
                        }
                        connectHoverToggle() {
                            this.trigger.addEventListener("mouseenter", (() => this.showDisclosure())), this.link.addEventListener("focus", (() => this.showDisclosure())), this.trigger.addEventListener("mouseleave", (() => this.hideDisclosure())), this.trigger.addEventListener("focusout", (t => {
                                this.trigger.contains(t.relatedTarget) || this.hideDisclosure()
                            })), this.disclosure.addEventListener("keyup", (t => {
                                t.code === theme.keyboardKeys.ESCAPE && this.hideDisclosure()
                            }))
                        }
                        onBlockSelect(t) {
                            this.disclosure.contains(t.target) && this.showDisclosure(t)
                        }
                        onBlockDeselect(t) {
                            this.disclosure.contains(t.target) && this.hideDisclosure()
                        }
                        constructor(t) {
                            this.disclosure = t, this.header = t.closest(hu), this.key = this.disclosure.id, this.trigger = document.querySelector(`[${bu}='${this.key}']`), this.link = this.trigger.querySelector(du), this.grandparent = this.trigger.classList.contains(gu), this.background = document.querySelector(uu), this.trigger.setAttribute(wu, !0), this.trigger.setAttribute(Eu, !1), this.trigger.setAttribute(Su, this.key), this.dropdown = this.trigger.querySelector(cu), this.connectHoverToggle(), this.handleTablets()
                        }
                    }(t))
                }))
            }, onBlockSelect(t) {
                Lu[this.id].forEach((e => {
                    "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
                }))
            }, onBlockDeselect(t) {
                Lu[this.id].forEach((e => {
                    "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
                }))
            }
        },
        Au = "[data-site-header]",
        qu = "[data-announcement-wrapper]",
        Cu = "[data-collection-filters]",
        Tu = "[data-logo]",
        Pu = "[data-logo-text-link]",
        Fu = "[data-collapsible-trigger]",
        Iu = "#nav-drawer",
        xu = "[data-drawer]",
        Du = "[data-drawer-toggle]",
        Hu = "[data-popdown-toggle]",
        Mu = "[data-mobile-menu]",
        Ou = "[data-nav]",
        _u = "[data-nav-icons]",
        Bu = "[data-nav-item]",
        $u = "[data-nav-link-mobile]",
        zu = "[data-nav-search-open]",
        Ru = "[data-wrapper]",
        Vu = "[data-header-background]",
        Wu = "[data-cart-page]",
        Nu = "[data-takes-space]",
        Uu = {
            jsDrawerOpenAll: ["js-drawer-open", "js-drawer-open-cart", "js-quick-view-visible"],
            headerTransparent: "site-header--transparent",
            headerLoading: "site-header--loading",
            headerHovered: "site-header--hovered",
            headerMenuOpened: "site-header--menu-opened",
            hasScrolled: "has-scrolled",
            hideHeader: "hide-header",
            navCompress: "nav--compress",
            logoCompress: "logo--compress",
            isVisible: "is-visible",
            isOpen: "is-open",
            searchOpened: "search-opened",
            noOutline: "no-outline",
            cloneClass: "js__header__clone"
        },
        ju = "data-nav-alignment",
        Ku = {};
    ct("header", [{
        onLoad() {
            Ku[this.id] = new class {
                updateHeaderHover() {
                    requestAnimationFrame((() => {
                        const t = this.header.matches(":hover"),
                            e = this.header.classList.contains(Uu.headerHovered);
                        t && !e && this.header.classList.add(Uu.headerHovered)
                    }))
                }
                handleTouchstart(t) {
                    const e = this.header.contains(t.target),
                        i = this.header.querySelector(`.${Uu.isVisible}${Bu}`);
                    !e && i && i.dispatchEvent(new Event("mouseleave", {
                        bubbles: !0
                    }))
                }
                handleTextLinkLogos() {
                    if (null === this.logoTextLink) return;
                    const t = this.header.offsetHeight;
                    document.documentElement.style.setProperty("--header-height", `${t}px`), document.documentElement.style.setProperty("--header-sticky-height", `${t}px`)
                }
                initStickyHeader() {
                    if (this.hasScrolled = !1, this.hasCollectionFilters = document.querySelector(Cu), this.position = this.header.dataset.position, "fixed" === this.position && !this.hasCollectionFilters) return this.header.classList.remove(Uu.headerLoading), this.headerState(), void document.addEventListener("theme:scroll", this.headerStateEvent);
                    document.body.classList.remove(Uu.hasScrolled), window.isHeaderTransparent && this.header.classList.add(Uu.headerTransparent), this.header.classList.remove(Uu.headerLoading)
                }
                headerState(t) {
                    const e = parseInt(this.header.dataset.height || this.header.offsetHeight),
                        i = document.querySelector(qu),
                        s = e + (i ? i.offsetHeight : 0),
                        o = window.pageYOffset || document.documentElement.scrollTop,
                        n = t && t.detail && t.detail.up;
                    this.hasScrolled = o > s, document.body.classList.toggle(Uu.hasScrolled, this.hasScrolled);
                    const r = o < s + window.stickyHeaderHeight && n;
                    if (document.body.classList.toggle(Uu.hideHeader, r), window.isHeaderTransparent) {
                        const t = !this.hasScrolled || r;
                        this.header.classList.toggle(Uu.headerTransparent, t)
                    }
                    if (this.header.classList.contains(Uu.headerHovered)) {
                        const t = this.hasScrolled ? window.stickyHeaderHeight : e;
                        this.background.style.setProperty("--header-background-height", `${t}px`);
                        const i = this.header.querySelector(`.${Uu.isVisible}${Bu}`);
                        i && i.dispatchEvent(new Event("mouseenter", {
                            bubbles: !0
                        }))
                    }
                }
                handleBackgroundEvents() {
                    this.headerWrapper.addEventListener("mouseenter", this.updateBackgroundHeightEvent), this.headerWrapper.addEventListener("mouseleave", this.updateBackgroundHeightEvent), this.header.addEventListener("focusout", this.updateBackgroundHeightEvent), document.addEventListener("theme:cart:close", this.updateBackgroundHeightEvent), document.addEventListener("theme:search:close", this.updateBackgroundHeightEvent)
                }
                updateBackgroundHeight(t) {
                    const e = matchMedia("(pointer:fine)").matches,
                        i = !document.body.classList.contains(Uu.noOutline),
                        s = e && !i;
                    if (t) {
                        if ("mouseenter" === t.type) {
                            let t = !1;
                            if (Uu.jsDrawerOpenAll.forEach((e => {
                                    document.body.classList.contains(e) && (t = !0)
                                })), t) return;
                            return this.headerHeight = this.hasScrolled ? window.stickyHeaderHeight : this.header.offsetHeight, this.header.classList.add(Uu.headerHovered), void(this.header.classList.contains(Uu.headerMenuOpened) || this.background.style.setProperty("--header-background-height", `${this.headerHeight}px`))
                        }("focusout" !== t.type || e) && ("theme:search:close" !== t.type || s) && (this.hasScrolled || requestAnimationFrame((() => {
                            const e = null === document.activeElement.closest(Au);
                            document.body.classList.contains(Uu.searchOpened) || ("focusout" !== t.type || e) && (this.header.classList.remove(Uu.headerHovered), this.background.style.setProperty("--header-background-height", "0px"), i || document.activeElement.blur())
                        })))
                    }
                }
                listenWidth() {
                    document.addEventListener("theme:resize", this.checkWidthEvent), this.checkWidth()
                }
                checkWidth() {
                    window.innerWidth < this.minWidth ? (this.nav.classList.add(Uu.navCompress), this.logo.classList.add(Uu.logoCompress)) : (this.nav.classList.remove(Uu.navCompress), this.logo.classList.remove(Uu.logoCompress))
                }
                getMinWidth() {
                    const t = this.headerWrapper.currentStyle || window.getComputedStyle(this.headerWrapper),
                        e = 2 * parseInt(t.paddingLeft),
                        i = this.header.cloneNode(!0);
                    i.classList.add(Uu.cloneClass), document.body.appendChild(i);
                    const s = i.querySelectorAll(Nu),
                        o = function(t, e) {
                            let i = [];
                            t.forEach((t => {
                                i.push(t.clientWidth)
                            }));
                            let [s, o, n] = i;
                            if ("left" === e) {
                                const t = s;
                                s = o, o = t
                            }
                            return "right" !== e && (s > n ? n = s : s = n), s + o + n
                        }(s, this.header.getAttribute(ju));
                    return document.body.removeChild(i), o + 20 * s.length + e
                }
                initMobileNav() {
                    var t;
                    if (this.mobileMenu = this.headerSection.querySelector(Mu), this.navDrawer = this.headerSection.querySelector(Iu), this.drawerToggle = this.navDrawer.querySelector(Du), this.navSearchOpen = this.navDrawer.querySelectorAll(zu), null === (t = this.navSearchOpen) || void 0 === t || t.forEach((t => {
                            t.addEventListener("click", (t => {
                                t.preventDefault();
                                const e = this.drawerToggle.closest(`${xu}.${Uu.isOpen}`),
                                    i = matchMedia("(pointer:coarse)").matches ? this.mobileMenu.querySelector(Hu) : this.nav.querySelector(Hu);
                                this.drawerToggle.dispatchEvent(new Event("click", {
                                    bubbles: !0
                                }));
                                const s = t => {
                                    t.target === e && (requestAnimationFrame((() => i.dispatchEvent(new Event("click", {
                                        bubbles: !0
                                    })))), e.removeEventListener("transitionend", s))
                                };
                                e.addEventListener("transitionend", s)
                            }))
                        })), "link" === theme.settings.mobileMenuBehaviour) return;
                    const e = this.headerSection.querySelectorAll($u);
                    e.length && e.forEach((t => {
                        t.addEventListener("click", (e => {
                            const i = t.parentNode.querySelectorAll(Fu).length,
                                s = t.nextElementSibling;
                            i && (e.preventDefault(), s.dispatchEvent(new Event("click"), {
                                bubbles: !0
                            }))
                        }))
                    }))
                }
                onUnload() {
                    document.documentElement.style.removeProperty("--header-height"), document.documentElement.style.removeProperty("--header-sticky-height"), this.initStickyHeader(), document.body.classList.remove(...Uu.jsDrawerOpenAll), document.removeEventListener("theme:scroll", this.headerStateEvent), document.removeEventListener("theme:resize", this.checkWidthEvent), document.removeEventListener("theme:cart:close", this.updateBackgroundHeightEvent), document.removeEventListener("theme:search:close", this.updateBackgroundHeightEvent), document.body.removeEventListener("touchstart", this.handleTouchstartEvent), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                        bubbles: !0
                    })), "function" == typeof window.cart.unload && window.cart.unload()
                }
                constructor(t) {
                    this.container = t, this.background = document.querySelector(Vu), this.header = t, this.headerSection = t.parentNode, this.headerWrapper = t.querySelector(Ru), this.logo = t.querySelector(Tu), this.logoTextLink = t.querySelector(Pu), this.nav = t.querySelector(Ou), this.navIcons = t.querySelector(_u), this.headerStateEvent = t => this.headerState(t), this.handleTouchstartEvent = t => this.handleTouchstart(t), this.updateBackgroundHeightEvent = t => this.updateBackgroundHeight(t), m(), this.minWidth = this.getMinWidth(), this.checkWidthEvent = () => this.checkWidth(), this.listenWidth(), this.initMobileNav(), this.handleTextLinkLogos(), this.initStickyHeader(), this.handleBackgroundEvents(), document.querySelector(Wu) || (window.cart = new hc), document.body.addEventListener("touchstart", this.handleTouchstartEvent, {
                        passive: !0
                    }), this.updateHeaderHover()
                }
            }(this.container)
        }, onUnload() {
            Ku[this.id].onUnload()
        }
    }, ku, dn]);
    const Qu = "[data-slider]";
    let Gu = {};
    ct("icons-row", {
        onLoad() {
            Gu[this.id] = new class {
                onBlockSelect(t) {
                    const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                        i = parseInt(e.paddingLeft),
                        s = t.target.offsetLeft - i;
                    this.slider.scrollTo({
                        top: 0,
                        left: s,
                        behavior: "smooth"
                    })
                }
                constructor(t) {
                    this.container = t.container, this.slider = this.container.querySelector(Qu)
                }
            }(this)
        }, onBlockSelect(t) {
            Gu[this.id].onBlockSelect(t)
        }
    });
    const Xu = "[data-accordion-item]",
        Ju = "[data-accordion-button]",
        Yu = "is-expanded",
        Zu = {};
    ct("image-accordions", {
        onLoad() {
            Zu[this.id] = new class {
                init() {
                    this.imageAccordionsItems.forEach((t => {
                        t.addEventListener("mouseenter", this.accordionExpandEvent.bind(this, t))
                    })), this.buttons.forEach((t => {
                        t.addEventListener("focusin", this.accordionFocusEvent.bind(this, t))
                    }))
                }
                accordionExpand(t) {
                    t.classList.contains(Yu) || (this.imageAccordionsItems.forEach((t => {
                        t.classList.remove(Yu)
                    })), t.classList.add(Yu))
                }
                accordionFocus(t) {
                    t.closest(Xu).dispatchEvent(new Event("mouseenter"))
                }
                onBlockSelect(t) {
                    const e = t.target;
                    e && e.dispatchEvent(new Event("mouseenter"))
                }
                constructor(t) {
                    this.container = t.container, this.imageAccordionsItems = this.container.querySelectorAll(Xu), this.buttons = this.container.querySelectorAll(Ju), this.accordionExpandEvent = t => this.accordionExpand(t), this.accordionFocusEvent = t => this.accordionFocus(t), this.init()
                }
            }(this)
        }, onBlockSelect(t) {
            Zu[this.id].onBlockSelect(t)
        }
    }), ct("image-with-text", Uh), ct("list-collections", ru);
    const tp = {},
        ep = "[data-slider-gallery]",
        ip = "[data-slider-info]",
        sp = "[data-slide-item]";
    ct("locations", {
        onLoad() {
            tp[this.id] = new class {
                initSlider() {
                    const t = this.container.querySelectorAll(sp).length;
                    let i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null;
                    t <= 1 || (i = new e(this.slider, {
                        fade: !0,
                        wrapAround: !0,
                        adaptiveHeight: !0,
                        prevNextButtons: !1,
                        pageDots: !1
                    }), ae(this.slider), s = new e(this.sliderNav, {
                        fade: !0,
                        wrapAround: !0,
                        imagesLoaded: !0,
                        lazyLoad: !0,
                        asNavFor: this.slider,
                        prevNextButtons: !0,
                        pageDots: !1
                    }), s.on("change", (() => {
                        i.selectCell(s.selectedIndex)
                    })), i.on("change", (() => {
                        s.selectCell(i.selectedIndex)
                    })))
                }
                onBlockSelect(t) {
                    const i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null,
                        o = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    null !== i && i.select(o), null !== s && s.select(o)
                }
                constructor(t) {
                    this.container = t.container, this.slider = this.container.querySelector(ep), this.sliderNav = this.container.querySelector(ip), this.initSlider()
                }
            }(this)
        }, onBlockSelect(t) {
            tp[this.id].onBlockSelect(t)
        }
    });
    const op = {},
        np = "[data-slider]",
        rp = "[data-slide-item]",
        ap = "[data-pointer]",
        lp = "[data-product-media-container]",
        cp = "[data-quick-view-item-holder]",
        hp = ".flickity-button",
        dp = "a, button",
        up = "[data-tooltip]",
        pp = "data-pointer",
        mp = "data-hotspot",
        gp = "tabindex",
        vp = "product-grid-item__image--hovered",
        yp = "pointer--selected",
        fp = "is-selected",
        bp = "is-active",
        wp = "pswp--open";
    const Ep = {
        onLoad() {
            op[this.id] = new class {
                listen() {
                    this.slider && (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize)), this.pointers.length > 0 && this.pointers.forEach((t => {
                        t.addEventListener("click", this.pointersInit), t.addEventListener("mouseover", this.pointersOver), t.addEventListener("mouseleave", this.pointersOut)
                    }))
                }
                checkSlidesSize() {
                    const t = window.innerWidth >= theme.sizes.small;
                    this.initTooltips(), t ? this.slides.length > 2 ? this.initSlider() : (this.destroySlider(), this.slidesTabIndex()) : !t && this.slides.length > 1 ? this.initSlider() : this.destroySlider()
                }
                initTooltips() {
                    this.tooltips = this.container.querySelectorAll(up), this.tooltips.forEach((t => {
                        new ze(t)
                    }))
                }
                initSlider() {
                    null !== this.flkty ? this.setSliderArrowsPosition() : this.flkty = new e(this.slider, {
                        prevNextButtons: !0,
                        wrapAround: !0,
                        adaptiveHeight: !1,
                        cellAlign: "left",
                        groupCells: !1,
                        contain: !0,
                        on: {
                            ready: () => {
                                this.slidesTabIndex(), this.setSliderArrowsPosition(), this.dotPointers()
                            },
                            change: () => {
                                this.slidesTabIndex(), this.dotPointers()
                            }
                        }
                    })
                }
                setSliderArrowsPosition() {
                    if (!(window.innerWidth >= theme.sizes.small)) return;
                    const t = this.slider.querySelectorAll(hp),
                        e = this.slider.querySelector(lp);
                    t.length && e && t.forEach((t => {
                        t.style.top = e.offsetHeight / 2 + "px"
                    }))
                }
                slidesTabIndex() {
                    if (this.slides.length < 3) return void this.slider.querySelectorAll(dp).forEach((t => {
                        t.setAttribute(gp, "0")
                    }));
                    const t = e.data(this.slider);
                    t.cells.forEach((t => {
                        t.element.querySelectorAll(dp).forEach((t => {
                            t.setAttribute(gp, "-1")
                        }))
                    })), t.cells.forEach((t => {
                        t.element.classList.contains(fp) && (t.element.querySelectorAll(dp).forEach((t => {
                            t.setAttribute(gp, "0")
                        })), (t.element.nextSibling ? t.element.nextSibling : t.element.parentNode.firstChild).querySelectorAll(dp).forEach((t => {
                            t.setAttribute(gp, "0")
                        })))
                    }))
                }
                destroySlider() {
                    "object" == typeof this.flkty && null !== this.flkty && (this.flkty.destroy(), this.flkty = null)
                }
                dotPointers(t) {
                    if (0 === this.pointers.length) return;
                    if (this.pointers.forEach((t => {
                            t.classList.remove(yp)
                        })), t) {
                        var e;
                        const i = t.target.getAttribute(pp);
                        return void(null === (e = this.flkty) || void 0 === e || e.select(i))
                    }
                    const i = null == this.flkty ? 0 : this.flkty.selectedIndex;
                    i >= 0 && this.pointers[i].classList.add(yp)
                }
                dotPointerIn(t) {
                    const e = t.target.getAttribute(pp),
                        i = this.slides[e].querySelector(lp),
                        s = matchMedia("(pointer:coarse)").matches;
                    window.innerWidth < theme.sizes.small || s || this.observeImage(i), this.pointers.forEach((t => {
                        t.style.setProperty("--look-animation", "none")
                    }))
                }
                dotPointerOut(t) {
                    const e = t.target.getAttribute(pp),
                        i = this.slides[e].querySelector(lp);
                    i.classList.remove(vp), i.dispatchEvent(new Event("mouseleave")), this.observer && this.observer.disconnect(), this.pointers.forEach((t => {
                        t.style.removeProperty("--look-animation")
                    }))
                }
                observeImage(t) {
                    this.observer = new IntersectionObserver(((t, e) => {
                        t.forEach((t => {
                            const e = t.target;
                            0 == t.intersectionRatio || (e.dispatchEvent(new Event("mouseenter")), e.classList.add(vp))
                        }))
                    }), {
                        root: this.slider,
                        threshold: [.95, 1]
                    }), this.observer.observe(t)
                }
                triggerClick(t) {
                    requestAnimationFrame((() => t.dispatchEvent(new Event("click"))))
                }
                destroyQuickViewPopup() {
                    var t, e;
                    const i = null === (t = this.quickViewPopup) || void 0 === t || null === (e = t.loadPhotoswipe) || void 0 === e ? void 0 : e.pswpElement;
                    i && i.classList.contains(wp) && this.quickViewPopup.loadPhotoswipe.popup.close()
                }
                onBlockSelect(t) {
                    this.debouncedBlockSelectCallback(t)
                }
                debouncedBlockSelect(t) {
                    var e, i;
                    const s = null === (e = this.quickViewPopup) || void 0 === e || null === (i = e.loadPhotoswipe) || void 0 === i ? void 0 : i.pswpElement;
                    s ? setTimeout((() => {
                        if (s.classList.contains(wp)) {
                            const e = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelector(`[${mp}="${t.target.getAttribute(mp)}"]`),
                                i = this.quickViewPopup.loadPhotoswipe.pswpElement.querySelectorAll(cp);
                            e.classList.add(bp), i.forEach((t => {
                                t !== e && t.classList.remove(bp)
                            }))
                        } else this.triggerClick(t.target)
                    })) : setTimeout((() => this.triggerClick(t.target)), 400)
                }
                onUnload() {
                    this.destroyQuickViewPopup(), document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize)
                }
                onDeselect() {
                    this.destroyQuickViewPopup()
                }
                constructor(t) {
                    this.container = t, this.slider = this.container.querySelector(np), this.slides = this.container.querySelectorAll(rp), this.pointers = this.container.querySelectorAll(ap), this.flkty = null, this.observer = null, this.checkSlidesSizeOnResize = () => this.checkSlidesSize(), this.pointersInit = t => this.dotPointers(t), this.pointersOver = t => this.dotPointerIn(t), this.pointersOut = t => this.dotPointerOut(t), this.debouncedBlockSelectCallback = n((t => this.debouncedBlockSelect(t)), 500), this.quickViewPopup = new Fl(this.container), this.listen()
                }
            }(this.container)
        }, onUnload() {
            op[this.id].onUnload()
        }, onBlockSelect(t) {
            op[this.id].onBlockSelect(t)
        }, onDeselect() {
            op[this.id].onDeselect()
        }
    };
    ct("look", [Ep]);
    const Sp = "[data-grid]";
    ct("mosaic", {
        onBlockSelect(t) {
            const e = t.target.closest(Sp),
                i = e.currentStyle || window.getComputedStyle(e),
                s = parseInt(i.paddingLeft),
                o = t.target.offsetLeft - s;
            e.scrollTo({
                top: 0,
                left: o,
                behavior: "smooth"
            })
        }
    }), ct("newsletter", Dd), ct("overlapping-images", Uh);
    const Lp = "[data-toggle-admin]",
        kp = "[data-toggle-newsletter]",
        Ap = "[data-form-admin]",
        qp = "[data-form-newsletter]";
    let Cp = {};
    ct("password-template", {
        onLoad() {
            Cp[this.id] = new class {
                init() {
                    this.toggleAdmin.addEventListener("click", (t => {
                        t.preventDefault(), this.showPasswordForm()
                    })), this.toggleNewsletter.addEventListener("click", (t => {
                        t.preventDefault(), this.hidePasswordForm()
                    })), "#login" == window.location.hash || this.adminErrors ? this.showPasswordForm() : this.hidePasswordForm()
                }
                showPasswordForm() {
                    un(this.adminForm), pn(this.newsletterForm), window.location.hash = "#login"
                }
                hidePasswordForm() {
                    un(this.newsletterForm), pn(this.adminForm), window.location.hash = ""
                }
                constructor(t) {
                    this.container = t.container, this.toggleAdmin = this.container.querySelector(Lp), this.toggleNewsletter = this.container.querySelector(kp), this.adminForm = this.container.querySelector(Ap), this.newsletterForm = this.container.querySelector(qp), this.adminErrors = this.adminForm.querySelector(".errors"), this.newsletterErrors = this.newsletterForm.querySelector(".errors"), this.init()
                }
            }(this)
        }
    });
    const Tp = "[data-large-promo]",
        Pp = "[data-large-promo-inner]",
        Fp = "[data-tracking-consent]",
        Ip = "[data-tracking-consent-inner]",
        xp = "[data-confirm-cookies]",
        Dp = "[data-popup-bar]",
        Hp = "[data-popup-bar-holder]",
        Mp = "[data-popup-bar-toggle]",
        Op = "[data-popup-body]",
        _p = "[data-popup-close]",
        Bp = "[data-popup-underlay]",
        $p = "[data-newsletter-form]",
        zp = "data-target-referrer",
        Rp = "data-prevent-scroll-lock",
        Vp = "has-success",
        Wp = "has-error",
        Np = "selected",
        Up = "has-block-selected",
        jp = "popup--expanded",
        Kp = "popup--visible",
        Qp = "mobile",
        Gp = "desktop",
        Xp = "popup--bar",
        Jp = "popup-bar-is-visible";
    let Yp = {},
        Zp = 0,
        tm = 0,
        em = [],
        im = class {
            always() {
                this.showPopup()
            }
            delayed(t = 10) {
                setTimeout((() => {
                    this.showPopup()
                }), 1e3 * t)
            }
            bottom() {
                document.addEventListener("theme:scroll", this.showPopupOnScrollEvent)
            }
            idle() {
                if (!(!0 === this.checkPopupTarget())) return;
                let t = 0;
                const e = ["mousemove", "mousedown", "click", "touchmove", "touchstart", "touchend", "keydown", "keypress"],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        t = setTimeout((() => {
                            t = 0, this.showPopup()
                        }), 6e4), e.forEach((t => {
                            document.addEventListener(t, o)
                        })), i.forEach((t => {
                            window.addEventListener(t, o)
                        }))
                    },
                    o = () => {
                        t && clearTimeout(t), e.forEach((t => {
                            document.removeEventListener(t, o)
                        })), i.forEach((t => {
                            window.removeEventListener(t, o)
                        })), s()
                    };
                s()
            }
            showPopup() {
                const t = {
                    id: this.popup.id,
                    body: this.popupBody
                };
                em.push(t);
                if (!0 === this.checkPopupTarget()) {
                    if (tm += 1, this.popup.classList.add(Kp), this.popup.classList.contains(Xp) && document.body.classList.add(Jp), this.a11y.trapFocus({
                            container: this.popupBody
                        }), this.popup.hasAttribute(Rp)) return !1;
                    this.scrollLock()
                }
            }
            checkPopupTarget() {
                const t = this.popup.parentNode.classList.contains(Qp),
                    e = this.popup.parentNode.classList.contains(Gp);
                return !(t && window.innerWidth >= theme.sizes.small || e && window.innerWidth < theme.sizes.small)
            }
            scrollLock() {
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                    bubbles: !0,
                    detail: this.popupBody
                }))
            }
            showPopupOnScroll() {
                window.scrollY + window.innerHeight >= document.body.clientHeight && (this.showPopup(), document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent))
            }
            onUnload() {
                document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent)
            }
            constructor(t, e) {
                if (this.popupContainer = t, this.popup = e, this.popupBody = e.querySelector(Op), this.delay = t.dataset.popupDelay, this.isSubmitted = -1 !== window.location.href.indexOf("accepts_marketing") || -1 !== window.location.href.indexOf("customer_posted=true"), this.a11y = _t, this.showPopupOnScrollEvent = () => this.showPopupOnScroll(), ("always" === this.delay || this.isSubmitted) && this.always(), this.delay && this.delay.includes("delayed") && !this.isSubmitted) {
                    const t = this.delay.includes("_") ? parseInt(this.delay.split("_")[1]) : 10;
                    this.delayed(t)
                }
                "bottom" !== this.delay || this.isSubmitted || this.bottom(), "idle" !== this.delay || this.isSubmitted || this.idle()
            }
        },
        sm = class {
            constructor(t) {
                if (this.popupContainer = t, this.locationPath = location.href, !this.popupContainer.hasAttribute(zp)) return !1; - 1 !== this.locationPath.indexOf(this.popupContainer.getAttribute(zp)) || window.Shopify.designMode || this.popupContainer.parentNode.removeChild(this.popupContainer)
            }
        };
    ct("popups", [{
        onLoad() {
            Yp[this.id] = [], window.Shopify.designMode && (tm = 0);
            const t = this.container.querySelectorAll(Tp);
            t.length && t.forEach((t => {
                Yp[this.id].push(new class {
                    init() {
                        !1 !== this.cookie.read() && !window.Shopify.designMode || (window.Shopify.designMode ? this.showPopup() : new im(this.popupContainer, this.popup), this.form && setTimeout((() => {
                            this.form.classList.contains(Vp) && (this.showPopupIfNoCookie(), tm -= 1)
                        })), this.initClosers())
                    }
                    checkPopupTarget() {
                        const t = this.popup.parentNode.classList.contains(Qp),
                            e = this.popup.parentNode.classList.contains(Gp);
                        return !(t && window.innerWidth >= theme.sizes.small || e && window.innerWidth < theme.sizes.small)
                    }
                    showPopupIfNoCookie() {
                        this.showPopup()
                    }
                    initClosers() {
                        this.close.addEventListener("click", this.closePopup.bind(this)), this.underlay.addEventListener("click", this.closePopup.bind(this)), this.popupContainer.addEventListener("keyup", (t => {
                            t.code === theme.keyboardKeys.ESCAPE && this.closePopup(t)
                        }))
                    }
                    closePopup(t) {
                        t.preventDefault(), this.hidePopup(), this.cookie.write()
                    }
                    scrollLock() {
                        this.resetScrollUnlock(), this.a11y.trapFocus({
                            container: this.popupBody
                        }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                            bubbles: !0,
                            detail: this.popupBody
                        }))
                    }
                    scrollUnlock() {
                        this.resetScrollUnlock(), Zp = setTimeout((() => {
                            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                                bubbles: !0
                            }))
                        }), 300)
                    }
                    resetScrollUnlock() {
                        Zp && clearTimeout(Zp)
                    }
                    showPopup() {
                        const t = !0 === this.checkPopupTarget(),
                            e = {
                                id: this.popupId,
                                body: this.popup
                            };
                        em.push(e), t && (tm += 1, this.popup.classList.add(Kp), this.scrollLock())
                    }
                    hidePopup() {
                        this.popup.classList.remove(Kp);
                        const t = em.findIndex((t => t.id === this.popupId));
                        if (tm -= 1, em.splice(t, 1), 1 == tm && document.body.classList.contains(Jp)) this.scrollUnlock();
                        else if (tm < 1) this.scrollUnlock(), this.a11y.removeTrapFocus();
                        else if (em.length > 0) {
                            const t = em[em.length - 1].body;
                            this.a11y.trapFocus({
                                container: t
                            })
                        }
                    }
                    onBlockSelect(t) {
                        this.popupContainer.contains(t.target) && !this.popup.classList.contains(Kp) && (this.popup.classList.add(Np), this.popupContainer.classList.add(Up), this.showPopup())
                    }
                    onBlockDeselect(t) {
                        this.popupContainer.contains(t.target) && (this.popup.classList.remove(Np), this.popupContainer.classList.remove(Up), this.hidePopup())
                    }
                    onUnload() {
                        this.scrollUnlock()
                    }
                    onDeselect() {
                        this.popup.classList.remove(Np), this.popupContainer.classList.remove(Up), this.hidePopup()
                    }
                    constructor(t) {
                        this.popupContainer = t, this.popup = this.popupContainer.querySelector(Pp), this.popupBody = this.popup.querySelector(Op), this.popupId = this.popup.id, this.close = this.popup.querySelector(_p), this.underlay = this.popup.querySelector(Bp), this.form = this.popup.querySelector($p), this.cookie = new qd(this.popupContainer.dataset.cookieName, "user_has_closed"), this.isTargeted = new sm(this.popupContainer), this.a11y = _t, this.init()
                    }
                }(t))
            }));
            const e = this.container.querySelectorAll(Dp);
            e.length && e.forEach((t => {
                Yp[this.id].push(new class {
                    init() {
                        !1 !== this.cookie.read() && !window.Shopify.designMode || (window.Shopify.designMode ? this.showPopup() : new im(this.popupContainer, this.popup), this.initPopupToggleButton(), this.initClosers(), this.form && setTimeout((() => {
                            this.form.classList.contains(Vp) && this.showPopupIfNoCookie(), this.form.classList.contains(Wp) && this.toggle.dispatchEvent(new Event("click"))
                        })))
                    }
                    checkPopupTarget() {
                        const t = this.popup.parentNode.classList.contains(Qp),
                            e = this.popup.parentNode.classList.contains(Gp);
                        return !(t && window.innerWidth >= theme.sizes.small || e && window.innerWidth < theme.sizes.small)
                    }
                    showPopupIfNoCookie() {
                        this.showPopup(), this.toggle.dispatchEvent(new Event("click"))
                    }
                    initPopupToggleButton() {
                        this.toggle.addEventListener("click", (t => {
                            t.preventDefault(), this.popup.classList.toggle(jp), this.popup.classList.contains(jp) ? this.scrollLock() : this.scrollUnlock()
                        }))
                    }
                    showPopup() {
                        const t = {
                            id: this.popupId,
                            body: this.popup
                        };
                        em.push(t), this.a11y.trapFocus({
                            container: this.popupBody
                        }), !0 === this.checkPopupTarget() && (tm += 1, document.body.classList.add(Jp), this.popup.classList.add(Kp))
                    }
                    hidePopup() {
                        this.popup.classList.remove(Kp), document.body.classList.remove(Jp);
                        const t = em.findIndex((t => t.id === this.popupId));
                        if (em.splice(t, 1), tm >= 1 && (tm -= 1), tm < 1) this.scrollUnlock(), this.a11y.removeTrapFocus();
                        else if (em.length > 0) {
                            const t = em[em.length - 1].body;
                            this.a11y.trapFocus({
                                container: t
                            })
                        }
                    }
                    initClosers() {
                        this.close.addEventListener("click", this.closePopup.bind(this)), this.underlay.addEventListener("click", (() => this.toggle.dispatchEvent(new Event("click")))), this.popupContainer.addEventListener("keyup", (t => {
                            t.code === theme.keyboardKeys.ESCAPE && (this.popup.classList.remove(jp), this.scrollUnlock())
                        }))
                    }
                    closePopup(t) {
                        t.preventDefault(), this.cookie.write(), this.hidePopup()
                    }
                    scrollLock() {
                        document.dispatchEvent(new CustomEvent("theme:scroll:lock", {
                            bubbles: !0,
                            detail: this.popupBody
                        }))
                    }
                    scrollUnlock() {
                        this.resetScrollUnlock(), Zp = setTimeout((() => {
                            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", {
                                bubbles: !0
                            }))
                        }), 300)
                    }
                    resetScrollUnlock() {
                        Zp && clearTimeout(Zp)
                    }
                    onBlockSelect(t) {
                        this.popupContainer.contains(t.target) && !this.popup.classList.contains(Kp) && (this.showPopup(), this.popup.classList.add(jp), this.popup.classList.add(Np), this.popup.parentNode.classList.add(Up), this.resetScrollUnlock(), this.scrollLock())
                    }
                    onBlockDeselect(t) {
                        this.popupContainer.contains(t.target) && (this.popup.classList.remove(jp), this.popup.classList.remove(Np), this.popup.parentNode.classList.remove(Up), this.hidePopup())
                    }
                    onUnload() {
                        this.scrollUnlock()
                    }
                    onDeselect() {
                        this.popup.classList.remove(jp), this.popup.classList.remove(Np), this.popup.parentNode.classList.remove(Up), this.hidePopup()
                    }
                    constructor(t) {
                        this.popupContainer = t, this.popup = this.popupContainer.querySelector(Hp), this.popupBody = this.popup.querySelector(Op), this.popupId = this.popup.id, this.close = this.popup.querySelector(_p), this.underlay = this.popup.querySelector(Bp), this.toggle = this.popup.querySelector(Mp), this.cookie = new qd(this.popupContainer.dataset.cookieName, "user_has_closed"), this.form = this.popup.querySelector($p), this.isTargeted = new sm(this.popupContainer), this.a11y = _t, this.init()
                    }
                }(t))
            }));
            const i = this.container.querySelectorAll(Fp);
            i.length && i.forEach((t => {
                Yp[this.id].push(new class {
                    init() {
                        this.enableTracking && this.showPopup(), this.clickEvents()
                    }
                    clickEvents() {
                        this.close.addEventListener("click", (t => {
                            t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!1, (() => this.hidePopup()))
                        })), this.acceptButton.addEventListener("click", (t => {
                            t.preventDefault(), window.Shopify.customerPrivacy.setTrackingConsent(!0, (() => this.hidePopup()))
                        })), document.addEventListener("trackingConsentAccepted", (() => {
                            console.log("trackingConsentAccepted event fired")
                        }))
                    }
                    showPopup() {
                        const t = {
                            id: this.popupId,
                            body: this.popup
                        };
                        em.push(t), this.popup.classList.add(Kp), this.a11y.trapFocus({
                            container: this.popup
                        })
                    }
                    hidePopup() {
                        this.popup.classList.remove(Kp);
                        const t = em.findIndex((t => t.id === this.popupId));
                        if (em.splice(t, 1), tm < 1) this.a11y.removeTrapFocus();
                        else if (em.length > 0) {
                            const t = em[em.length - 1].body;
                            this.a11y.trapFocus({
                                container: t
                            })
                        }
                    }
                    onBlockSelect(t) {
                        this.popupContainer.contains(t.target) && this.enableTracking && !this.popup.classList.contains(Kp) && (this.showPopup(), this.popup.classList.add(Np), this.popup.parentNode.classList.add(Up))
                    }
                    onBlockDeselect(t) {
                        this.popupContainer.contains(t.target) && (this.popup.classList.remove(Np), this.popupContainer.classList.remove(Up), this.hidePopup())
                    }
                    onDeselect() {
                        this.popup.classList.remove(Np), this.popupContainer.classList.remove(Up), this.hidePopup()
                    }
                    constructor(t) {
                        this.popupContainer = t, this.popup = this.popupContainer.querySelector(Ip), this.popupId = this.popup.id, this.close = this.popup.querySelector(_p), this.acceptButton = this.popup.querySelector(xp), this.enable = "true" === this.popupContainer.dataset.enable, this.a11y = _t, window.Shopify.loadFeatures([{
                            name: "consent-tracking-api",
                            version: "0.1"
                        }], (t => {
                            if (t) throw t;
                            const e = window.Shopify.customerPrivacy.userCanBeTracked(),
                                i = window.Shopify.customerPrivacy.getTrackingConsent();
                            this.enableTracking = !e && "no_interaction" === i && this.enable, window.Shopify.designMode && (this.enableTracking = !0), this.init()
                        }))
                    }
                }(t))
            }))
        }, onDeselect() {
            Yp[this.id].forEach((t => {
                "function" == typeof t.onDeselect && t.onDeselect()
            }))
        }, onBlockSelect(t) {
            Yp[this.id].forEach((e => {
                "function" == typeof e.onBlockSelect && e.onBlockSelect(t)
            }))
        }, onBlockDeselect(t) {
            Yp[this.id].forEach((e => {
                "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t)
            }))
        }, onUnload(t) {
            Yp[this.id].forEach((e => {
                "function" == typeof e.onUnload && e.onUnload(t)
            }))
        }
    }, Dd]);
    const om = "[data-press-items]",
        nm = "[data-logo-slider]",
        rm = "[data-logo-slide]",
        am = "a, button",
        lm = "data-logo-index",
        cm = "tabindex";
    let hm = {};
    const dm = {
        onLoad() {
            hm[this.id] = new class {
                checkSlides() {
                    const t = this.container.offsetWidth,
                        i = this.container.querySelectorAll(rm),
                        s = e.data(this.sliderNav) || null;
                    null !== s && (s.options.draggable = !1, s.options.wrapAround = !1, s.options.contain = !0, this.getSlidesWidth() > t && i.length > 2 && (s.options.draggable = !0, s.options.wrapAround = !0, s.options.contain = !1), s.resize(), s.updateDraggable())
                }
                getSlidesWidth() {
                    const t = this.container.querySelectorAll(rm);
                    let e = 0;
                    return t.length && t.forEach((t => {
                        e += t.offsetWidth
                    })), e
                }
                initSlider() {
                    let t = e.data(this.slider) || null,
                        i = e.data(this.sliderNav) || null;
                    const s = parseInt(this.container.dataset.duration),
                        o = "true" === this.container.dataset.autoplay && s;
                    t = new e(this.slider, {
                        fade: !0,
                        wrapAround: !0,
                        adaptiveHeight: !0,
                        prevNextButtons: !1,
                        pageDots: !1,
                        autoPlay: o
                    }), i = new e(this.sliderNav, {
                        draggable: !1,
                        wrapAround: !1,
                        contain: !0,
                        imagesLoaded: !0,
                        lazyLoad: !0,
                        asNavFor: this.slider,
                        prevNextButtons: !1,
                        adaptiveHeight: !1,
                        pageDots: !1,
                        on: {
                            ready: () => {
                                this.container.querySelectorAll(rm).forEach((e => {
                                    e.addEventListener("keyup", (i => {
                                        if (i.code === theme.keyboardKeys.ENTER || i.code === theme.keyboardKeys.NUMPADENTER || i.code === theme.keyboardKeys.SPACE) {
                                            const i = Number(e.getAttribute(lm));
                                            t.selectCell(i)
                                        }
                                    }))
                                }))
                            }
                        }
                    }), ae(this.slider), ae(this.sliderNav), i.on("change", (e => {
                        t.selectCell(e)
                    })), t.on("change", (e => {
                        i.selectCell(e), t.cells.forEach(((t, i) => {
                            t.element.querySelectorAll(am).forEach((t => {
                                t.setAttribute(cm, i === e ? "0" : "-1")
                            }))
                        }))
                    }))
                }
                resizeSlider() {
                    const t = e.data(this.slider);
                    t && t.resize()
                }
                onBlockSelect(t) {
                    const i = e.data(this.slider) || null,
                        s = e.data(this.sliderNav) || null,
                        o = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    null !== i && (i.select(o), i.pausePlayer()), null !== s && s.select(o)
                }
                onBlockDeselect() {
                    const t = e.data(this.slider) || null;
                    "true" === this.container.dataset.autoplay && null !== t && t.playPlayer()
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.sliderResizeEvent)
                }
                constructor(t) {
                    this.container = t.container, this.slider = this.container.querySelector(om), this.sliderNav = this.container.querySelector(nm), this.sliderResizeEvent = () => this.checkSlides(), this.initSlider(), this.checkSlides(), window.addEventListener("load", this.resizeSlider.bind(this)), document.addEventListener("theme:resize:width", this.sliderResizeEvent)
                }
            }(this)
        }, onUnload(t) {
            hm[this.id].onUnload(t)
        }, onBlockSelect(t) {
            hm[this.id].onBlockSelect(t)
        }, onBlockDeselect() {
            hm[this.id].onBlockDeselect()
        }
    };
    ct("press", dm);
    const um = "[data-product-single-media-slider]",
        pm = "[data-product-info]",
        mm = "[data-header-sticky]",
        gm = "[data-header-height]",
        vm = "is-sticky",
        ym = "data-sticky-enabled";
    window.theme.variables = {
        productPageSticky: !1
    };
    const fm = {};
    const bm = {
            onLoad() {
                fm[this.id] = new class {
                    init() {
                        this.stickyEnabled && (this.stickyScrollCheck(), document.addEventListener("theme:resize", this.resizeEvent)), this.initSticky()
                    }
                    initSticky() {
                        theme.variables.productPageSticky && (this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition())), this.productInfo.addEventListener("theme:form:sticky", (t => {
                            this.removeAnimationFrame(), this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition(t)))
                        })), document.addEventListener("theme:scroll", this.scrollEvent))
                    }
                    scrollEvents(t) {
                        null !== t.detail && (this.scrollTop = t.detail.position, this.scrollDirectionDown = t.detail.down), this.requestAnimationSticky || (this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition())))
                    }
                    resizeEvents() {
                        this.stickyScrollCheck(), document.removeEventListener("theme:scroll", this.scrollEvent), this.initSticky()
                    }
                    stickyScrollCheck() {
                        const t = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) >= window.theme.sizes.large,
                            e = this.container.querySelector(pm);
                        if (e)
                            if (t) {
                                const t = this.container.querySelector(pm),
                                    i = this.container.querySelector(um);
                                if (!t || !i) return;
                                t.offsetHeight < i.offsetHeight ? (theme.variables.productPageSticky = !0, e.classList.add(vm)) : (theme.variables.productPageSticky = !1, e.classList.remove(vm))
                            } else theme.variables.productPageSticky = !1, e.classList.remove(vm)
                    }
                    calculateStickyPosition(t = null) {
                        const e = Boolean(t && t.detail),
                            i = Boolean(e && t.detail.element && "accordion" === t.detail.element),
                            s = this.productInfo.offsetHeight,
                            o = window.innerHeight - s - this.defaultTopBottomSpacings,
                            n = Math.abs(this.scrollTop - this.scrollLastPosition);
                        this.scrollDirectionDown ? this.stickyScrollTop -= n : this.stickyScrollTop += n, this.stickyFormLoad && (document.querySelector(mm) && document.querySelector(gm) ? this.stickyDefaultTop = parseInt(document.querySelector(gm).getBoundingClientRect().height) : this.stickyDefaultTop = this.defaultTopBottomSpacings, this.stickyScrollTop = this.stickyDefaultTop), this.stickyScrollTop = Math.min(Math.max(this.stickyScrollTop, o), this.stickyDefaultTop);
                        const r = this.stickyScrollTop - this.currentPoint;
                        this.currentPoint = this.stickyFormLoad ? this.stickyScrollTop : this.currentPoint + .5 * r, this.productInfo.style.setProperty("--sticky-top", `${this.currentPoint}px`), this.scrollLastPosition = this.scrollTop, this.stickyFormLoad = !1, i && this.onChangeCounter <= 10 || i && this.stickyFormLastHeight !== s || this.stickyScrollTop !== this.currentPoint && this.requestAnimationSticky ? (i && (this.onChangeCounter += 1), i && this.stickyFormLastHeight !== s && (this.onChangeCounter = 11), this.requestAnimationSticky = requestAnimationFrame((() => this.calculateStickyPosition(t)))) : this.requestAnimationSticky && this.removeAnimationFrame(), this.stickyFormLastHeight = s
                    }
                    removeAnimationFrame() {
                        this.requestAnimationSticky && (cancelAnimationFrame(this.requestAnimationSticky), this.requestAnimationSticky = null, this.onChangeCounter = 0)
                    }
                    onUnload() {
                        this.stickyEnabled && document.removeEventListener("theme:resize", this.resizeEvent), theme.variables.productPageSticky && document.removeEventListener("theme:scroll", this.scrollEvent)
                    }
                    constructor(t) {
                        this.container = t.container, this.stickyEnabled = "true" === this.container.getAttribute(ym), this.productInfo = this.container.querySelector(pm), this.stickyScrollTop = 0, this.scrollLastPosition = 0, this.stickyDefaultTop = 0, this.currentPoint = 0, this.defaultTopBottomSpacings = 30, this.scrollTop = window.scrollY, this.scrollDirectionDown = !0, this.requestAnimationSticky = null, this.stickyFormLoad = !0, this.stickyFormLastHeight = null, this.onChangeCounter = 0, this.scrollEvent = t => this.scrollEvents(t), this.resizeEvent = t => this.resizeEvents(t), this.init()
                    }
                }(this)
            }, onUnload() {
                fm[this.id].onUnload()
            }
        },
        wm = "[data-product-single-media-group]",
        Em = "[data-product-single-media-slider]",
        Sm = "[data-zoom-wrapper]",
        Lm = "pswp-zoom-gallery",
        km = "pswp-zoom-gallery--single",
        Am = "is-moving",
        qm = "data-image-width",
        Cm = "data-image-height";
    const Tm = "[data-complementary-products]",
        Pm = "[data-button-quick-view]",
        Fm = "data-url";
    let Im = class extends HTMLElement {
        connectedCallback() {
            new IntersectionObserver(((t, e) => {
                t[0].isIntersecting && (e.unobserve(this), this.hasAttribute(Fm) && "" !== this.getAttribute(Fm) && fetch(this.getAttribute(Fm)).then((t => t.text())).then((t => {
                    const e = document.createElement("div");
                    e.innerHTML = t;
                    const i = e.querySelector(Tm);
                    i && i.innerHTML.trim().length && (this.innerHTML = i.innerHTML), e.querySelector(Pm) && new Fl(this)
                })).catch((t => {
                    console.error(t)
                })))
            }).bind(this), {
                rootMargin: "0px 0px 400px 0px"
            }).observe(this)
        }
        constructor() {
            super()
        }
    };
    const xm = "[data-recipient-checkbox]",
        Dm = "[data-recipient-email]",
        Hm = "[data-recipient-name]",
        Mm = "[data-recipient-message]",
        Om = "[data-recipient-send-on]",
        _m = "[data-recipient-control]",
        Bm = "[data-recipient-offset]",
        $m = "[data-product-form]",
        zm = "[data-cart-drawer]",
        Rm = "js-quick-view-visible";
    let Vm = class extends HTMLElement {
        connectedCallback() {
            this.recipientCheckbox && (this.disableInputFields(), this.recipientCheckbox.addEventListener("change", this.onChangeEvent), document.addEventListener("theme:cart:added", this.onCartAddedEvent))
        }
        onChange(t) {
            if (!t.target.checked) return this.clearInputFields(), void this.disableInputFields();
            this.enableInputFields()
        }
        onCartAdded() {
            const t = this.closest($m).offsetTop,
                e = document.body.classList.contains(Rm);
            if (!(!0 === this.recipientCheckbox.checked)) return;
            e || window.scrollTo({
                top: t,
                left: 0,
                behavior: "smooth"
            });
            const i = t => {
                t.target === this.cartDrawer && (requestAnimationFrame((() => {
                    this.recipientCheckbox.checked = !1, this.recipientCheckbox.dispatchEvent(new Event("change"))
                })), this.cartDrawer.removeEventListener("transitionend", i))
            };
            this.cartDrawer.addEventListener("transitionend", i)
        }
        inputFields() {
            return [this.recipientEmail, this.recipientName, this.recipientMessage, this.recipientSendOn]
        }
        disableableFields() {
            return [...this.inputFields(), this.recipientOffset]
        }
        clearInputFields() {
            this.inputFields().forEach((t => t.value = ""))
        }
        enableInputFields() {
            this.disableableFields().forEach((t => t.disabled = !1))
        }
        disableInputFields() {
            this.disableableFields().forEach((t => t.disabled = !0))
        }
        disconnectedCallback() {
            this.recipientCheckbox.removeEventListener("change", this.onChangeEvent), document.removeEventListener("theme:cart:added", this.onCartAddedEvent)
        }
        constructor() {
            super(), this.recipientCheckbox = this.querySelector(xm), this.recipientControl = this.querySelector(_m), this.recipientControl.disabled = !0, this.recipientEmail = this.querySelector(Dm), this.recipientName = this.querySelector(Hm), this.recipientMessage = this.querySelector(Mm), this.recipientSendOn = this.querySelector(Om), this.recipientOffset = this.querySelector(Bm), this.recipientOffset && (this.recipientOffset.value = (new Date).getTimezoneOffset()), this.cartDrawer = document.querySelector(zm), this.onChangeEvent = t => this.onChange(t), this.onCartAddedEvent = () => this.onCartAdded()
        }
    };
    const Wm = "[data-product-single-media-slider]",
        Nm = "[data-thumbnail-id]",
        Um = "[data-product-single-media-thumbs]",
        jm = "[data-product-single-media-wrapper]",
        Km = "[data-model]",
        Qm = ".product-single__thumbnail-link",
        Gm = "[data-deferred-media]",
        Xm = "[data-deferred-media-button]",
        Jm = "[data-product-rating]",
        Ym = "#shopify-product-reviews",
        Zm = "a, button",
        tg = "[data-upsell-holder]",
        eg = "[data-upsell-slider]",
        ig = "[data-slider]",
        sg = "featured-product",
        og = "featured-product--onboarding",
        ng = "has-media-active",
        rg = "is-selected",
        ag = "media--hidden",
        lg = "no-outline",
        cg = "is-moving",
        hg = "data-media-id",
        dg = "data-section-id",
        ug = "data-thumbnail-id",
        pg = "data-tall-layout",
        mg = "loaded",
        gg = "tabindex",
        vg = {};
    const yg = {
        onLoad() {
            vg[this.id] = new class {
                productSlider() {
                    this.checkSlider(), document.addEventListener("theme:resize:width", this.checkSliderOnResize)
                }
                checkSlider() {
                    !this.tallLayout || window.innerWidth < theme.sizes.large ? this.initProductSlider() : this.destroyProductSlider()
                }
                resizeFlickityNav() {
                    null !== this.flktyNav && this.flktyNav.resize()
                }
                initProductSlider() {
                    const t = this.container.querySelector(Wm),
                        i = this.container.querySelector(Um),
                        s = this.container.querySelectorAll(jm);
                    if (s.length > 1 && (this.flkty = new e(t, {
                            wrapAround: !0,
                            pageDots: !1,
                            adaptiveHeight: !0,
                            on: {
                                ready: () => {
                                    t.setAttribute(gg, "-1"), s.forEach((t => {
                                        if (!t.classList.contains(rg)) {
                                            const e = t.querySelectorAll(Zm);
                                            e.length && e.forEach((t => {
                                                t.setAttribute(gg, "-1")
                                            }))
                                        }
                                    }))
                                },
                                dragStart: () => {
                                    t.classList.add(cg)
                                },
                                dragMove: () => {
                                    this.isFlickityDragging = !0
                                },
                                staticClick: () => {
                                    this.isFlickityDragging = !1
                                },
                                settle: e => {
                                    const i = this.flkty.selectedElement.getAttribute(hg);
                                    this.flkty.cells.forEach(((t, i) => {
                                        const s = t.element.querySelectorAll(Zm);
                                        s.length && s.forEach((t => {
                                            t.setAttribute(gg, i === e ? "0" : "-1")
                                        }))
                                    })), this.switchMedia(i), t.classList.remove(cg)
                                }
                            }
                        }), s.length && s.forEach((t => {
                            t.addEventListener("theme:media:play", (() => {
                                this.flkty.options.draggable = !1, this.flkty.updateDraggable(), t.closest(Wm).classList.add(ng)
                            })), t.addEventListener("theme:media:pause", (() => {
                                this.flkty.options.draggable = !0, this.flkty.updateDraggable(), t.closest(Wm).classList.remove(ng)
                            }))
                        })), ae(t), null !== i)) {
                        this.flktyNav = new e(i, {
                            asNavFor: t,
                            contain: !0,
                            pageDots: !1,
                            prevNextButtons: !1,
                            resize: !0,
                            on: {
                                ready: () => {
                                    i.setAttribute(gg, "-1")
                                }
                            }
                        }), null !== this.flktyNav && document.addEventListener("theme:resize:width", this.flktyNavOnResize), ae(i);
                        const s = this.container.querySelectorAll(Qm);
                        s.length && s.forEach((t => {
                            t.addEventListener("click", (t => {
                                t.preventDefault()
                            }))
                        }))
                    }
                }
                destroyProductSlider() {
                    null !== this.flkty && (this.flkty.destroy(), this.flktyNav.destroy(), this.flkty = null, this.flktyNav = null)
                }
                initUpsellSlider() {
                    const t = this.container.querySelector(eg);
                    if (this.container.querySelectorAll(tg).length > 1) {
                        const i = new e(t, {
                            wrapAround: !0,
                            pageDots: !0,
                            adaptiveHeight: !0,
                            prevNextButtons: !1
                        });
                        i.on("change", (t => {
                            i.cells.forEach(((e, i) => {
                                const s = e.element.querySelectorAll(Zm);
                                s.length && s.forEach((e => {
                                    e.setAttribute(gg, i === t ? "0" : "-1")
                                }))
                            }))
                        }))
                    }
                }
                initFeatureSlider() {
                    this.featureSliders.forEach((t => {
                        Array.from(t.children).length > 1 && (this.flktyFeature = new e(t, {
                            wrapAround: !0,
                            pageDots: !0,
                            adaptiveHeight: !0,
                            prevNextButtons: !1
                        }))
                    }))
                }
                handleMediaFocus(t) {
                    if (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.TAB) return;
                    const i = t.currentTarget.getAttribute(ug),
                        s = this.container.querySelector(`[${hg}="${i}"]`),
                        o = parseInt([...s.parentNode.children].indexOf(s)),
                        n = this.container.querySelector(Wm),
                        r = this.container.querySelector(Um),
                        a = e.data(n) || null,
                        l = e.data(r) || null;
                    a && a.isActive && o > -1 && (t.code === theme.keyboardKeys.ENTER || t.code === theme.keyboardKeys.NUMPADENTER) && a.select(o), l && l.isActive && o > -1 && l.select(o)
                }
                switchMedia(t) {
                    const e = document.querySelectorAll(`${jm}`),
                        i = this.container.querySelector(`${jm}[${hg}="${t}"]`),
                        s = !document.body.classList.contains(lg);
                    e.length && e.forEach((t => {
                        t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                            bubbles: !0
                        }), t.classList.add(ag)
                    })), s && i.focus(), i.closest(Wm).classList.remove(ng), i.classList.remove(ag), i.dispatchEvent(new CustomEvent("theme:media:visible"), {
                        bubbles: !0
                    });
                    const o = i.querySelector(Gm);
                    o && "true" !== o.getAttribute(mg) && i.querySelector(Xm).dispatchEvent(new Event("click"))
                }
                initMediaSwitch() {
                    const t = this.container.querySelectorAll(Nm);
                    t.length && t.forEach((t => {
                        t.addEventListener("keyup", this.handleMediaFocus.bind(this)), t.addEventListener("click", (t => {
                            t.preventDefault()
                        }))
                    }))
                }
                initProductVideo() {
                    this.videos = new Ee(this.container)
                }
                initProductModel() {
                    const t = this.container.querySelectorAll(Km);
                    t.length && t.forEach((t => {
                        theme.ProductModel.init(t, this.sectionId)
                    }))
                }
                initShopifyXrLaunch() {
                    document.addEventListener("shopify_xr_launch", (() => {
                        this.container.querySelector(`${Km}:not(.${ag})`).dispatchEvent(new CustomEvent("xrLaunch"))
                    }))
                }
                onUnload() {
                    null !== this.flktyNav && document.removeEventListener("theme:resize:width", this.flktyNavOnResize), document.removeEventListener("theme:resize:width", this.checkSliderOnResize)
                }
                scrollToReviews() {
                    const t = this.container.querySelector(Jm);
                    t && ["click", "keydown"].forEach((e => {
                        t.addEventListener(e, (t => {
                            if (t.code !== theme.keyboardKeys.ENTER && t.code !== theme.keyboardKeys.NUMPADENTER || "click" != t.type) {
                                const t = document.querySelector(Ym);
                                if (!t) return;
                                t.scrollIntoView({
                                    behavior: "smooth"
                                })
                            }
                        }))
                    }))
                }
                onBlockSelect(t) {
                    const i = e.data(t.target.closest(ig)),
                        s = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    i && i.select(s)
                }
                constructor(t) {
                    this.container = t.container, this.sectionId = this.container.getAttribute(dg), this.tallLayout = "true" === this.container.getAttribute(pg), this.featureSliders = this.container.querySelectorAll(ig), this.flkty = null, this.flktyNav = null, this.isFlickityDragging = !1, this.enableHistoryState = !this.container.classList.contains(sg), this.checkSliderOnResize = () => this.checkSlider(), this.flktyNavOnResize = () => this.resizeFlickityNav(), this.scrollToReviews(), this.initUpsellSlider(), this.initFeatureSlider(), new Fl(this.container), this.container.classList.contains(og) || (new class {
                        init() {
                            this.zoomWrappers.length && this.zoomWrappers.forEach(((t, e) => {
                                t.addEventListener("click", (i => {
                                    i.preventDefault(), this.slider && this.slider.classList.contains(Am) || (this.a11y.state.trigger = t, this.createZoom(e))
                                }))
                            }))
                        }
                        createZoom(t) {
                            const e = this;
                            let i = [],
                                s = 0;
                            this.zoomWrappers.forEach((o => {
                                const n = o.getAttribute("href"),
                                    r = parseInt(o.getAttribute(qm)),
                                    a = parseInt(o.getAttribute(Cm));
                                if (i.push({
                                        src: n,
                                        w: r,
                                        h: a,
                                        msrc: n
                                    }), s += 1, e.zoomWrappers.length === s) {
                                    let e = `${Lm}`;
                                    1 === s && (e = `${Lm} ${km}`), new dl(i, {
                                        barsSize: {
                                            top: 60,
                                            bottom: 60
                                        },
                                        history: !1,
                                        focus: !1,
                                        index: t,
                                        mainClass: e,
                                        showHideOpacity: !0,
                                        showAnimationDuration: 250,
                                        hideAnimationDuration: 250,
                                        closeOnScroll: !1,
                                        closeOnVerticalDrag: !1,
                                        captionEl: !1,
                                        closeEl: !0,
                                        closeElClasses: ["caption-close"],
                                        tapToClose: !1,
                                        clickToCloseNonZoomable: !1,
                                        maxSpreadZoom: 2,
                                        loop: !0,
                                        spacing: 0,
                                        allowPanToNext: !0,
                                        pinchToClose: !1
                                    })
                                }
                            }))
                        }
                        constructor(t) {
                            this.container = t, this.mediaContainer = this.container.querySelector(wm), this.slider = this.container.querySelector(Em), this.zoomWrappers = this.container.querySelectorAll(Sm), this.zoomEnable = "true" === this.mediaContainer.dataset.gallery, this.a11y = _t, this.zoomEnable && this.init()
                        }
                    }(this.container), this.productSlider(), this.initMediaSwitch(), this.initProductVideo(), this.initProductModel(), this.initShopifyXrLaunch())
                }
            }(this)
        }, onUnload: function() {
            vg[this.id].onUnload()
        }, onBlockSelect(t) {
            vg[this.id].onBlockSelect(t)
        }
    };
    ct("product-template", [Mr, yg, Yi, Zi, Vh, Tt, Re, oa, dn, bm]), ct("featured-product", [Mr, yg, Yi, Zi, Vh, Tt, Re, oa, dn, bm]), customElements.get("complementary-products") || customElements.define("complementary-products", Im), customElements.get("recipient-form") || customElements.define("recipient-form", Vm);
    const fg = "is-disabled",
        bg = "data-circle-text-parallax";
    const wg = "href",
        Eg = "data-media-id",
        Sg = "data-deferred-media-loaded",
        Lg = "[data-product-content-wrapper]",
        kg = "[data-product-single-media-wrapper]",
        Ag = "[data-model]",
        qg = "[data-product-link]",
        Cg = "[data-product-single-media-image]",
        Tg = "[data-slider-contents]",
        Pg = "[data-slider-images]",
        Fg = "[data-tab-button]",
        Ig = "[data-tab-item]",
        xg = "[data-circle-text]",
        Dg = {
            aosAnimate: "aos-animate",
            tabButtonActive: "products-list__nav__button--active",
            tabItemActive: "products-list__item--active",
            mediaHidden: "media--hidden",
            isDisabled: "is-disabled"
        },
        Hg = {};
    ct("products-list", {
        onLoad() {
            Hg[this.id] = new class {
                listen() {
                    (this.slidersImages.length > 0 || this.slidersContents.length > 0) && document.addEventListener("theme:resize", this.sliderResizeEvent)
                }
                resizeSlider() {
                    this.flktyImages.length > 0 && requestAnimationFrame((() => {
                        this.flktyImages.forEach((t => t.resize()))
                    })), this.flktyContent.length > 0 && requestAnimationFrame((() => {
                        this.flktyContent.forEach((t => t.resize()))
                    }))
                }
                initButtons() {
                    this.tabButtons.length && this.tabButtons.forEach((t => {
                        t.addEventListener("click", (e => {
                            if (t.classList.contains(Dg.tabButtonActive)) return;
                            const i = t.getAttribute(wg),
                                s = this.container.querySelector(i),
                                o = s.querySelector(kg),
                                n = o ? o.dataset.mediaId : null,
                                r = s.querySelector(xg);
                            this.tabButtons.forEach((t => {
                                t.classList.remove(Dg.tabButtonActive)
                            })), this.tabItems.forEach((t => {
                                const e = t.querySelector(xg);
                                t.classList.remove(Dg.tabItemActive), null == e || e.classList.add(Dg.isDisabled), theme.settings.animations && t.querySelectorAll(`.${Dg.aosAnimate}`).forEach((t => {
                                    t.classList.remove(Dg.aosAnimate), setTimeout((() => {
                                        t.classList.add(Dg.aosAnimate)
                                    }))
                                }))
                            })), t.classList.add(Dg.tabButtonActive), s.classList.add(Dg.tabItemActive), document.dispatchEvent(new Event("theme:resize")), r && (r.classList.remove(Dg.isDisabled), document.dispatchEvent(new Event("theme:scroll"))), this.handleProductVideos(s, n), e.preventDefault()
                        }))
                    }))
                }
                initSliders() {
                    this.slidersImages.forEach(((t, i) => {
                        const s = t.closest(Ig).querySelector(Tg),
                            o = new e(t, {
                                fade: !0,
                                pageDots: !1,
                                prevNextButtons: !0,
                                wrapAround: !0,
                                adaptiveHeight: !0,
                                asNavFor: s,
                                on: {
                                    change: t => {
                                        this.flktyContent.length > 0 && this.flktyContent[i].select(t)
                                    }
                                }
                            });
                        o.on("settle", (e => {
                            const i = t.querySelectorAll(kg);
                            for (let t = 0; t < i.length; t++) t === e ? i[t].querySelector(Cg).removeAttribute("tabindex") : i[t].querySelector(Cg).setAttribute("tabindex", "-1")
                        })), this.flktyImages.push(o)
                    })), this.slidersContents.forEach((t => {
                        const i = new e(t, {
                            fade: !0,
                            pageDots: !1,
                            prevNextButtons: !1,
                            wrapAround: !0,
                            adaptiveHeight: !0
                        });
                        i.on("settle", (e => {
                            const i = t.querySelectorAll(Lg);
                            for (let t = 0; t < i.length; t++) t === e ? i[t].querySelectorAll(qg).forEach((t => {
                                t.removeAttribute("tabindex")
                            })) : i[t].querySelectorAll(qg).forEach((t => {
                                t.setAttribute("tabindex", "-1")
                            }))
                        })), this.flktyContent.push(i)
                    }))
                }
                initProductVideos() {
                    this.tabItems.forEach((t => {
                        t.classList.contains(Dg.tabItemActive) && this.handleProductVideos(t)
                    }))
                }
                loadVideos(t, e = null) {
                    new IntersectionObserver(((i, s) => {
                        i.forEach((i => {
                            if (i.isIntersecting) {
                                const o = new Ee(t);
                                this.videos.push(o), t.setAttribute(Sg, ""), this.playToggle(e), s.unobserve(i.target)
                            }
                        }))
                    }), {
                        root: null,
                        rootMargin: "300px",
                        threshold: [0, .1, .25, .5, .75, 1]
                    }).observe(t)
                }
                handleProductVideos(t, e = null) {
                    t.hasAttribute(Sg) ? this.playToggle(e) : this.loadVideos(t, e)
                }
                playToggle(t) {
                    this.videos.forEach((e => {
                        "function" == typeof e.pauseContainerMedia && t && (e.pauseContainerMedia(t, this.container), this.switchMedia(t)), t || 0 !== Object.keys(e.players).length || this.pauseContainerMedia(this.container)
                    }))
                }
                switchMedia(t) {
                    const e = this.container.querySelector(`${kg}[${Eg}="${t}"]`);
                    !document.body.classList.contains(Dg.noOutline) && e.focus(), e.classList.remove(Dg.mediaHidden), e.dispatchEvent(new CustomEvent("theme:media:visible"), {
                        bubbles: !0
                    })
                }
                pauseContainerMedia(t) {
                    const e = t.querySelectorAll(kg);
                    0 !== e.length && e.forEach((t => {
                        t.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                            bubbles: !0
                        }), t.classList.add(Dg.mediaHidden)
                    }))
                }
                initProductModel() {
                    const t = this.container.querySelectorAll(Ag);
                    t.length && t.forEach((t => {
                        theme.ProductModel.init(t, this.sectionId)
                    }))
                }
                initShopifyXrLaunch() {
                    document.addEventListener("shopify_xr_launch", (() => {
                        this.container.querySelector(`${Ag}:not(.${Dg.mediaHidden})`).dispatchEvent(new CustomEvent("xrLaunch"))
                    }))
                }
                initCircleText() {
                    this.container.querySelectorAll(xg).forEach((t => {
                        new class {
                            init() {
                                this.circleText.hasAttribute(bg) && document.addEventListener("theme:scroll", this.scrollEvent)
                            }
                            updateParallax() {
                                if (this.circleText.classList.contains(fg)) return;
                                const t = Math.round(window.innerHeight),
                                    e = Math.round(window.scrollY),
                                    i = e + t,
                                    s = Math.round(this.circleText.getBoundingClientRect().top + e),
                                    o = this.circleText.offsetHeight;
                                if (s < i && !(s + o < e)) {
                                    const e = 100 * (i - s - o / 2) / t;
                                    let n = this.rotateDegree * e / 100 * -1;
                                    e > 0 && (this.circleText.style.transform = `rotate(${this.adjustRotateDegree+n}deg)`)
                                }
                            }
                            unload() {
                                document.removeEventListener("theme:scroll", this.scrollEvent)
                            }
                            constructor(t) {
                                this.circleText = t, this.rotateDegree = 70, this.adjustRotateDegree = this.rotateDegree / 2, this.scrollEvent = () => this.updateParallax(), this.init()
                            }
                        }(t)
                    }))
                }
                onBlockSelect(t) {
                    t.target.dispatchEvent(new Event("click"))
                }
                onUnload() {
                    (this.slidersImages.length > 0 || this.slidersContents.length > 0) && document.removeEventListener("theme:resize", this.sliderResizeEvent)
                }
                constructor(t) {
                    this.container = t.container, this.sectionId = this.container.dataset.sectionId, this.tabButtons = this.container.querySelectorAll(Fg), this.tabItems = this.container.querySelectorAll(Ig), this.slidersImages = this.container.querySelectorAll(Pg), this.slidersContents = this.container.querySelectorAll(Tg), this.videos = [], this.flktyImages = [], this.flktyContent = [], this.sliderResizeEvent = () => this.resizeSlider(), this.initButtons(), this.initSliders(), this.initProductVideos(), this.initProductModel(), this.initShopifyXrLaunch(), this.initCircleText(), this.listen()
                }
            }(this)
        }, onUnload() {
            Hg[this.id].onUnload()
        }, onBlockSelect(t) {
            Hg[this.id].onBlockSelect(t)
        }
    });
    const Mg = "[data-product-block]",
        Og = "[data-related-products]",
        _g = "data-section-id",
        Bg = "data-product-id",
        $g = "data-limit",
        zg = {};
    ct("related-products", {
        onLoad() {
            zg[this.id] = new class {
                init() {
                    const t = this.container.getAttribute(_g),
                        e = this.container.getAttribute(Bg),
                        i = this.container.getAttribute($g),
                        s = `${theme.routes.product_recommendations_url}?section_id=${t}&limit=${i}&product_id=${e}`;
                    fetch(s).then((t => t.text())).then((t => {
                        const e = document.createElement("div");
                        e.innerHTML = t;
                        const i = e.querySelector(Og);
                        i.querySelectorAll(Mg).length && (this.relatedProducts.innerHTML = i.innerHTML, this.productGrid = new ds(this.container), this.gridSlider = new nu(this.container))
                    }))
                }
                onDeselect() {
                    this.productGrid && this.productGrid.onDeselect()
                }
                onUnload() {
                    this.productGrid && this.productGrid.onUnload(), this.gridSlider && this.gridSlider.onUnload()
                }
                constructor(t) {
                    this.container = t, this.relatedProducts = this.container.querySelector(Og), this.init()
                }
            }(this.container)
        }, onDeselect() {
            zg[this.id].onDeselect()
        }, onUnload() {
            zg[this.id].onUnload()
        }
    });
    const Rg = {},
        Vg = "[data-slider]",
        Wg = "[data-item]",
        Ng = "[data-button-show]",
        Ug = "[data-button-hide]",
        jg = "[data-item-products]",
        Kg = "[data-item-products-slider]",
        Qg = "[data-item-product]",
        Gg = "a, button",
        Xg = "blog-item--active",
        Jg = "blog-item__products--visible",
        Yg = "flickity-enabled",
        Zg = "is-selected",
        tv = {
            slider: "data-slider",
            slidePosition: "data-slide-position",
            sectionId: "data-section-id",
            tabIndex: "tabindex"
        };
    const ev = {
        onLoad() {
            Rg[this.id] = new class {
                initSlider() {
                    this.flkty = new e(this.slider, {
                        prevNextButtons: !0,
                        pageDots: !1,
                        cellAlign: "left",
                        wrapAround: !1,
                        groupCells: !0,
                        contain: !0,
                        on: {
                            ready: () => {
                                this.handleFocus()
                            }
                        }
                    }), this.flkty.on("change", (() => {
                        const t = this.container.querySelectorAll(Wg);
                        this.handleFocus(), t.length && t.forEach((t => {
                            const e = t.querySelector(jg);
                            t.classList.remove(Xg), e && t.querySelector(jg).classList.remove(Jg)
                        })), this.flkty && !this.flkty.options.draggable && (this.flkty.options.draggable = !0, this.flkty.updateDraggable())
                    }))
                }
                destroySlider() {
                    null !== this.flkty && (this.flkty.destroy(), this.flkty = null)
                }
                checkSlidesSize() {
                    const t = this.container.querySelector(Wg).currentStyle || window.getComputedStyle(this.container.querySelector(Wg));
                    this.gutter = parseInt(t.marginRight);
                    const e = this.slider.offsetWidth + this.gutter < this.getItemsWidth();
                    window.innerWidth >= theme.sizes.small && e ? this.initSlider() : this.destroySlider()
                }
                getItemsWidth() {
                    let t = 0;
                    const e = this.slider.querySelectorAll(Wg);
                    return e.length && e.forEach((e => {
                        t += e.offsetWidth + this.gutter
                    })), t
                }
                bindButtons() {
                    const t = this.container.querySelectorAll(Kg),
                        i = this.container.querySelectorAll(Ng),
                        s = this.container.querySelectorAll(Ug);
                    i.length && i.forEach((t => {
                        t.addEventListener("click", (e => {
                            e.preventDefault(), this.container.querySelectorAll(Wg).forEach((t => {
                                const e = t.querySelector(jg);
                                t.classList.remove(Xg), e && (e.classList.remove(Jg), this.changeTabIndex(e))
                            }));
                            const i = t.closest(Wg),
                                s = i.querySelector(jg);
                            if (i.classList.add(Xg), s) {
                                s.classList.add(Jg), this.changeTabIndex(s, "enable");
                                const t = s.querySelector(Kg),
                                    e = t.querySelectorAll(Qg);
                                if (t.classList.contains(Yg)) {
                                    const i = t.querySelector(`.${Zg}`).getAttribute(tv.slidePosition);
                                    e.forEach(((t, e) => {
                                        t.setAttribute(tv.tabIndex, e === i ? "0" : "-1")
                                    }))
                                }
                            }
                            null !== this.flkty && (this.flkty.options.draggable = !1, this.flkty.updateDraggable()), this.a11y.state.trigger = t
                        }))
                    })), s.length && s.forEach((t => {
                        t.addEventListener("click", (e => {
                            e.preventDefault();
                            const i = t.closest(Wg),
                                s = i.querySelector(jg);
                            i.classList.remove(Xg), s && (s.classList.remove(Jg), this.changeTabIndex(s)), null !== this.flkty && (this.flkty.options.draggable = !0, this.flkty.updateDraggable()), this.a11y.state.trigger.focus()
                        }))
                    })), t.length && t.forEach((t => {
                        if (t.querySelectorAll(Qg).length > 1) {
                            const i = new e(t, {
                                prevNextButtons: !0,
                                contain: !0,
                                pageDots: !1,
                                wrapAround: !0,
                                on: {
                                    change: t => {
                                        i.cells.forEach(((e, i) => {
                                            e.element.querySelectorAll(Gg).forEach((e => {
                                                e.setAttribute(tv.tabIndex, i === t ? "0" : "-1")
                                            }))
                                        }))
                                    }
                                }
                            })
                        }
                    })), this.slider.addEventListener("keyup", (t => {
                        if (t.code === theme.keyboardKeys.ESCAPE) {
                            const e = t.target.hasAttribute(tv.slider) ? t.target.querySelectorAll(Wg) : t.target.closest(Vg).querySelectorAll(Wg);
                            e.length && (e.forEach((t => {
                                const e = t.querySelector(jg);
                                t.classList.remove(Xg), e && (e.classList.remove(Jg), this.changeTabIndex(e))
                            })), this.flkty && (this.flkty.options.draggable = !0, this.flkty.updateDraggable())), this.a11y.state.trigger.focus()
                        }
                    }))
                }
                handleFocus() {
                    const t = this.container.querySelectorAll(Wg);
                    t.length && t.forEach((t => {
                        const e = t.classList.contains(Zg),
                            i = t.querySelector(jg);
                        e ? (this.changeTabIndex(t, "enable"), i && this.changeTabIndex(i)) : (this.changeTabIndex(t), i && i.classList.remove(Jg))
                    }))
                }
                listen() {
                    this.slider && (this.checkSlidesSize(), document.addEventListener("theme:resize:width", this.checkSlidesSizeOnResize)), document.addEventListener("mousedown", this.clickOutsideItemEvent)
                }
                changeTabIndex(t, e = "") {
                    const i = "enable" === e ? "0" : "-1";
                    t.querySelectorAll(Gg).forEach((t => {
                        t.setAttribute(tv.tabIndex, i)
                    }))
                }
                onBlockSelect(t) {
                    if (null !== this.flkty) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s)
                    } else {
                        const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                            i = parseInt(e.paddingLeft),
                            s = t.target.offsetLeft - i;
                        this.slider.scrollTo({
                            top: 0,
                            left: s,
                            behavior: "smooth"
                        })
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.checkSlidesSizeOnResize), document.removeEventListener("mousedown", this.clickOutsideItemEvent)
                }
                constructor(t) {
                    this.container = t.container, this.flkty = null, this.slider = this.container.querySelector(Vg), this.checkSlidesSizeOnResize = () => this.checkSlidesSize(), this.isFullWidth = this.container.hasAttribute(tv.fullWidth), this.gutter = 0, this.a11y = _t, this.clickOutsideItemEvent = t => {
                        if (!t.target.matches(Wg) && !t.target.closest(Wg)) {
                            const t = this.container.querySelectorAll(Wg);
                            t.length && t.forEach((t => {
                                const e = t.querySelector(jg);
                                e && (e.classList.remove(Jg), this.changeTabIndex(e)), t.classList.remove(Xg)
                            }))
                        }
                    }, this.bindButtons(), this.listen()
                }
            }(this)
        }, onUnload(t) {
            Rg[this.id].onUnload(t)
        }, onBlockSelect(t) {
            Rg[this.id].onBlockSelect(t)
        }
    };
    ct("shoppable-blog", ev);
    const iv = "[data-scroll-down]",
        sv = "[data-site-header]",
        ov = "[data-slide]",
        nv = "a, button",
        rv = "[data-slider]",
        av = "data-style",
        lv = "data-current-style",
        cv = "tabindex",
        hv = "data-slide-position",
        dv = "site-header--fixed",
        uv = {};
    ct("slider", [{
        onLoad() {
            uv[this.id] = new class {
                initSlider() {
                    const t = this.container.querySelectorAll(ov).length,
                        i = parseInt(this.container.dataset.duration),
                        s = "true" === this.container.dataset.pageDots && t > 1,
                        o = "true" === this.container.dataset.navArrows && t > 1;
                    let n = "true" === this.container.dataset.autoplay;
                    if (n && (n = i), t > 1) this.flkty = new e(this.container, {
                        fade: !0,
                        cellSelector: ov,
                        autoPlay: n,
                        wrapAround: !0,
                        adaptiveHeight: !0,
                        setGallerySize: !0,
                        imagesLoaded: !0,
                        pageDots: s,
                        prevNextButtons: o,
                        on: {
                            ready: () => {
                                const t = this.container.querySelector(`${ov}[${hv}="1"]`).getAttribute(av);
                                this.container.setAttribute(lv, t), requestAnimationFrame(this.resizeEvent), document.addEventListener("theme:vars", this.resizeEvent)
                            },
                            change: t => {
                                const e = this.flkty.selectedElement.getAttribute(av);
                                this.container.setAttribute(lv, e), this.flkty.cells.forEach(((e, i) => {
                                    e.element.querySelectorAll(nv).forEach((e => {
                                        e.setAttribute(cv, i === t ? "0" : "-1")
                                    }))
                                }))
                            }
                        }
                    }), ae(this.container);
                    else if (1 === t) {
                        const t = this.container.querySelector(ov).getAttribute(av);
                        this.container.setAttribute(lv, t)
                    }
                }
                bindScrollButton() {
                    const t = this.container.querySelector(iv);
                    t && t.addEventListener("click", (t => {
                        t.preventDefault();
                        const e = this.header.classList.contains(dv) ? 60 : 0,
                            i = parseInt(Math.ceil(this.container.offsetTop + this.container.offsetHeight - e));
                        window.scrollTo({
                            top: i,
                            left: 0,
                            behavior: "smooth"
                        })
                    }))
                }
                onBlockSelect(t) {
                    const e = parseInt([...t.target.parentNode.children].indexOf(t.target));
                    null !== this.flkty && (this.flkty.select(e), this.flkty.pausePlayer())
                }
                onBlockDeselect(t) {
                    "true" === t.target.closest(rv).dataset.autoplay && null !== this.flkty && this.flkty.playPlayer()
                }
                onReorder() {
                    null !== this.flkty && this.flkty.resize()
                }
                onUnload() {
                    null !== this.flkty && (document.removeEventListener("theme:vars", this.resizeEvent), this.flkty.destroy(), this.flkty = null)
                }
                constructor(t) {
                    this.container = t.container, this.header = document.querySelector(sv), this.flkty = null, this.resizeEvent = () => {
                        this.flkty.resize()
                    }, this.initSlider(), this.bindScrollButton()
                }
            }(this)
        }, onReorder(t) {
            uv[this.id].onReorder(t)
        }, onUnload(t) {
            uv[this.id].onUnload(t)
        }, onBlockSelect(t) {
            uv[this.id].onBlockSelect(t)
        }, onBlockDeselect(t) {
            uv[this.id].onBlockDeselect(t)
        }
    }, Uh, Gh]), ct("subcollections", ru), ct("tab-collections", [us, ru, Jo]);
    const pv = {},
        mv = "[data-slider]",
        gv = "[data-item]",
        vv = "flickity-enabled",
        yv = "data-section-id";
    ct("testimonials", {
        onLoad() {
            pv[this.id] = new class {
                initSlider() {
                    const t = this.slider.querySelectorAll(gv).length;
                    let i = this.slider.classList.contains(vv);
                    2 == t && window.innerWidth >= theme.sizes.small || 1 == t || window.innerWidth < theme.sizes.small ? i && this.flkty.destroy() : (this.flkty = new e(this.slider, {
                        cellSelector: gv,
                        prevNextButtons: !0,
                        pageDots: !1,
                        groupCells: !0,
                        cellAlign: "left",
                        contain: !0,
                        adaptiveHeight: !1
                    }), this.flkty.resize(), this.flkty.slideableWidth > this.flkty.size.width || this.flkty.destroy())
                }
                onBlockSelect(t) {
                    if (null !== this.flkty) {
                        const e = parseInt([...t.target.parentNode.children].indexOf(t.target)),
                            i = parseInt(this.flkty.slides[0].cells.length),
                            s = Math.floor(e / i);
                        this.flkty.select(s)
                    } else {
                        const e = this.slider.currentStyle || window.getComputedStyle(this.slider),
                            i = parseInt(e.paddingLeft),
                            s = t.target.offsetLeft - i;
                        this.slider.scrollTo({
                            top: 0,
                            left: s,
                            behavior: "smooth"
                        })
                    }
                }
                onUnload() {
                    document.removeEventListener("theme:resize:width", this.sliderResizeEvent)
                }
                constructor(t) {
                    this.container = t.container, this.sectionId = this.container.getAttribute(yv), this.slider = this.container.querySelector(mv), this.sliderResizeEvent = () => this.initSlider(), this.flkty = null, this.initSlider(), document.addEventListener("theme:resize:width", this.sliderResizeEvent)
                }
            }(this)
        }, onUnload(t) {
            pv[this.id].onUnload(t)
        }, onBlockSelect(t) {
            pv[this.id].onBlockSelect(t)
        }
    });
    const fv = "no-outline",
        bv = "[data-skip-content]",
        wv = 'a[href="#"]';
    document.documentElement.style.setProperty("--scrollbar-width", `${(()=>{const t=document.createElement("div");t.style.visibility="hidden",t.style.overflow="scroll",t.style.msOverflowStyle="scrollbar",document.body.appendChild(t);const e=document.createElement("div");t.appendChild(e);const i=t.offsetWidth-e.offsetWidth;return t.parentNode.removeChild(t),i})()}px`), document.addEventListener("DOMContentLoaded", (function() {
        ht("*");
        "true" === document.body.dataset.animations && o.init({
            once: !0,
            offset: 50,
            duration: 600,
            startEvent: "load"
        }), new class {
            init() {
                this.body = document.body, this.inPageLink = document.querySelector(bv), this.linkesWithOnlyHash = document.querySelectorAll(wv), this.isFocused = !1, this.focusHash(), this.bindInPageLinks(), this.clickEvents(), this.focusEvents(), this.focusEventsOff()
            }
            clickEvents() {
                this.inPageLink && this.inPageLink.addEventListener("click", (t => {
                    t.preventDefault()
                })), this.linkesWithOnlyHash && this.linkesWithOnlyHash.forEach((t => {
                    t.addEventListener("click", (t => {
                        t.preventDefault()
                    }))
                }))
            }
            focusEvents() {
                document.addEventListener("keyup", (t => {
                    t.code === theme.keyboardKeys.TAB && (this.body.classList.remove(fv), this.isFocused = !0)
                }))
            }
            focusEventsOff() {
                document.addEventListener("mousedown", (() => {
                    this.body.classList.add(fv), this.isFocused = !1
                }))
            }
            forceFocus(t, e) {
                e = e || {};
                var i = t.tabIndex;
                t.tabIndex = -1, t.dataset.tabIndex = i, t.focus(), void 0 !== e.className && t.classList.add(e.className), t.addEventListener("blur", (function s(o) {
                    o.target.removeEventListener(o.type, s), t.tabIndex = i, delete t.dataset.tabIndex, void 0 !== e.className && t.classList.remove(e.className)
                }))
            }
            focusHash(t) {
                t = t || {};
                let e = window.location.hash;
                void 0 !== theme.settings.newHash && (e = theme.settings.newHash, window.location.hash = `#${e}`);
                const i = document.getElementById(e.slice(1));
                if (i && t.ignore && i.matches(t.ignore)) return !1;
                e && i && this.forceFocus(i, t)
            }
            bindInPageLinks(t) {
                return t = t || {}, Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((e => {
                    if ("#" === e.hash || "" === e.hash) return !1;
                    if (t.ignore && e.matches(t.ignore)) return !1;
                    if (i = e.hash.substr(1), null === document.getElementById(i)) return !1;
                    var i, s = document.querySelector(e.hash);
                    return !!s && (e.addEventListener("click", (() => {
                        this.forceFocus(s, t)
                    })), !0)
                }))
            }
            constructor() {
                this.init()
            }
        }, !customElements.get("product-grid-item-swatch") && window.theme.settings.enableColorSwatchesCollection && customElements.define("product-grid-item-swatch", Gi);
        "scrollBehavior" in document.documentElement.style || $t({
            url: theme.assets.smoothscroll
        })
    }))
}(themeVendor.ScrollLock, themeVendor.Flickity, themeVendor.themeCurrency, themeVendor.ajaxinate, themeVendor.AOS);

 $(document).ready(function(){
    var $div1 = $('.product__submit__holder');
    var div1Top = $div1.offset().top;

   if ($('.scroll-bar-addcar').is(':visible')) {
        $div1.addClass('fixeds');
    }
                   else{
                      $div1.removeClass('fixeds');
                   }
   
    $(window).on('scroll', function() {
      if ($(window).scrollTop() >= div1Top) {
        
        $div1.addClass('fixeds');
        $('.scroll-bar-addcart').show()
      } else {
        $div1.removeClass('fixeds');
        $('.scroll-bar-addcart').hide()
        
      }
    });

  });
